import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type AccessControlCreateDto = {
  active: Scalars['Boolean']['input'];
  modules: Array<ModuleInput>;
  name: Scalars['String']['input'];
};

export type AccessControlDeleteDto = {
  _id: Scalars['String']['input'];
};

export type AccessControlListDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AccessControlListSort>;
};

export type AccessControlListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type AccessControlModel = {
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  modules: Array<Module>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AccessControlUpdateDto = {
  _id: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  modules?: InputMaybe<Array<ModuleInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AccountWalletBalanceModel = {
  balanceCents: Scalars['Float']['output'];
  balanceWithPendingsCents: Scalars['Float']['output'];
  creditValueCentsToday: Scalars['Float']['output'];
  currentDate: Scalars['String']['output'];
  debitValueCentsToday: Scalars['Float']['output'];
};

export type ActionDto = {
  internalName: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
};

export type AddNoteGraphqlDto = {
  fileKey?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type AddressDto = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  neighborhood: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type AddressGraphqlDto = {
  city: Scalars['String']['input'];
  complement?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  neighborhood: Scalars['String']['input'];
  number: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type AddressGraphqlModel = {
  city: Scalars['String']['output'];
  complement?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  neighborhood: Scalars['String']['output'];
  number: Scalars['String']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  zipcode: Scalars['String']['output'];
};

export type AffiliatePartnerDeleteUserModel = {
  success: Scalars['Boolean']['output'];
};

export type AffiliatePartnerUserAccessControl = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AffiliatePartnerUserApprovedUpdateInput = {
  accessStatus?: InputMaybe<EAffiliatePartnerUserAccessStatus>;
  /** e-mail do preposto */
  email?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliatePartnerUserCreateInput = {
  address: AddressGraphqlDto;
  captureSource: Scalars['String']['input'];
  cpf: Scalars['String']['input'];
  /** e-mail do preposto */
  email: Scalars['String']['input'];
  facebook?: InputMaybe<Scalars['String']['input']>;
  files: Array<AffiliatePartnerUserFileInput>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** nome do preposto */
  name: Scalars['String']['input'];
  /** telefone do preposto */
  phone: Scalars['String']['input'];
  professionalHistory?: InputMaybe<Array<AffiliatePartnerUserProfessionalReferenceInput>>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliatePartnerUserFileInput = {
  fileKey: Scalars['String']['input'];
  type: EAffiliatePartnerUserFileType;
};

export type AffiliatePartnerUserFileModel = {
  file: FileUploadModel;
  type: EAffiliatePartnerUserFileType;
};

export type AffiliatePartnerUserFilterArgs = {
  inAccessStatus?: InputMaybe<Array<EAffiliatePartnerUserAccessStatus>>;
  inStatus?: InputMaybe<Array<EAffiliatePartnerUserStatus>>;
  nameOrUsernameOrEmail?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
};

export type AffiliatePartnerUserHistoryModel = {
  author: EAffiliatePartnerUserHistoryAuthor;
  date: Scalars['DateTime']['output'];
  event: EAffiliatePartnerUserHistoryEvent;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type AffiliatePartnerUserListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type AffiliatePartnerUserLoggedUserOutput = {
  /** Generated accessToken of the user */
  accessToken: Scalars['String']['output'];
};

/** metadados de paginação */
export type AffiliatePartnerUserMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** preposto do parceiro */
export type AffiliatePartnerUserModel = {
  _id: Scalars['ID']['output'];
  accessControlRef: AffiliatePartnerUserAccessControl;
  accessStatus: EAffiliatePartnerUserAccessStatus;
  address?: Maybe<AddressGraphqlModel>;
  captureSource?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  facebook?: Maybe<Scalars['String']['output']>;
  files: Array<AffiliatePartnerUserFileModel>;
  history: Array<AffiliatePartnerUserHistoryModel>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner: Scalars['Boolean']['output'];
  partnerRef?: Maybe<AffiliatePartnerUserPartnerRef>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  professionalHistory: Array<AffiliatePartnerUserProfessionalReferenceModel>;
  site?: Maybe<Scalars['String']['output']>;
  status: EAffiliatePartnerUserStatus;
  type?: Maybe<EUserType>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type AffiliatePartnerUserPaginateArgs = {
  filter?: InputMaybe<AffiliatePartnerUserFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<AffiliatePartnerUserListSort>;
};

export type AffiliatePartnerUserPartnerRef = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type AffiliatePartnerUserProfessionalReferenceInput = {
  companyName: Scalars['String']['input'];
  observation: Scalars['String']['input'];
  role: Scalars['String']['input'];
  segment: Scalars['String']['input'];
};

export type AffiliatePartnerUserProfessionalReferenceModel = {
  companyName?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
};

export type AffiliatePartnerUserRecoverPasswordChangeInput = {
  newPassword: Scalars['String']['input'];
  retypeNewPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AffiliatePartnerUserRecoverPasswordInput = {
  email: Scalars['String']['input'];
};

/** AffiliatePartnerUserRecoverPassword */
export type AffiliatePartnerUserRecoverPasswordModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  partnerUserRef: AffiliatePartnerUserRefModel;
  status: EAffiliatePartnerUserPasswordRecoverStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AffiliatePartnerUserRefModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type AffiliatePartnerUserUpdateInput = {
  address?: InputMaybe<AddressGraphqlDto>;
  captureSource?: InputMaybe<Scalars['String']['input']>;
  cpf?: InputMaybe<Scalars['String']['input']>;
  /** e-mail do preposto */
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<AffiliatePartnerUserFileInput>>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  /** nome do preposto */
  name?: InputMaybe<Scalars['String']['input']>;
  /** telefone do preposto */
  phone?: InputMaybe<Scalars['String']['input']>;
  professionalHistory?: InputMaybe<Array<AffiliatePartnerUserProfessionalReferenceInput>>;
  site?: InputMaybe<Scalars['String']['input']>;
};

/** paginação de prepostos */
export type AffiliatePartnerUsersPaginateModel = {
  data: Array<AffiliatePartnerUserModel>;
  meta: AffiliatePartnerUserMetaModel;
};

export type AnalyseLegalRepresentativeDataDto = {
  document: Scalars['String']['input'];
  pendencies: ProposalLegalRepresentativesPendencies;
  proposalId: Scalars['String']['input'];
};

export type AnalyseRegistrationDataDto = {
  pendencies: ProposalCustomerPendencies;
  proposalId: Scalars['String']['input'];
};

export type AnticipatedCommissionResponseDto = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
};

export type AnticipatedCommissioningParamsDto = {
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionExceptionGroups: Array<CommissionExceptionGroupCreateDto>;
  commissionedInvoices: Scalars['Float']['input'];
};

export type AnticipatedCommissioningUpdateParamsDto = {
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionExceptionGroups: Array<CommissionExceptionGroupUpdateDto>;
  commissionedInvoices: Scalars['Float']['input'];
};

export type AuthAffiliatePartnerUserArgs = {
  /** password of the user */
  password: Scalars['String']['input'];
  /** username of the user */
  username: Scalars['String']['input'];
};

export type AuthCustomerUserArgs = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
  /** expo push token */
  expoPushToken?: InputMaybe<Scalars['String']['input']>;
  isPushNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** operating system */
  os?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  /** password */
  password: Scalars['String']['input'];
  /** username */
  username: Scalars['String']['input'];
};

export type AuthUserArgs = {
  /** password of the user */
  password: Scalars['String']['input'];
  /** username of the user */
  username: Scalars['String']['input'];
};

export type BankGraphqlDto = {
  account: Scalars['String']['input'];
  agency: Scalars['String']['input'];
  code: Scalars['String']['input'];
  type: EBankAccountType;
};

export type BankGraphqlModel = {
  account: Scalars['String']['output'];
  agency: Scalars['String']['output'];
  code: Scalars['String']['output'];
  type: EBankAccountType;
};

export type BankOperationResModel = {
  document: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  pix?: Maybe<DigitalAccountPixResModel>;
  type: Scalars['String']['output'];
};

export type BusinessProposalFileModel = {
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  storageService?: Maybe<EStorageService>;
};

export type BusinessProposalModel = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  businessProposalDespertaNumber?: Maybe<Scalars['Float']['output']>;
  businessProposalPartnerNumber?: Maybe<Scalars['Float']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  contractOfAdhesion?: Maybe<BusinessProposalFileModel>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<BusinessProposalFileModel>;
  invoiceValueWithPartner?: Maybe<Scalars['Float']['output']>;
  linkFileToSign: Scalars['String']['output'];
  monthlyEconomyPercent: Scalars['Float']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  powerGeneratorId: Scalars['String']['output'];
  powerPlantId?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<Scalars['String']['output']>;
  status: EBusinessProposalStatus;
  tariffGreenFlag: Scalars['Float']['output'];
  tariffPurpleFlag: Scalars['Float']['output'];
  tariffRedFlagP1: Scalars['Float']['output'];
  tariffRedFlagP2: Scalars['Float']['output'];
  tariffYellowFlag: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CalculateCommissionParamsDto = {
  customerDiscountOffered: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
  personType: EPersonType;
};

export type CalculateCommissionResponseDto = {
  anticipated?: Maybe<AnticipatedCommissionResponseDto>;
  customerDiscountOffered: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  personType: EPersonType;
  recurring?: Maybe<RecurringCommissionResponseDto>;
};

export type CancelContractDtoGraphql = {
  contractId: Scalars['String']['input'];
  lossReason: EContractLossReason;
  reason: Scalars['String']['input'];
};

export type CancelProposalGraphqlDto = {
  lossReason: ELossReason;
  proposalId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionAnticipatedConditionModel = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
  commissionExceptionGroupId: Scalars['String']['output'];
  commissionedInvoices: Scalars['Float']['output'];
};

export type CommissionCalculationBaseModel = {
  /** Taxa de disponibilidade aplicada em kWh */
  availabilityFeeKwh: Scalars['Float']['output'];
  /** Consumo médio do contrato em kWh */
  averageConsumptionKwh: Scalars['Float']['output'];
  /** kWh faturáveis (consumo - taxa de disponibilidade) */
  billableKwh: Scalars['Float']['output'];
  /** Base de cálculo da comissão em centavos */
  calculationBaseValueCents: Scalars['Float']['output'];
  /** Motivo da escolha do consumo usado no cálculo */
  consumptionChoiceReason: Scalars['String']['output'];
  /** Consumo utilizado no cálculo (médio ou total) em kWh */
  consumptionUsedKwh: Scalars['Float']['output'];
  /** Percentual de desvio entre consumo médio e total */
  deviationPercentage: Scalars['Float']['output'];
  /** Tarifa TE + TUSD Desperta em R$/kWh */
  teAndTusdDespertaPerKwh: Scalars['Float']['output'];
  /** Tensão do contrato (monofasico, bifasico, trifasico) */
  tension: EConsumerUnitTension;
  /** Consumo total da fatura em kWh */
  totalConsumptionKwh: Scalars['Float']['output'];
  /** Se foi usado consumo total (true) ou médio (false) */
  usedTotalConsumption: Scalars['Boolean']['output'];
};

export type CommissionCondition = CommissionAnticipatedConditionModel | CommissionRecurringConditionModel;

export type CommissionExceptionGroupCreateDto = {
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionedInvoices: Scalars['Float']['input'];
  dealerships: Array<Scalars['String']['input']>;
};

export type CommissionExceptionGroupSchema = {
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionedInvoices: Scalars['Float']['output'];
  dealerships: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type CommissionExceptionGroupUpdateDto = {
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionedInvoices: Scalars['Float']['input'];
  dealerships: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type CommissionFilterArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  nameCustomerOrSalesman?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  salesmanId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ECommissionStatusFilter>>;
};

export type CommissionFilterMetricsArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  nameCustomerOrSalesman?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  salesmanId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<ECommissionStatus>>;
};

export type CommissionListMetricsSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CommissionListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type CommissionMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type CommissionMetadataModel = {
  /** Detalhes do cálculo da base de comissão */
  calculationBase?: Maybe<CommissionCalculationBaseModel>;
  contractId: Scalars['String']['output'];
  invoiceId: Scalars['String']['output'];
  invoiceValueCents: Scalars['Float']['output'];
  proposalId: Scalars['String']['output'];
};

export type CommissionMetricsArgs = {
  filter?: InputMaybe<CommissionFilterMetricsArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CommissionListMetricsSort>;
};

export type CommissionMetricsDto = {
  expectedRevenueCents: Scalars['Float']['output'];
  receivableRevenueCents: Scalars['Float']['output'];
};

export type CommissionModel = {
  _id: Scalars['ID']['output'];
  commissioningType: ECommissioningType;
  condition?: Maybe<CommissionCondition>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate: Scalars['DateTime']['output'];
  indicationRef: IndicationRefModel;
  metadata: CommissionMetadataModel;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  status: ECommissionStatus;
  updatedAt: Scalars['DateTime']['output'];
  valueCents: Scalars['Float']['output'];
};

export type CommissionPaginateArgs = {
  filter?: InputMaybe<CommissionFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CommissionListSort>;
};

/** Commissions pagination */
export type CommissionPaginateModel = {
  data: Array<CommissionModel>;
  meta: CommissionMetaModel;
};

export type CommissionRecurringConditionModel = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  alwaysCommissionedInvoices: Scalars['Boolean']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
  commissionedInvoices?: Maybe<Scalars['Float']['output']>;
};

export type ConsortiumCreateDtoGraphql = {
  address: AddressGraphqlDto;
  bank?: InputMaybe<BankGraphqlDto>;
  cnpj: Scalars['String']['input'];
  documents?: InputMaybe<Array<ConsortiumDigitalAccountDocumentCreateDto>>;
  email: Scalars['String']['input'];
  fantasyName: Scalars['String']['input'];
  leaderEmail: Scalars['String']['input'];
  leaderName: Scalars['String']['input'];
  legalRepresentative?: InputMaybe<ConsortiumLegalRepresentativeDtoGraphql>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  status: EConsortiumStatus;
};

export type ConsortiumDigitalAccountDocumentCreateDto = {
  file: ConsortiumDigitalAccountDocumentFileCreateDto;
  type: EDigitalAccountDocumentType;
};

export type ConsortiumDigitalAccountDocumentFileCreateDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  storageService: EStorageService;
};

/** Digital Account Document File */
export type ConsortiumDigitalAccountDocumentFileModel = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  storageService: EStorageService;
};

/** Digital account document */
export type ConsortiumDigitalAccountDocumentModel = {
  file: ConsortiumDigitalAccountDocumentFileModel;
  type: EDigitalAccountDocumentType;
};

export type ConsortiumDigitalAccountLegalRepresentativeModel = {
  document?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** paginate metadata */
export type ConsortiumDigitalAccountModel = {
  accountOwner?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  documents: Array<ConsortiumDigitalAccountDocumentModel>;
  email?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legalRepresentative?: Maybe<ConsortiumDigitalAccountLegalRepresentativeModel>;
  name: Scalars['String']['output'];
  pendencies: ConsortiumDigitalAccountPendenciesModel;
  phone?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Digital account pendencies */
export type ConsortiumDigitalAccountPendenciesModel = {
  account: ConsortiumDigitalAccountPendencyModel;
  address: ConsortiumDigitalAccountPendencyModel;
  addressProof: ConsortiumDigitalAccountPendencyModel;
  agency: ConsortiumDigitalAccountPendencyModel;
  balance_sheet: ConsortiumDigitalAccountPendencyModel;
  identificationBack: ConsortiumDigitalAccountPendencyModel;
  identificationFront: ConsortiumDigitalAccountPendencyModel;
  selfie: ConsortiumDigitalAccountPendencyModel;
  social_contract: ConsortiumDigitalAccountPendencyModel;
};

/** Digital account pendency */
export type ConsortiumDigitalAccountPendencyModel = {
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  inAnalysisAt?: Maybe<Scalars['DateTime']['output']>;
  pendenciedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ConsortiumLegalRepresentativeDtoGraphql = {
  document: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** paginate metadata */
export type ConsortiumLegalRepresentativeModel = {
  document: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ConsortiumListDtoGraphql = {
  nameOrFantasyNameOrDocument?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ConsortiumListSort>;
};

export type ConsortiumListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type ConsortiumMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** consortiums */
export type ConsortiumModel = {
  _id: Scalars['ID']['output'];
  address: AddressGraphqlModel;
  bank?: Maybe<BankGraphqlModel>;
  cnpj: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digitalAccount?: Maybe<ConsortiumDigitalAccountModel>;
  email: Scalars['String']['output'];
  fantasyName: Scalars['String']['output'];
  leaderEmail: Scalars['String']['output'];
  leaderName: Scalars['String']['output'];
  legalRepresentative?: Maybe<ConsortiumLegalRepresentativeModel>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EConsortiumStatus>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Consortiums pagination */
export type ConsortiumPaginateModel = {
  data: Array<ConsortiumModel>;
  meta: ConsortiumMetaModel;
};

export type ConsortiumUpdateDtoGraphql = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<ConsortiumDigitalAccountDocumentCreateDto>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fantasyName?: InputMaybe<Scalars['String']['input']>;
  leaderEmail?: InputMaybe<Scalars['String']['input']>;
  leaderName?: InputMaybe<Scalars['String']['input']>;
  legalRepresentative?: InputMaybe<ConsortiumLegalRepresentativeDtoGraphql>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EConsortiumStatus>;
};

export type ContactPersonCreateDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ContactPersonSchema = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type ContactPersonUpdateDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

/** Erro de ativação contrato e massa */
export type ContractActivateBulkErrorModel = {
  error: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Ativação de contratos em massa */
export type ContractActivateBulkModel = {
  activated: Array<Scalars['String']['output']>;
  notActivated: Array<ContractActivateBulkErrorModel>;
};

export type ContractAddEnergyBillInfoGraphqlDto = {
  AmountCents?: InputMaybe<Scalars['Float']['input']>;
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  avarageBillAmountCents?: InputMaybe<Scalars['Float']['input']>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<ContractFileCreateDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractAnalysisFilesDto = {
  approve: Scalars['Boolean']['input'];
  legalRepresentativeDocument?: InputMaybe<Scalars['String']['input']>;
  types: Array<EProposalFileType>;
};

export type ContractAnalyzeLegalRepresentativeDataDto = {
  contractId: Scalars['String']['input'];
  document: Scalars['String']['input'];
  pendencies: ContractLegalRepresentativesPendencies;
};

export type ContractAnalyzeRegistrationDataDto = {
  contractId: Scalars['String']['input'];
  pendencies: ContractCustomerPendencies;
};

export type ContractChangeBenefitDto = {
  contractId: Scalars['String']['input'];
  rewardType: ERewardType;
};

export type ContractChangePowerPlantDto = {
  consortiumId: Scalars['String']['input'];
  contractId: Scalars['String']['input'];
  powerGeneratorId: Scalars['String']['input'];
  powerPlantId: Scalars['String']['input'];
};

export type ContractChangeSingleAccountDto = {
  contractId: Scalars['String']['input'];
  type: ESingleAccountType;
};

export type ContractCreateDtoGraphql = {
  billingType?: InputMaybe<EBillingType>;
  consortiumId?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Array<Scalars['String']['input']>>;
  contractedSharePercent?: InputMaybe<Scalars['Float']['input']>;
  customerId: Scalars['String']['input'];
  customerIndicationRef?: InputMaybe<ContractCustomerIndicationDto>;
  dealershipLogin?: InputMaybe<DealershipLoginCreateDto>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  eligibleForCashback?: InputMaybe<Scalars['Boolean']['input']>;
  energyBillInfo?: InputMaybe<ContractCreateEnergyBillInfoGraphqlDto>;
  fidelityMonths?: InputMaybe<Scalars['Float']['input']>;
  generatorId?: InputMaybe<Scalars['String']['input']>;
  gracePeriodMonths?: InputMaybe<Scalars['Float']['input']>;
  hasOwnGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  indicationRef?: InputMaybe<IndicationRefInputModel>;
  isPortabilityCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  origin?: InputMaybe<EContractOrigin>;
  ownGenerationAverageKwh?: InputMaybe<Scalars['Float']['input']>;
  participationKwh?: InputMaybe<Scalars['Float']['input']>;
  powerPlantId?: InputMaybe<Scalars['String']['input']>;
  previousGenerationBalance?: InputMaybe<Scalars['Float']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardCreateDto>;
  specialDiscount?: InputMaybe<Array<SpecialDiscountCreateDto>>;
  termOfManagement?: InputMaybe<Array<TermOfManagementCreateGraphqlDto>>;
  type: EContractType;
  validityMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractCreateEnergyBillInfoGraphqlDto = {
  AmountCents?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<AddressGraphqlDto>;
  avarageBillAmountCents?: InputMaybe<Scalars['Float']['input']>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<ContractFileCreateDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractCustomerIndicationDto = {
  customerId: Scalars['String']['input'];
  customerName: Scalars['String']['input'];
};

export type ContractCustomerPendencies = {
  city?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['Boolean']['input']>;
  uf?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractCustomerRefLegalRepresentativeModel = {
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  files?: Maybe<Array<DocumentationAnalysisFileModel>>;
  name: Scalars['String']['output'];
  pendencies?: Maybe<ContractCustomerRefLegalRepresentativePendenciesModel>;
  phone: Scalars['String']['output'];
};

export type ContractCustomerRefLegalRepresentativePendenciesModel = {
  city: ContractPendencyFieldModel;
  complement: ContractPendencyFieldModel;
  customerPjRepresentativeDocumentWithPhotoBack: ContractPendencyFieldModel;
  customerPjRepresentativeDocumentWithPhotoFront: ContractPendencyFieldModel;
  document: ContractPendencyFieldModel;
  email: ContractPendencyFieldModel;
  name: ContractPendencyFieldModel;
  neighborhood: ContractPendencyFieldModel;
  number: ContractPendencyFieldModel;
  phone: ContractPendencyFieldModel;
  state: ContractPendencyFieldModel;
  zipCode: ContractPendencyFieldModel;
};

export type ContractCustomerRefModel = {
  document: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  legalRepresentatives?: Maybe<Array<ContractCustomerRefLegalRepresentativeModel>>;
  name: Scalars['String']['output'];
  pendencies?: Maybe<ContractCustomerRefPendenciesModel>;
  personType: EPersonType;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ContractCustomerRefPendenciesModel = {
  city: ContractPendencyFieldModel;
  email: ContractPendencyFieldModel;
  name: ContractPendencyFieldModel;
  neighborhood: ContractPendencyFieldModel;
  number: ContractPendencyFieldModel;
  phone: ContractPendencyFieldModel;
  state: ContractPendencyFieldModel;
  street: ContractPendencyFieldModel;
  uf: ContractPendencyFieldModel;
  zipCode: ContractPendencyFieldModel;
};

export type ContractEnergyBillInfo = {
  AmountCents?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<AddressGraphqlModel>;
  avarageBillAmountCents?: Maybe<Scalars['Float']['output']>;
  avarageConsumption?: Maybe<Scalars['Float']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  consumerClassification?: Maybe<EConsumerUnitClassification>;
  dealershipId?: Maybe<Scalars['String']['output']>;
  dealershipName?: Maybe<Scalars['String']['output']>;
  distributionTaxes?: Maybe<Scalars['Float']['output']>;
  energyBillFile?: Maybe<ContractFileModel>;
  energyTaxes?: Maybe<Scalars['Float']['output']>;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  installationNumber?: Maybe<Scalars['String']['output']>;
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceDueDay?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  tariffClassification?: Maybe<ETariffClassification>;
  tension?: Maybe<EConsumerUnitTension>;
  tusdValue?: Maybe<Scalars['Float']['output']>;
};

export type ContractFileCreateDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  storageService: EStorageService;
};

export type ContractFileModel = {
  fileName?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  storageService?: Maybe<EStorageService>;
};

export type ContractInvoiceChangeDueDateDto = {
  contractId: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  isInterestAndFineWaived?: InputMaybe<Scalars['Boolean']['input']>;
  newDueDate: Scalars['DateTime']['input'];
};

export type ContractInvoiceSimulateDueDateChangeDto = {
  invoiceId: Scalars['String']['input'];
  isInterestAndFineWaived?: InputMaybe<Scalars['Boolean']['input']>;
  newDueDate: Scalars['DateTime']['input'];
};

export type ContractLegalRepresentativesPendencies = {
  city?: InputMaybe<Scalars['Boolean']['input']>;
  complement?: InputMaybe<Scalars['Boolean']['input']>;
  customerPjRepresentativeDocumentWithPhotoBack?: InputMaybe<Scalars['Boolean']['input']>;
  customerPjRepresentativeDocumentWithPhotoFront?: InputMaybe<Scalars['Boolean']['input']>;
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractListDtoGraphql = {
  canCreateInvoices?: InputMaybe<Scalars['Boolean']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<DateRangeGraphqlSchema>;
  inOrigin?: InputMaybe<Array<EContractOrigin>>;
  inPendencies?: InputMaybe<Array<EContractFilterListPendencies>>;
  inPendenciesStatus?: InputMaybe<Array<EPendenciesStatus>>;
  inStatus?: InputMaybe<Array<EContractStatus>>;
  isFormalizedByPartner?: InputMaybe<Scalars['Boolean']['input']>;
  nameOrDocument?: InputMaybe<Scalars['String']['input']>;
  oldInstallationNumber?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ContractListSort>;
  type?: InputMaybe<EContractType>;
  ucOrClientNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ContractListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type ContractMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** Contracts */
export type ContractModel = {
  _id: Scalars['ID']['output'];
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedBy?: Maybe<Scalars['String']['output']>;
  billingType?: Maybe<EBillingType>;
  canCreateInvoices?: Maybe<Scalars['Boolean']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  canceledReason?: Maybe<Scalars['String']['output']>;
  cancellationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  cancellationRequestedBy?: Maybe<Scalars['String']['output']>;
  consortiumId?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Array<Scalars['String']['output']>>;
  contractedSharePercent?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['String']['output'];
  customerIndicationRef?: Maybe<CustomerIndicationReferenceModel>;
  customerRef: ContractCustomerRefModel;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<Scalars['String']['output']>;
  dealershipLogin?: Maybe<DealershipLoginModel>;
  eligibleForCashback: Scalars['Boolean']['output'];
  energyBillInfo?: Maybe<ContractEnergyBillInfo>;
  fidelityMonths?: Maybe<Scalars['Float']['output']>;
  files?: Maybe<Array<DocumentationAnalysisFileModel>>;
  gracePeriodMonths?: Maybe<Scalars['Float']['output']>;
  hasOwnGeneration: Scalars['Boolean']['output'];
  hasRequestedCustomerBankData?: Maybe<Scalars['Boolean']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  inDeactivationAt?: Maybe<Scalars['DateTime']['output']>;
  inDeactivationBy?: Maybe<Scalars['String']['output']>;
  indicationRef?: Maybe<IndicationRefModel>;
  isDocumentsAudited: Scalars['Boolean']['output'];
  isFormalizedByPartner: Scalars['Boolean']['output'];
  isPortabilityCustomer: Scalars['Boolean']['output'];
  lossReason?: Maybe<EContractLossReason>;
  monthlyConsumption?: Maybe<ContractMonthlyConsumption>;
  notes?: Maybe<Array<ObservationModel>>;
  origin?: Maybe<EContractOrigin>;
  ownGenerationAverageKwh?: Maybe<Scalars['Float']['output']>;
  participationKwh?: Maybe<Scalars['Float']['output']>;
  powerGeneratorId?: Maybe<Scalars['String']['output']>;
  powerPlantId?: Maybe<Scalars['String']['output']>;
  previousGenerationBalance?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<RewardModel>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signDate?: Maybe<Scalars['DateTime']['output']>;
  singleAccount?: Maybe<ContractSingleAccountModel>;
  specialDiscount?: Maybe<Array<SpecialDiscountModel>>;
  status?: Maybe<EContractStatus>;
  termOfAdhesion?: Maybe<Array<ContractTermOfAdhesionModel>>;
  termOfManagement?: Maybe<Array<ContractTermOfManagementModel>>;
  type?: Maybe<EContractType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validityMonths?: Maybe<Scalars['Float']['output']>;
};

export type ContractMonthlyConsumption = {
  april?: Maybe<Scalars['Int']['output']>;
  august?: Maybe<Scalars['Int']['output']>;
  december?: Maybe<Scalars['Int']['output']>;
  february?: Maybe<Scalars['Int']['output']>;
  january?: Maybe<Scalars['Int']['output']>;
  july?: Maybe<Scalars['Int']['output']>;
  june?: Maybe<Scalars['Int']['output']>;
  march?: Maybe<Scalars['Int']['output']>;
  may?: Maybe<Scalars['Int']['output']>;
  november?: Maybe<Scalars['Int']['output']>;
  october?: Maybe<Scalars['Int']['output']>;
  september?: Maybe<Scalars['Int']['output']>;
};

export type ContractNotifyPartnerFinishedDocumentationGraphqlDto = {
  contractId: Scalars['String']['input'];
};

/** Contracts pagination */
export type ContractPaginateModel = {
  data: Array<ContractModel>;
  meta: ContractMetaModel;
};

export type ContractPendencyFieldModel = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  analyzedBy?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
};

/** single account */
export type ContractSingleAccountCustomerAreaModel = {
  active: Scalars['Boolean']['output'];
  adhesionAt?: Maybe<Scalars['String']['output']>;
  adhesionBy?: Maybe<EAdhesionBySingleAccount>;
  adhesionResponsibility?: Maybe<Scalars['String']['output']>;
  history: Array<SingleAccountHitoryCustomerAreaModel>;
};

/** single account */
export type ContractSingleAccountModel = {
  active: Scalars['Boolean']['output'];
  adhesionAt?: Maybe<Scalars['DateTime']['output']>;
  adhesionBy?: Maybe<EAdhesionBySingleAccount>;
  adhesionResponsibility?: Maybe<Scalars['String']['output']>;
  history: Array<SingleAccountHitoryModel>;
};

export type ContractSolveCustomerPendenciesGraphqlDto = {
  contractId: Scalars['String']['input'];
  pendencies: Array<Scalars['String']['input']>;
};

export type ContractSolveLegalRepresentantPendenciesGraphqlDto = {
  contractId: Scalars['String']['input'];
  document: Scalars['String']['input'];
  pendencies: Array<Scalars['String']['input']>;
};

export type ContractSpecialDiscount = {
  discountPercent: Scalars['Float']['input'];
  month: Scalars['Float']['input'];
};

export type ContractTermOfAdhesionModel = {
  active: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  file?: Maybe<ContractFileModel>;
  replaced: Scalars['Boolean']['output'];
  signatureLink?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  signerEmail: Scalars['String']['output'];
  status: ETermStatus;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ContractTermOfManagementModel = {
  active: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  documentSignId: Scalars['String']['output'];
  file?: Maybe<ContractFileModel>;
  origin?: Maybe<Scalars['String']['output']>;
  refusedReason?: Maybe<Scalars['String']['output']>;
  replaced: Scalars['Boolean']['output'];
  signatureLink?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  signerEmail?: Maybe<Scalars['String']['output']>;
  status: ETermStatus;
  type?: Maybe<ETermOfManagementType>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type ContractUpdateCommercialCondition = {
  billingType?: InputMaybe<EBillingType>;
  contractId: Scalars['String']['input'];
  contractedSharePercent?: InputMaybe<Scalars['Float']['input']>;
  defaultDiscount?: InputMaybe<Scalars['Float']['input']>;
  fidelityMonths?: InputMaybe<Scalars['Float']['input']>;
  gracePeriodMonths?: InputMaybe<Scalars['Float']['input']>;
  participationKwh?: InputMaybe<Scalars['Float']['input']>;
  specialDiscount?: InputMaybe<Array<ContractSpecialDiscount>>;
  validityMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractUpdateDtoGraphql = {
  _id: Scalars['String']['input'];
  billingType?: InputMaybe<EBillingType>;
  consortiumId?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Array<Scalars['String']['input']>>;
  contractedSharePercent?: InputMaybe<Scalars['Float']['input']>;
  dealershipLogin?: InputMaybe<DealershipLoginUpdateDto>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  eligibleForCashback?: InputMaybe<Scalars['Boolean']['input']>;
  fidelityMonths?: InputMaybe<Scalars['Int']['input']>;
  gracePeriodMonths?: InputMaybe<Scalars['Float']['input']>;
  hasOwnGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  isPortabilityCustomer?: InputMaybe<Scalars['Boolean']['input']>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  ownGenerationAverageKwh?: InputMaybe<Scalars['Int']['input']>;
  participationKwh?: InputMaybe<Scalars['Float']['input']>;
  powerGeneratorId?: InputMaybe<Scalars['String']['input']>;
  powerPlantId?: InputMaybe<Scalars['String']['input']>;
  previousGenerationBalance?: InputMaybe<Scalars['Float']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  reward?: InputMaybe<RewardUpdateDto>;
  specialDiscount?: InputMaybe<Array<SpecialDiscountUpdateDto>>;
  status?: InputMaybe<EContractStatus>;
  type?: InputMaybe<EContractType>;
  validityMonths?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractUpdateDealershipLogin = {
  extraPassword: Scalars['String']['input'];
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ContractUpdateEnergyBillInfo = {
  AmountCents?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<AddressGraphqlDto>;
  avarageBillAmountCents?: InputMaybe<Scalars['Float']['input']>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  contractId: Scalars['String']['input'];
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipLogin?: InputMaybe<ContractUpdateDealershipLogin>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<FileUploadInputTypeDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previousGenerationBalance?: InputMaybe<Scalars['Float']['input']>;
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ContractUpdateManuallyTermManagement = {
  contractId: Scalars['String']['input'];
  file: FilesUploadInputGraphqlDto;
};

export type ContractUpdateManuallyTermManagementApproveDto = {
  approve: Scalars['Boolean']['input'];
  contractId: Scalars['String']['input'];
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type CreateDiscountDto = {
  code: Scalars['String']['input'];
  /** Informar valor entre 0 e 100 % */
  discountPercentage?: Scalars['Float']['input'];
  type: EDiscountTableType;
};

export type CreateIndicationPartnerDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  averageEnergyBillValueCents: Scalars['Float']['input'];
  customerDiscountOffered?: InputMaybe<Scalars['Float']['input']>;
  dealershipId: Scalars['String']['input'];
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  personType: EPersonType;
  phone: Scalars['String']['input'];
  uf: Scalars['String']['input'];
};

export type CreateProposalPdfGraphql = {
  template: Scalars['String']['input'];
  variables: CreateProposalPdfVariablesGraphql;
};

export type CreateProposalPdfVariablesGraphql = {
  propoasalInstallationNumber: Scalars['String']['input'];
  proposalAmountWithDesperta: Scalars['String']['input'];
  proposalAmountWithoutDesperta: Scalars['String']['input'];
  proposalAverageMonthSavingValue: Scalars['String']['input'];
  proposalAverageYearSavingValue: Scalars['String']['input'];
  proposalConsumeAverageKwh: Scalars['String']['input'];
  proposalCustomerDocument: Scalars['String']['input'];
  proposalCustomerLegalRepresentativeName: Scalars['String']['input'];
  proposalCustomerName: Scalars['String']['input'];
  proposalDate: Scalars['String']['input'];
  proposalDiscountMonthPerFlagGreenPercentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagGreenValue: Scalars['String']['input'];
  proposalDiscountMonthPerFlagPurplePercentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagPurpleValue: Scalars['String']['input'];
  proposalDiscountMonthPerFlagRedP1Percentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagRedP1Value: Scalars['String']['input'];
  proposalDiscountMonthPerFlagRedP2Percentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagRedP2Value: Scalars['String']['input'];
  proposalDiscountMonthPerFlagYellowPercentage: Scalars['String']['input'];
  proposalDiscountMonthPerFlagYellowValue: Scalars['String']['input'];
  proposalDiscountPercentage: Scalars['String']['input'];
  proposalDueDate: Scalars['String']['input'];
  proposalNumber: Scalars['String']['input'];
};

export type CreateSimulationPdfGraphql = {
  template: Scalars['String']['input'];
  variables: CreateSimulationPdfVariablesGraphql;
};

export type CreateSimulationPdfVariablesGraphql = {
  applyDiscount?: InputMaybe<Scalars['Float']['input']>;
  baseURL?: InputMaybe<Scalars['String']['input']>;
  proposalToken?: InputMaybe<Scalars['String']['input']>;
  simulationAmountWithDesperta: Scalars['String']['input'];
  simulationAmountWithoutDesperta: Scalars['String']['input'];
  simulationAverageMonthSavingValue: Scalars['String']['input'];
  simulationAverageYearSavingValue: Scalars['String']['input'];
  simulationCustomerDocument: Scalars['String']['input'];
  simulationCustomerLegalRepresentativeName: Scalars['String']['input'];
  simulationCustomerName: Scalars['String']['input'];
  simulationDate: Scalars['String']['input'];
  simulationDueDate: Scalars['String']['input'];
  simulationNumber: Scalars['String']['input'];
};

export type CustomerAreaRewardHistoryModel = {
  description: Scalars['String']['output'];
  ocurredAt: Scalars['String']['output'];
};

export type CustomerAreaRewardModel = {
  history?: Maybe<Array<CustomerAreaRewardHistoryModel>>;
  percent: Scalars['Float']['output'];
  type: ECustomerAreaRewardType;
};

export type CustomerCashbackInvoicePayDto = {
  invoceIds: Array<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type CustomerCreateDigitalAccountGraphqlDto = {
  accountOwner: EPersonType;
  bank: BankGraphqlDto;
  customerId?: InputMaybe<Scalars['String']['input']>;
  legalRepresentativeDocument?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<CustomerFileCreateGraphql>>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  personType: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  uf?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerDigitalAccountInfoDto = {
  address: AddressGraphqlModel;
  bank?: Maybe<BankGraphqlModel>;
  customerLegalRepresentative?: Maybe<CustomerDigitalAccountLegalRepresentativeDto>;
  digitalAccountStatus: EDigitalAccountStatus;
  document: Scalars['String']['output'];
  documents: Array<DigitalAccountDocumentDto>;
  feedback?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pendecies: DigitalAccountPendenciesDto;
  personType: EPersonType;
  phone: Scalars['String']['output'];
};

export type CustomerDigitalAccountLegalRepresentativeDto = {
  document: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Digital account pendencies */
export type CustomerDigitalAccountPendenciesModel = {
  account: CustomerDigitalAccountPendencyModel;
  address: CustomerDigitalAccountPendencyModel;
  addressProof: CustomerDigitalAccountPendencyModel;
  agency: CustomerDigitalAccountPendencyModel;
  balance_sheet?: Maybe<CustomerDigitalAccountPendencyModel>;
  identificationBack: CustomerDigitalAccountPendencyModel;
  identificationFront: CustomerDigitalAccountPendencyModel;
  selfie: CustomerDigitalAccountPendencyModel;
  social_contract?: Maybe<CustomerDigitalAccountPendencyModel>;
};

/** Digital account pendency */
export type CustomerDigitalAccountPendencyModel = {
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  inAnalysisAt?: Maybe<Scalars['DateTime']['output']>;
  pendenciedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerDigitalAccountUpdateLegalRepresentativeDto = {
  document: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CustomerFileCreateGraphql = {
  file: FileUploadInputTypeDto;
  sendAt: Scalars['String']['input'];
  status: ECustomerFileStatus;
  type: ECustomerFileType;
};

export type CustomerFileCreateGraphqlDto = {
  file?: InputMaybe<FileUploadInputTypeDto>;
  sendAt?: InputMaybe<Scalars['DateTime']['input']>;
  status: ECustomerFileStatus;
  type: ECustomerFileType;
};

export type CustomerFileModel = {
  file?: Maybe<FileUploadModel>;
  sendAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ECustomerFileStatus>;
  type?: Maybe<ECustomerFileType>;
};

export type CustomerIndicationRefModel = {
  address?: Maybe<AddressGraphqlModel>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type CustomerIndicationReferenceModel = {
  customerId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
};

export type CustomerLegalRepresentativeGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<ProposalFileCreateGraphqlDto>>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type CustomerListGraphqlDto = {
  dateRange?: InputMaybe<DateRangeGraphqlSchema>;
  nameOrDocumentOrEmail?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  personType?: InputMaybe<EPersonType>;
  sort?: InputMaybe<CustomerListSort>;
};

export type CustomerListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CustomerModel = {
  _id: Scalars['ID']['output'];
  address?: Maybe<AddressGraphqlModel>;
  bank?: Maybe<BankGraphqlModel>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digitalAccount?: Maybe<DigitalAccountModel>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  files?: Maybe<Array<CustomerFileModel>>;
  hash?: Maybe<Scalars['String']['output']>;
  indicationCode: Scalars['String']['output'];
  legalRepresentatives?: Maybe<Array<LegalRepresentativeModel>>;
  maritalStatus?: Maybe<EMaritalStatus>;
  name: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  origin: Scalars['String']['output'];
  personType: EPersonType;
  phone: Scalars['String']['output'];
  status: ECustomerStatus;
  uf?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CustomerPendencyFields = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  analysedBy?: Maybe<Scalars['String']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  sendedAt?: Maybe<Scalars['DateTime']['output']>;
  solvedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CustomerRefCustomerRefModel = {
  document: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  energyBillFile: CustomerUserFileModel;
  name: Scalars['String']['output'];
  personType: EPersonType;
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerRefModel = {
  address?: Maybe<AddressGraphqlModel>;
  digitalAccountId?: Maybe<Scalars['String']['output']>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type CustomerUpdateGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uf?: InputMaybe<Scalars['String']['input']>;
};

/** CustomerUseCashbackModel */
export type CustomerUseCashbackModel = {
  balanceCashbackAfterInvoicedPaidCents: Scalars['Float']['output'];
  balanceCashbackCents: Scalars['Float']['output'];
  invoiceId: Scalars['String']['output'];
  oldInvoiceValueCents: Scalars['Float']['output'];
};

/** User Access control */
export type CustomerUserAccessControl = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomerUserContractEnergyBillInfo = {
  AmountCents?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<AddressGraphqlModel>;
  avarageBillAmountCents?: Maybe<Scalars['Float']['output']>;
  avarageConsumption?: Maybe<Scalars['Float']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  consumerClassification?: Maybe<EConsumerUnitClassification>;
  dealershipId?: Maybe<Scalars['String']['output']>;
  dealershipName?: Maybe<Scalars['String']['output']>;
  distributionTaxes?: Maybe<Scalars['Float']['output']>;
  energyTaxes?: Maybe<Scalars['Float']['output']>;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  installationNumber?: Maybe<Scalars['String']['output']>;
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceDueDay?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  tariffClassification?: Maybe<ETariffClassification>;
  tension?: Maybe<EConsumerUnitTension>;
  tusdValue?: Maybe<Scalars['Float']['output']>;
};

/** paginate metadata */
export type CustomerUserContractMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** CustomerUserContracts */
export type CustomerUserContractModel = {
  _id: Scalars['String']['output'];
  activatedAt?: Maybe<Scalars['String']['output']>;
  activatedBy?: Maybe<Scalars['String']['output']>;
  consortiumId?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Array<Scalars['String']['output']>>;
  contractedSharePercent?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  customerRef?: Maybe<CustomerRefCustomerRefModel>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  eligibleForCashback: Scalars['Boolean']['output'];
  energyBillInfo?: Maybe<CustomerUserContractEnergyBillInfo>;
  fidelityMonths?: Maybe<Scalars['Float']['output']>;
  gracePeriodMonths?: Maybe<Scalars['Float']['output']>;
  hasRequestedCustomerBankData?: Maybe<Scalars['Boolean']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  internalNotes?: Maybe<Array<Scalars['String']['output']>>;
  participationKwh?: Maybe<Scalars['Float']['output']>;
  powerGeneratorId?: Maybe<Scalars['String']['output']>;
  powerPlantId?: Maybe<Scalars['String']['output']>;
  proposalId?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<CustomerAreaRewardModel>;
  signDate?: Maybe<Scalars['DateTime']['output']>;
  singleAccount?: Maybe<ContractSingleAccountCustomerAreaModel>;
  status?: Maybe<EContractStatus>;
  type?: Maybe<EContractType>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  validityMonths?: Maybe<Scalars['Float']['output']>;
};

export type CustomerUserContractUpdateDealershipLoginDto = {
  contractId: Scalars['String']['input'];
  dealershipLogin: DealershipLoginUpdateDto;
};

export type CustomerUserCreateInput = {
  /** customer id */
  customerId: Scalars['String']['input'];
  /** username of the user */
  email: Scalars['String']['input'];
  /** name of the user */
  name: Scalars['String']['input'];
  /** password of the user */
  password: Scalars['String']['input'];
  /** phone of the user */
  phone: Scalars['String']['input'];
};

export type CustomerUserFileModel = {
  fileName: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  storageService: EStorageService;
};

export type CustomerUserFilterArgs = {
  nameOrUsernameOrEmail?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ECustomerUserStatus>;
};

export type CustomerUserListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type CustomerUserLoggedUserOutput = {
  /** Generated accessToken of the user */
  accessToken: Scalars['String']['output'];
};

/** paginate metadata */
export type CustomerUserMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** user */
export type CustomerUserModel = {
  _id: Scalars['ID']['output'];
  accessControlRef: CustomerUserAccessControl;
  createdAt: Scalars['DateTime']['output'];
  customerId?: Maybe<Scalars['String']['output']>;
  customerRef?: Maybe<UserCustomerRefModel>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  status: ECustomerUserStatus;
  type?: Maybe<EUserType>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type CustomerUserPaginateArgs = {
  filter?: InputMaybe<CustomerUserFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CustomerUserListSort>;
};

export type CustomerUserRecoverPasswordChangeInput = {
  newPassword: Scalars['String']['input'];
  retypeNewPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CustomerUserRecoverPasswordInput = {
  email: Scalars['String']['input'];
};

/** customerUserRecoverPassword */
export type CustomerUserRecoverPasswordModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  status: ECustomerUserPasswordRecoverStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userRef: CustomerUserRefModel;
};

export type CustomerUserRefModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

/** users pagination */
export type CustomerUsersPaginateModel = {
  data: Array<CustomerUserModel>;
  meta: CustomerUserMetaModel;
};

/** customerWithdraw */
export type CustomerWithdrawModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customerRef?: Maybe<UserCustomerRefModel>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digitalAccountId: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: ECustomerWithdrawStatus;
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type CustomerWithdrawRequestInputDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type Dashboard = {
  internalId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DashboardEmbedInfo = {
  embedToken: Scalars['String']['output'];
  embedUrl: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type DashboardInfoResponse = {
  embedToken: Scalars['String']['output'];
  embedUrl: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type DateRangeGraphqlSchema = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

/** dealership */
export type DealershiRefModel = {
  available: Scalars['Boolean']['output'];
  distributorId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationUf?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  needLoginDealership: Scalars['Boolean']['output'];
};

export type DealershipCreateDto = {
  available: Scalars['Boolean']['input'];
  distributorId: Scalars['String']['input'];
  locationUf: Scalars['String']['input'];
  maxDiscountPercentagePf: Scalars['Float']['input'];
  maxDiscountPercentagePj: Scalars['Float']['input'];
  minimumExceptionValue?: InputMaybe<DealershipMinimumExceptionValueCreateDto>;
  name: Scalars['String']['input'];
  needLoginDealership: Scalars['Boolean']['input'];
  partnerBenefitToCustomer: DealershipPartnerBenefitToCustomerCreateDto;
  resolutionAneel?: InputMaybe<DealershipResolutionAneelCreateDto>;
  resolutionClasses?: InputMaybe<Array<DealershipResolutionClassDto>>;
};

export type DealershipDeleteDto = {
  _id: Scalars['String']['input'];
};

/** paginate metadata */
export type DealershipFlagTaxMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type DealershipHistorySchema = {
  action: Scalars['String']['output'];
  newData?: Maybe<Scalars['JSON']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  oldData?: Maybe<Scalars['JSON']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type DealershipListDto = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscountPercentages?: InputMaybe<Scalars['Boolean']['input']>;
  locationUf?: InputMaybe<EBrazilStates>;
  maxDiscountPercentagePf?: InputMaybe<Scalars['Float']['input']>;
  maxDiscountPercentagePj?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DealershipListSort>;
};

export type DealershipListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type DealershipLoginCreateDto = {
  extraPassword?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type DealershipLoginModel = {
  extraPassword?: Maybe<Scalars['String']['output']>;
  login: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type DealershipLoginUpdateDto = {
  extraPassword?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** paginate metadata */
export type DealershipMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type DealershipMinimumExceptionValueCreateDto = {
  allowException: Scalars['Boolean']['input'];
  value: Scalars['Float']['input'];
};

/** Minimum exception value  */
export type DealershipMinimumExceptionValueModel = {
  allowException: Scalars['Boolean']['output'];
  value: Scalars['Float']['output'];
};

/** dealerships */
export type DealershipModel = {
  _id: Scalars['ID']['output'];
  available: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distributorId?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Array<DealershipHistorySchema>>;
  locationUf?: Maybe<Scalars['String']['output']>;
  maxDiscountPercentagePf?: Maybe<Scalars['Float']['output']>;
  maxDiscountPercentagePj?: Maybe<Scalars['Float']['output']>;
  minimumExceptionValue?: Maybe<DealershipMinimumExceptionValueModel>;
  name?: Maybe<Scalars['String']['output']>;
  needLoginDealership: Scalars['Boolean']['output'];
  partnerBenefitToCustomer: DealershipPartnerBenefitToCustomerModel;
  resolutionAneel?: Maybe<DealershipResolutionAneelModel>;
  resolutionClasses: Array<DealershipResolutionClasseModel>;
  updatedAt: Scalars['DateTime']['output'];
};

/** dealerships pagination */
export type DealershipPaginateModel = {
  data: Array<DealershipModel>;
  meta: DealershipMetaModel;
};

export type DealershipPartnerBenefitToCustomerCreateDto = {
  customerPFDiscountMax: Scalars['Float']['input'];
  customerPFDiscountMin: Scalars['Float']['input'];
  customerPFDiscountSuggested: Scalars['Float']['input'];
  customerPJDiscountMax: Scalars['Float']['input'];
  customerPJDiscountMin: Scalars['Float']['input'];
  customerPJDiscountSuggested: Scalars['Float']['input'];
};

/** Partner benefit to customer */
export type DealershipPartnerBenefitToCustomerModel = {
  customerPFDiscountMax?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountMin?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountSuggested?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountMax?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountMin?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountSuggested?: Maybe<Scalars['Float']['output']>;
};

export type DealershipResolutionAneelCreateDto = {
  linkUrl: Scalars['String']['input'];
  modality?: InputMaybe<EDealershipResolutionModality>;
  resolutionHomologed: Scalars['String']['input'];
  validity: Scalars['String']['input'];
};

/** Resoluções da Aneel em vigor */
export type DealershipResolutionAneelModel = {
  linkUrl: Scalars['String']['output'];
  modality?: Maybe<EDealershipResolutionModality>;
  resolutionHomologed: Scalars['String']['output'];
  validity: Scalars['String']['output'];
};

export type DealershipResolutionClassDto = {
  class: EDealershipResolutuionClass;
  cofinsPercentage: Scalars['Float']['input'];
  fcp?: InputMaybe<Scalars['Float']['input']>;
  icmsPercentage: Scalars['Float']['input'];
  pisPercentage: Scalars['Float']['input'];
  teValueCents: Scalars['Float']['input'];
  tusdValueCents: Scalars['Float']['input'];
  wireBCalculationBaseValueCents?: InputMaybe<Scalars['Float']['input']>;
};

export type DealershipResolutionClasseModel = {
  class: EDealershipResolutuionClass;
  cofinsPercentage: Scalars['Float']['output'];
  fcp?: Maybe<Scalars['Float']['output']>;
  icmsPercentage: Scalars['Float']['output'];
  pisPercentage: Scalars['Float']['output'];
  teValueCents: Scalars['Float']['output'];
  tusdValueCents: Scalars['Float']['output'];
  wireBCalculationBaseValueCents?: Maybe<Scalars['Float']['output']>;
};

export type DealershipUpdateDto = {
  _id: Scalars['String']['input'];
  available?: InputMaybe<Scalars['Boolean']['input']>;
  distributorId?: InputMaybe<Scalars['String']['input']>;
  locationUf?: InputMaybe<Scalars['String']['input']>;
  maxDiscountPercentagePf?: InputMaybe<Scalars['Float']['input']>;
  maxDiscountPercentagePj?: InputMaybe<Scalars['Float']['input']>;
  minimumExceptionValue?: InputMaybe<DealershipMinimumExceptionValueCreateDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  needLoginDealership?: InputMaybe<Scalars['Boolean']['input']>;
  partnerBenefitToCustomer?: InputMaybe<DealershipPartnerBenefitToCustomerCreateDto>;
  resolutionAneel?: InputMaybe<DealershipResolutionAneelCreateDto>;
  resolutionClasses?: InputMaybe<Array<DealershipResolutionClassDto>>;
};

export type DigitalAccountBalanceModel = {
  balanceCents?: Maybe<Scalars['Float']['output']>;
};

export type DigitalAccountDocumentDto = {
  file: DigitalAccountDocumentFileDto;
  type: EDigitalAccountDocumentType;
};

export type DigitalAccountDocumentFileDto = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  storageService: EStorageService;
};

export type DigitalAccountDocumentFileModel = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  storageService: EStorageService;
};

export type DigitalAccountDocumentFileUpdateDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  storageService: EStorageService;
  type: EDigitalAccountDocumentType;
};

export type DigitalAccountDocumentModel = {
  file: DigitalAccountDocumentFileModel;
  type: EDigitalAccountDocumentType;
};

export type DigitalAccountInvoiceSplitModel = {
  amountCents: Scalars['Float']['output'];
  barcode?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  internalAccountIdToPayment?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type DigitalAccountLegalRepresentativeModel = {
  document?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type DigitalAccountModel = {
  accountOwner?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  documents: Array<DigitalAccountDocumentModel>;
  email?: Maybe<Scalars['String']['output']>;
  feedback?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  legalRepresentative?: Maybe<Array<DigitalAccountLegalRepresentativeModel>>;
  name: Scalars['String']['output'];
  pendencies: CustomerDigitalAccountPendenciesModel;
  phone?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type DigitalAccountPendecyDto = {
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  inAnalysisAt?: Maybe<Scalars['DateTime']['output']>;
  pendenciedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DigitalAccountPendenciesDto = {
  account: DigitalAccountPendecyDto;
  address: DigitalAccountPendecyDto;
  addressProof: DigitalAccountPendecyDto;
  agency: DigitalAccountPendecyDto;
  balance_sheet?: Maybe<DigitalAccountPendecyDto>;
  customerLegalRepresentativeDocument?: Maybe<DigitalAccountPendecyDto>;
  customerLegalRepresentativeName?: Maybe<DigitalAccountPendecyDto>;
  identificationBack: DigitalAccountPendecyDto;
  identificationFront: DigitalAccountPendecyDto;
  selfie: DigitalAccountPendecyDto;
  social_contract?: Maybe<DigitalAccountPendecyDto>;
};

export type DigitalAccountPixResModel = {
  key: Scalars['String']['output'];
  keyType: Scalars['String']['output'];
};

export type DigitalAccountUpdateDto = {
  address: AddressGraphqlDto;
  bank: BankGraphqlDto;
  customerLegalRepresentative?: InputMaybe<CustomerDigitalAccountUpdateLegalRepresentativeDto>;
  documents: Array<DigitalAccountDocumentFileUpdateDto>;
  phone: Scalars['String']['input'];
};

export type DigitalAccountWalletExtractResponseModel = {
  _id: Scalars['String']['output'];
  balanceCents: Scalars['Float']['output'];
  bankOperation?: Maybe<BankOperationResModel>;
  createdAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  idempotencyKey: Scalars['String']['output'];
  metadata?: Maybe<Metadata>;
  operationType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trackOperation?: Maybe<TrackOperationResModel>;
  updatedAt: Scalars['String']['output'];
  valueCents: Scalars['Float']['output'];
};

export type DiscountExceptionSchema = {
  customerPFDiscountMax: Scalars['Float']['output'];
  customerPFDiscountMin: Scalars['Float']['output'];
  customerPFDiscountSuggested: Scalars['Float']['output'];
  customerPJDiscountMax: Scalars['Float']['output'];
  customerPJDiscountMin: Scalars['Float']['output'];
  customerPJDiscountSuggested: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
};

export type DiscountOfferedSchema = {
  customerPFDiscountOffered: Scalars['Float']['output'];
  customerPJDiscountOffered: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
};

export type DiscountTableDto = {
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountPercentage: Scalars['Float']['output'];
  type: EDiscountTableType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscountTableListDto = {
  filter?: InputMaybe<FilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DiscountTableListSort>;
};

export type DiscountTableListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type DiscountTableModel = {
  _id: Scalars['ID']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountPercentage: Scalars['Float']['output'];
  type: EDiscountTableType;
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscountTablePaginateDto = {
  data: Array<DiscountTableDto>;
  meta: Meta;
};

export type DistributorListDto = {
  active?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<DistributorListSort>;
};

export type DistributorListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type DistributorMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** distributors */
export type DistributorModel = {
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  providerDistributorId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** distributors pagination */
export type DistributorPaginateModel = {
  data: Array<DistributorModel>;
  meta: DistributorMetaModel;
};

export type DocumentSignerModel = {
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  requestSignId?: Maybe<Scalars['String']['output']>;
};

export type DocumentationAnalysisFileModel = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  analyzedBy?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FileUploadModel>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: EProposalFileStatus;
  type: EProposalFileType;
};

export enum EAdhesionBySingleAccount {
  customer = 'customer',
  desperta = 'desperta'
}

export enum EAffiliatePartnerUserAccessStatus {
  allowed = 'allowed',
  notAllowed = 'notAllowed'
}

export enum EAffiliatePartnerUserFileType {
  addressProof = 'addressProof',
  cnpj = 'cnpj',
  idDocument = 'idDocument',
  selfie = 'selfie',
  socialContract = 'socialContract'
}

export enum EAffiliatePartnerUserHistoryAuthor {
  backoffice = 'backoffice',
  representative = 'representative'
}

export enum EAffiliatePartnerUserHistoryEvent {
  accessAllowed = 'accessAllowed',
  accessRevoked = 'accessRevoked',
  approved = 'approved',
  passwordSet = 'passwordSet',
  registered = 'registered',
  rejected = 'rejected'
}

export enum EAffiliatePartnerUserPasswordRecoverStatus {
  completed = 'completed',
  expired = 'expired',
  pending = 'pending'
}

export enum EAffiliatePartnerUserStatus {
  approved = 'approved',
  rejected = 'rejected',
  underAnalysis = 'underAnalysis'
}

export enum EBankAccountType {
  cc = 'cc',
  cp = 'cp'
}

export enum EBillingType {
  keepsBenefit = 'keepsBenefit',
  losesBenefit = 'losesBenefit'
}

export enum EBrazilStates {
  AC = 'AC',
  AL = 'AL',
  AM = 'AM',
  AP = 'AP',
  BA = 'BA',
  CE = 'CE',
  DF = 'DF',
  ES = 'ES',
  GO = 'GO',
  MA = 'MA',
  MG = 'MG',
  MS = 'MS',
  MT = 'MT',
  PA = 'PA',
  PB = 'PB',
  PE = 'PE',
  PI = 'PI',
  PR = 'PR',
  RJ = 'RJ',
  RN = 'RN',
  RO = 'RO',
  RR = 'RR',
  RS = 'RS',
  SC = 'SC',
  SE = 'SE',
  SP = 'SP'
}

export enum EBusinessProposalStatus {
  allocated = 'allocated',
  approved = 'approved',
  canceled = 'canceled',
  finalized = 'finalized',
  inAnalysis = 'inAnalysis',
  rejected = 'rejected'
}

export enum EChangedBy {
  AUTOMATIC = 'AUTOMATIC',
  BITRIX = 'BITRIX',
  MANUAL = 'MANUAL'
}

export enum ECommissionStatus {
  canceled = 'canceled',
  extension = 'extension',
  late = 'late',
  notPaid = 'notPaid',
  paid = 'paid'
}

export enum ECommissionStatusFilter {
  extension = 'extension',
  late = 'late',
  notPaid = 'notPaid',
  paid = 'paid'
}

export enum ECommissioningType {
  anticipated = 'anticipated',
  recurring = 'recurring'
}

export enum EConsortiumStatus {
  active = 'active',
  inactive = 'inactive'
}

export enum EConsumerUnitClassification {
  comercial = 'comercial',
  industrial = 'industrial',
  outros = 'outros',
  residencial = 'residencial',
  rural = 'rural'
}

export enum EConsumerUnitTension {
  bifasico = 'bifasico',
  monofasico = 'monofasico',
  trifasico = 'trifasico'
}

export enum EContractFilterListPendencies {
  signTermAdhesion = 'signTermAdhesion',
  signTermManagement = 'signTermManagement'
}

export enum EContractLossReason {
  areaNotCovered = 'areaNotCovered',
  beneficiaryDueToLowIncome = 'beneficiaryDueToLowIncome',
  buildingOwnPlantOrAlreadyHasOne = 'buildingOwnPlantOrAlreadyHasOne',
  closedWithCompetitor = 'closedWithCompetitor',
  companyChangingPartners = 'companyChangingPartners',
  companyDeactivated = 'companyDeactivated',
  delinquent = 'delinquent',
  didNotUnderstandTheSolution = 'didNotUnderstandTheSolution',
  duplicateLead = 'duplicateLead',
  leadCreatedForTesting = 'leadCreatedForTesting',
  lostToPartner = 'lostToPartner',
  other = 'other',
  rejectedByGenerator = 'rejectedByGenerator',
  suspectedFraud = 'suspectedFraud'
}

export enum EContractOrigin {
  activeCampaign = 'activeCampaign',
  customer = 'customer',
  internal = 'internal',
  partner = 'partner',
  partnerApi = 'partnerApi',
  partnerLink = 'partnerLink',
  rdStation = 'rdStation',
  website = 'website'
}

export enum EContractStatus {
  active = 'active',
  cancellationRequested = 'cancellationRequested',
  deactivated = 'deactivated',
  inDeactivation = 'inDeactivation',
  reserved = 'reserved',
  sent = 'sent',
  signatures = 'signatures'
}

export enum EContractType {
  desperta = 'desperta',
  externalGenerator = 'externalGenerator'
}

export enum ECustomerAreaRewardType {
  cashback = 'cashback',
  discount = 'discount'
}

export enum ECustomerFileStatus {
  accepted = 'accepted',
  pending = 'pending',
  rejected = 'rejected',
  send = 'send'
}

export enum ECustomerFileType {
  customerPfDocumentWithPhotoBack = 'customerPfDocumentWithPhotoBack',
  customerPfDocumentWithPhotoFront = 'customerPfDocumentWithPhotoFront',
  customerPjDocumentCard = 'customerPjDocumentCard',
  customerPjRepresentativeDocumentWithPhotoBack = 'customerPjRepresentativeDocumentWithPhotoBack',
  customerPjRepresentativeDocumentWithPhotoFront = 'customerPjRepresentativeDocumentWithPhotoFront',
  customerPjSocialContract = 'customerPjSocialContract',
  energyBill = 'energyBill'
}

export enum ECustomerStatus {
  completed = 'completed',
  pending = 'pending'
}

export enum ECustomerUserPasswordRecoverStatus {
  completed = 'completed',
  expired = 'expired',
  pending = 'pending'
}

export enum ECustomerUserStatus {
  active = 'active',
  blocked = 'blocked',
  inactive = 'inactive',
  pending = 'pending'
}

export enum ECustomerWithdrawStatus {
  error = 'error',
  finished = 'finished',
  pending = 'pending',
  requested = 'requested'
}

export enum EDealershipResolutionModality {
  conventional = 'conventional',
  notConventional = 'notConventional'
}

export enum EDealershipResolutuionClass {
  b1 = 'b1',
  b2 = 'b2',
  b3 = 'b3'
}

export enum EDigitalAccountDocumentType {
  addressProof = 'addressProof',
  balance_sheet = 'balance_sheet',
  identificationBack = 'identificationBack',
  identificationFront = 'identificationFront',
  others = 'others',
  selfie = 'selfie',
  social_contract = 'social_contract'
}

export enum EDigitalAccountStatus {
  approved = 'approved',
  blocked = 'blocked',
  canceled = 'canceled',
  disapproved = 'disapproved',
  inAnalysis = 'inAnalysis',
  inactive = 'inactive',
  pending = 'pending'
}

export enum EDiscountTableType {
  customerFloatFlag = 'customerFloatFlag',
  customerNotFloatFlag = 'customerNotFloatFlag'
}

export enum EDocumentSignStatus {
  created = 'created',
  error = 'error',
  expired = 'expired',
  pending = 'pending',
  refused = 'refused',
  signatureRequested = 'signatureRequested',
  signed = 'signed',
  uploaded = 'uploaded'
}

export enum EIndicationOrigin {
  api = 'api',
  link = 'link',
  partnerArea = 'partnerArea'
}

export enum EIndicationStatus {
  activeContract = 'activeContract',
  awaitingSignature = 'awaitingSignature',
  canceled = 'canceled',
  canceledContract = 'canceledContract',
  canceledProposal = 'canceledProposal',
  contractWithPendencies = 'contractWithPendencies',
  expiredProposal = 'expiredProposal',
  pending = 'pending',
  proposalUnderAudit = 'proposalUnderAudit',
  requestedProposal = 'requestedProposal',
  signedContract = 'signedContract'
}

export enum EIndicationType {
  customer = 'customer',
  partner = 'partner',
  partnerApi = 'partnerApi',
  partnerLink = 'partnerLink'
}

export enum EInvoiceBenefitStatus {
  lost = 'lost',
  maintained = 'maintained'
}

export enum EInvoiceBenefitType {
  cashback = 'cashback',
  discount = 'discount'
}

export enum EInvoiceCancelReason {
  clientNegotiation = 'clientNegotiation',
  clientRetention = 'clientRetention',
  incorrectData = 'incorrectData',
  incorrectInvoice = 'incorrectInvoice',
  other = 'other',
  systemError = 'systemError',
  wrongAmount = 'wrongAmount'
}

export enum EInvoicePaymentType {
  external = 'external',
  internal = 'internal'
}

export enum EInvoiceStatus {
  canceled = 'canceled',
  createPayment = 'createPayment',
  expired = 'expired',
  externalNegotiation = 'externalNegotiation',
  generatePDF = 'generatePDF',
  late = 'late',
  paid = 'paid',
  paymentRequest = 'paymentRequest',
  pending = 'pending',
  requested = 'requested'
}

export enum EInvoiceTemplate {
  gd1WithCashback = 'gd1WithCashback',
  gd1WithCashbackUnified = 'gd1WithCashbackUnified',
  gd1WithDiscount = 'gd1WithDiscount',
  gd1WithDiscountUnified = 'gd1WithDiscountUnified'
}

export enum ELossReason {
  areaNotCovered = 'areaNotCovered',
  beneficiaryDueToLowIncome = 'beneficiaryDueToLowIncome',
  buildingOwnPlantOrAlreadyHasOne = 'buildingOwnPlantOrAlreadyHasOne',
  closedWithCompetitor = 'closedWithCompetitor',
  companyChangingPartners = 'companyChangingPartners',
  companyDeactivated = 'companyDeactivated',
  delinquent = 'delinquent',
  didNotSendDocumentation = 'didNotSendDocumentation',
  didNotUnderstandTheSolution = 'didNotUnderstandTheSolution',
  disagreesWithContractTerms = 'disagreesWithContractTerms',
  doesNotIntendToLeaveUtility = 'doesNotIntendToLeaveUtility',
  duplicateLead = 'duplicateLead',
  incorrectEmail = 'incorrectEmail',
  insufficientInvoiceAmount = 'insufficientInvoiceAmount',
  invalidOrMissingPhone = 'invalidOrMissingPhone',
  isInFreeMarket = 'isInFreeMarket',
  leadCreatedForTesting = 'leadCreatedForTesting',
  linkExpiredAfter30Days = 'linkExpiredAfter30Days',
  lostToPartner = 'lostToPartner',
  noContactReturned = 'noContactReturned',
  noInterestLostInterest = 'noInterestLostInterest',
  other = 'other',
  publicAgency = 'publicAgency',
  registrationMismatchWithInvoice = 'registrationMismatchWithInvoice',
  rejectedByCredit = 'rejectedByCredit',
  rejectedByGenerator = 'rejectedByGenerator',
  suspectedFraud = 'suspectedFraud',
  wantedDifferentDiscountPercentage = 'wantedDifferentDiscountPercentage'
}

export enum EMaritalStatus {
  divorced = 'divorced',
  married = 'married',
  single = 'single',
  widowed = 'widowed'
}

export enum EModule {
  accessControl = 'accessControl',
  affiliatePartnerArea = 'affiliatePartnerArea',
  commissions = 'commissions',
  consortiums = 'consortiums',
  contractNotes = 'contractNotes',
  contracts = 'contracts',
  customers = 'customers',
  customersArea = 'customersArea',
  dealership = 'dealership',
  documentsign = 'documentsign',
  files = 'files',
  invoices = 'invoices',
  notification = 'notification',
  partner = 'partner',
  powerGenerator = 'powerGenerator',
  powerPlants = 'powerPlants',
  proposals = 'proposals',
  sellers = 'sellers',
  users = 'users'
}

export enum ENotificationRecipient {
  customer = 'customer',
  partner = 'partner'
}

export enum EPartnerStatus {
  active = 'active',
  inactive = 'inactive'
}

export enum EPasswordRecoverStatus {
  completed = 'completed',
  expired = 'expired',
  pending = 'pending'
}

export enum EPendenciesStatus {
  documentationFullyReceived = 'documentationFullyReceived',
  fullyResolved = 'fullyResolved',
  partiallyResolved = 'partiallyResolved',
  rejected = 'rejected'
}

export enum EPersonType {
  pf = 'pf',
  pj = 'pj'
}

export enum EPowerPlantModality {
  gd1 = 'gd1',
  gd2 = 'gd2',
  gd3 = 'gd3'
}

export enum EProposalCustomerPendencies {
  averageEnergyBillValue = 'averageEnergyBillValue',
  city = 'city',
  dealershipName = 'dealershipName',
  document = 'document',
  email = 'email',
  maritalStatus = 'maritalStatus',
  name = 'name',
  nationality = 'nationality',
  neighborhood = 'neighborhood',
  number = 'number',
  phone = 'phone',
  state = 'state',
  street = 'street',
  uf = 'uf',
  zipcode = 'zipcode'
}

export enum EProposalFileStatus {
  accepted = 'accepted',
  pending = 'pending',
  rejected = 'rejected',
  send = 'send'
}

export enum EProposalFileType {
  customerPfDocumentWithPhotoBack = 'customerPfDocumentWithPhotoBack',
  customerPfDocumentWithPhotoFront = 'customerPfDocumentWithPhotoFront',
  customerPjDocumentCard = 'customerPjDocumentCard',
  customerPjRepresentativeDocumentWithPhotoBack = 'customerPjRepresentativeDocumentWithPhotoBack',
  customerPjRepresentativeDocumentWithPhotoFront = 'customerPjRepresentativeDocumentWithPhotoFront',
  customerPjSocialContract = 'customerPjSocialContract',
  energyBill = 'energyBill'
}

export enum EProposalFilterListPendencies {
  addressData = 'addressData',
  documentation = 'documentation',
  energyBill = 'energyBill',
  personalData = 'personalData',
  signTermAdhesion = 'signTermAdhesion'
}

export enum EProposalLegalRepresentantPendencies {
  address = 'address',
  document = 'document',
  email = 'email',
  maritalStatus = 'maritalStatus',
  name = 'name',
  phone = 'phone'
}

export enum EProposalOrigin {
  activeCampaign = 'activeCampaign',
  bitrix = 'bitrix',
  customer = 'customer',
  internal = 'internal',
  partner = 'partner',
  partnerApi = 'partnerApi',
  partnerLink = 'partnerLink',
  rdStation = 'rdStation',
  website = 'website'
}

export enum EProposalStatus {
  canceled = 'canceled',
  documentation = 'documentation',
  finalized = 'finalized',
  formalization = 'formalization'
}

export enum EProviderInvoice {
  api = 'api',
  gera = 'gera'
}

export enum EProviderInvoiceStatus {
  canceled = 'canceled',
  generated = 'generated',
  imported = 'imported',
  importedDealership = 'importedDealership',
  invoiced = 'invoiced'
}

export enum EProviderInvoiceType {
  dealership = 'dealership',
  powerPlan = 'powerPlan'
}

export enum ERewardType {
  cashback = 'cashback',
  discount = 'discount'
}

export enum ESellerChangeBy {
  partner = 'partner',
  system = 'system',
  user = 'user'
}

export enum ESingleAccountType {
  adhesion = 'adhesion',
  cancel = 'cancel'
}

export enum EStage {
  awaitingSignature = 'awaitingSignature',
  contactReestablished = 'contactReestablished',
  firstContactAttempt = 'firstContactAttempt',
  lead = 'lead',
  legalAssembly = 'legalAssembly',
  lost = 'lost',
  negotiating = 'negotiating',
  negotiationCoolingDown = 'negotiationCoolingDown',
  opportunity = 'opportunity',
  proposalContracted = 'proposalContracted',
  secondContactAttempt = 'secondContactAttempt',
  thirdContactAttempt = 'thirdContactAttempt'
}

export enum EStorageService {
  awsS3 = 'awsS3'
}

export enum ETariffClassification {
  A4 = 'A4',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3'
}

export enum ETermOfManagementType {
  automatic = 'automatic',
  manual = 'manual'
}

export enum ETermStatus {
  canceled = 'canceled',
  created = 'created',
  expired = 'expired',
  refused = 'refused',
  replaced = 'replaced',
  requestedSignature = 'requestedSignature',
  signed = 'signed',
  uploaded = 'uploaded'
}

export enum EUserStatus {
  active = 'active',
  blocked = 'blocked',
  inactive = 'inactive',
  pending = 'pending'
}

export enum EUserType {
  customer = 'customer',
  internal = 'internal',
  partner = 'partner',
  seller = 'seller'
}

export enum EWalletExtractStatus {
  error = 'error',
  finalized = 'finalized',
  processing = 'processing',
  requested = 'requested'
}

export type EmbedInfo = {
  embedToken: Scalars['String']['output'];
  embedUrl: Scalars['String']['output'];
  reportId: Scalars['String']['output'];
};

export type EnergyBill = {
  dealershipBarCode?: Maybe<Scalars['String']['output']>;
  dealershipBarCodeDueDate?: Maybe<Scalars['DateTime']['output']>;
  dealershipBarCodeValueCents?: Maybe<Scalars['Float']['output']>;
  dealershipInvoiceValueCents: Scalars['Float']['output'];
  despertaInvoiceValueCents: Scalars['Float']['output'];
  energyGeneratedInMonth: Scalars['Float']['output'];
  energyGenerationBalance: Scalars['Float']['output'];
  energyUsedMonth: Scalars['Float']['output'];
  lastMonthGenerationBalance: Scalars['Float']['output'];
  reference: ReferenceOrderModel;
};

/** Enriched Contracts pagination */
export type EnrichedContractModel = {
  _id: Scalars['ID']['output'];
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  activatedBy?: Maybe<Scalars['String']['output']>;
  billingType?: Maybe<EBillingType>;
  canCreateInvoices?: Maybe<Scalars['Boolean']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  canceledBy?: Maybe<Scalars['String']['output']>;
  canceledReason?: Maybe<Scalars['String']['output']>;
  cancellationRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  cancellationRequestedBy?: Maybe<Scalars['String']['output']>;
  consortiumId?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Array<Scalars['String']['output']>>;
  contractedSharePercent?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['String']['output'];
  customerIndicationRef?: Maybe<CustomerIndicationReferenceModel>;
  customerRef: ContractCustomerRefModel;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedBy?: Maybe<Scalars['String']['output']>;
  dealershipLogin?: Maybe<DealershipLoginModel>;
  dealershipRef?: Maybe<DealershiRefModel>;
  eligibleForCashback: Scalars['Boolean']['output'];
  energyBillInfo?: Maybe<ContractEnergyBillInfo>;
  fidelityMonths?: Maybe<Scalars['Float']['output']>;
  files?: Maybe<Array<DocumentationAnalysisFileModel>>;
  gracePeriodMonths?: Maybe<Scalars['Float']['output']>;
  hasOwnGeneration: Scalars['Boolean']['output'];
  hasRequestedCustomerBankData?: Maybe<Scalars['Boolean']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  inDeactivationAt?: Maybe<Scalars['DateTime']['output']>;
  inDeactivationBy?: Maybe<Scalars['String']['output']>;
  indicationRef?: Maybe<IndicationRefModel>;
  isDocumentsAudited: Scalars['Boolean']['output'];
  isFormalizedByPartner: Scalars['Boolean']['output'];
  isPortabilityCustomer: Scalars['Boolean']['output'];
  lossReason?: Maybe<EContractLossReason>;
  monthlyConsumption?: Maybe<ContractMonthlyConsumption>;
  notes?: Maybe<Array<ObservationModel>>;
  origin?: Maybe<EContractOrigin>;
  ownGenerationAverageKwh?: Maybe<Scalars['Float']['output']>;
  participationKwh?: Maybe<Scalars['Float']['output']>;
  powerGeneratorId?: Maybe<Scalars['String']['output']>;
  powerPlantId?: Maybe<Scalars['String']['output']>;
  powerPlantRef?: Maybe<PowerPlantModel>;
  previousGenerationBalance?: Maybe<Scalars['Float']['output']>;
  proposalId?: Maybe<Scalars['String']['output']>;
  reward?: Maybe<RewardModel>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  signDate?: Maybe<Scalars['DateTime']['output']>;
  singleAccount?: Maybe<ContractSingleAccountModel>;
  specialDiscount?: Maybe<Array<SpecialDiscountModel>>;
  status?: Maybe<EContractStatus>;
  termOfAdhesion?: Maybe<Array<ContractTermOfAdhesionModel>>;
  termOfManagement?: Maybe<Array<ContractTermOfManagementModel>>;
  type?: Maybe<EContractType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  validityMonths?: Maybe<Scalars['Float']['output']>;
};

/** Contracts pagination */
export type EnrichedContractPaginateModel = {
  data: Array<EnrichedContractModel>;
  meta: ContractMetaModel;
};

export type FileFilterArgs = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

/** paginate metadata */
export type FileMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** metadata */
export type FileMetadataModel = {
  sample: Scalars['String']['output'];
};

/** file */
export type FileModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt: Scalars['DateTime']['output'];
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  metadata?: Maybe<FileMetadataModel>;
  mimetype: Scalars['String']['output'];
  storageService?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FilePaginateArgs = {
  filter?: InputMaybe<FileFilterArgs>;
};

export type FileUploadInputTypeDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  storageService: Scalars['String']['input'];
};

export type FileUploadModel = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  storageService: Scalars['String']['output'];
};

/** files pagination */
export type FilesPaginateModel = {
  data: Array<FileModel>;
  meta: FileMetaModel;
};

export type FilesUploadInputGraphqlDto = {
  fileName: Scalars['String']['input'];
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  storageService: EStorageService;
};

export type FilterArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  floatType?: InputMaybe<Array<EDiscountTableType>>;
};

export type FilterDigitalAccountWalletExtractGraphqlDto = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  dateBegin: Scalars['DateTime']['input'];
  dateEnd: Scalars['DateTime']['input'];
  pageNumber?: InputMaybe<Scalars['Float']['input']>;
  pageSize?: InputMaybe<Scalars['Float']['input']>;
  status?: InputMaybe<EWalletExtractStatus>;
};

export type GeoLocationResModel = {
  accuracy: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GetIndicationRelatedEntitiesByIdResponseDto = {
  contract?: Maybe<ContractModel>;
  proposal?: Maybe<ProposalModel>;
};

export type GetMyContractsGraphql = {
  inStatus?: InputMaybe<Array<EContractStatus>>;
};

export type History = {
  action?: Maybe<Scalars['String']['output']>;
  createBy: HistoryCreateBy;
  ocurredAt: Scalars['DateTime']['output'];
  status?: Maybe<EInvoiceStatus>;
};

export type HistoryCreateBy = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IndicationAnticipatedConditionInputModel = {
  additionalCommissionPercentage: Scalars['Float']['input'];
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionAmountPercentage: Scalars['Float']['input'];
  commissionExceptionGroupId: Scalars['String']['input'];
  commissionedInvoices: Scalars['Float']['input'];
};

export type IndicationAnticipatedConditionModel = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
  commissionExceptionGroupId?: Maybe<Scalars['String']['output']>;
  commissionedInvoices: Scalars['Float']['output'];
};

export type IndicationConditionInputModel = {
  anticipated: IndicationAnticipatedConditionInputModel;
  customerDiscountMax: Scalars['Float']['input'];
  customerDiscountMin: Scalars['Float']['input'];
  customerDiscountOffered: Scalars['Float']['input'];
  customerDiscountSuggested: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
  dealershipName: Scalars['String']['input'];
  recurring: IndicationRecurringConditionInputModel;
  uf: Scalars['String']['input'];
};

export type IndicationConditionModel = {
  anticipated?: Maybe<IndicationAnticipatedConditionModel>;
  customerDiscountMax: Scalars['Float']['output'];
  customerDiscountMin: Scalars['Float']['output'];
  customerDiscountOffered: Scalars['Float']['output'];
  customerDiscountSuggested: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
  recurring?: Maybe<IndicationRecurringConditionModel>;
  uf: Scalars['String']['output'];
};

export type IndicationFilterArgs = {
  begin?: InputMaybe<Scalars['DateTime']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  nameCustomerOrSalesman?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Array<EIndicationOrigin>>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  proposalId?: InputMaybe<Scalars['String']['input']>;
  salesmanId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<EIndicationStatus>>;
};

export type IndicationListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type IndicationMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type IndicationMetadataModel = {
  contractId?: Maybe<Scalars['String']['output']>;
  partnerRef?: Maybe<PartnerRefModel>;
  preProposalFileKey?: Maybe<Scalars['String']['output']>;
  proposalId?: Maybe<Scalars['String']['output']>;
};

export type IndicationMetricsDto = {
  activeContract: Scalars['Float']['output'];
  awaitingSignature: Scalars['Float']['output'];
  canceled: Scalars['Float']['output'];
  canceledContract: Scalars['Float']['output'];
  canceledProposal: Scalars['Float']['output'];
  contractWithPendencies: Scalars['Float']['output'];
  expiredProposal: Scalars['Float']['output'];
  indicationCount: Scalars['Float']['output'];
  pending: Scalars['Float']['output'];
  proposalUnderAudit: Scalars['Float']['output'];
  requestedProposal: Scalars['Float']['output'];
  signedContract: Scalars['Float']['output'];
};

export type IndicationModel = {
  _id: Scalars['ID']['output'];
  averageEnergyBillValueCents: Scalars['Float']['output'];
  condition?: Maybe<IndicationConditionModel>;
  createdAt: Scalars['DateTime']['output'];
  customerRef: CustomerIndicationRefModel;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  metadata: IndicationMetadataModel;
  origin: EIndicationOrigin;
  salesmanRef: SalesmanRefModel;
  status: EIndicationStatus;
  type: EIndicationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type IndicationPaginateArgs = {
  filter?: InputMaybe<IndicationFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<IndicationListSort>;
};

/** indications pagination */
export type IndicationPaginateModel = {
  data: Array<IndicationModel>;
  meta: IndicationMetaModel;
};

export type IndicationProposalFileDto = {
  file?: InputMaybe<FilesUploadInputGraphqlDto>;
  status: EProposalFileStatus;
  type: EProposalFileType;
};

export type IndicationRecurringConditionInputModel = {
  additionalCommissionPercentage: Scalars['Float']['input'];
  alwaysCommissionedInvoices: Scalars['Boolean']['input'];
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionAmountPercentage: Scalars['Float']['input'];
  commissionedInvoices: Scalars['Float']['input'];
};

export type IndicationRecurringConditionModel = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  alwaysCommissionedInvoices: Scalars['Boolean']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
  commissionedInvoices?: Maybe<Scalars['Float']['output']>;
};

export type IndicationRefInputModel = {
  condition?: InputMaybe<IndicationConditionInputModel>;
  expired?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  partner: PartnerRefInputModel;
  salesman: SalesmanRefInputModel;
  type: EIndicationType;
};

export type IndicationRefModel = {
  condition?: Maybe<IndicationConditionModel>;
  expired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  partner?: Maybe<PartnerRefModel>;
  salesman: SalesmanRefModel;
  type: EIndicationType;
};

/** invoice calculate new duedate */
export type InvoiceCalculateNewDueDate = {
  invoiceId: Scalars['String']['output'];
  newDueDateCalculated: Array<InvoiceCalculateNewDueDateItem>;
};

export type InvoiceCalculateNewDueDateItem = {
  amountCents: Scalars['Float']['output'];
  dueDate: Scalars['DateTime']['output'];
  fineAmountCents: Scalars['Float']['output'];
  interestAmountCents: Scalars['Float']['output'];
  invoiceValue: Scalars['Float']['output'];
  lateDays: Scalars['Float']['output'];
};

export type InvoiceCancelInfoModel = {
  canceledBy?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceContractDealershipInfo = {
  dealershipTariff: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InvoiceContractInfo = {
  billingType: EBillingType;
  clientNumber: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dealership: InvoiceContractDealershipInfo;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  installationNumber: Scalars['String']['output'];
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  singleAccount: InvoiceContractSingleAccount;
};

export type InvoiceContractSingleAccount = {
  active: Scalars['Boolean']['output'];
  errorOnUnifiedInvoice?: Maybe<Scalars['String']['output']>;
  unifiedInvoice: Scalars['Boolean']['output'];
};

export type InvoiceDashboardHistoryInvoiceArrayModel = {
  history?: Maybe<Array<InvoiceHistoryDashboardModel>>;
};

export type InvoiceDashboardHistoryRewardsInvoiceArrayModel = {
  rewardHistory: Array<InvoiceHistoryRewardsDashboardModel>;
};

export type InvoiceDashboardInfoLastEconomyModel = {
  amountCents: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
};

export type InvoiceDashboardInfoModel = {
  lastEconomy: InvoiceDashboardInfoLastEconomyModel;
  lastInvoiceAmountCents: Scalars['Float']['output'];
  numberOfInvoices: Scalars['Float']['output'];
  overdueInvoices: Scalars['Float']['output'];
};

export type InvoiceDashboardUnifiedModel = {
  history?: Maybe<Array<InvoiceHistoryDashboardModel>>;
  rewardHistory: Array<InvoiceHistoryRewardsDashboardModel>;
};

export type InvoiceExternalPayment = {
  note?: Maybe<Scalars['String']['output']>;
  reportedAt: Scalars['DateTime']['output'];
  reportedBy: InvoiceExternalPaymentReportedByModel;
};

export type InvoiceExternalPaymentReportedByModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type InvoiceHistoryDashboardModel = {
  amountCents: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type InvoiceHistoryRewardsDashboardModel = {
  amountCents: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
  year: Scalars['Float']['output'];
};

export type InvoiceListDto = {
  contractId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<DateRangeGraphqlSchema>;
  customerDocument?: InputMaybe<Scalars['String']['input']>;
  customerEmail?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<DateRangeGraphqlSchema>;
  inStatus?: InputMaybe<Array<EInvoiceStatus>>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paymentTypes?: InputMaybe<Array<EInvoicePaymentType>>;
  secondCopy?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  sort?: InputMaybe<InvoiceListSort>;
};

export type InvoiceListDigitalAccountModel = {
  _id: Scalars['String']['output'];
  amountCents: Scalars['Float']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  payment: InvoicePaymentModel;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentValueCents?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type InvoiceListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type InvoiceMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** invoices */
export type InvoiceModel = {
  _id: Scalars['ID']['output'];
  amountCents: Scalars['Int']['output'];
  benefitAmountCents: Scalars['Int']['output'];
  benefitPercentage: Scalars['Float']['output'];
  benefitStatus: EInvoiceBenefitStatus;
  benefitType: EInvoiceBenefitType;
  billingType: EBillingType;
  cancelInfo?: Maybe<InvoiceCancelInfoModel>;
  consortium: CustomerRefModel;
  contract: InvoiceContractInfo;
  createdAt: Scalars['DateTime']['output'];
  customer: CustomerRefModel;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  dueDate: Scalars['DateTime']['output'];
  energyBill: EnergyBill;
  extended: Scalars['Boolean']['output'];
  externalPayment?: Maybe<InvoiceExternalPayment>;
  hasInterestAndFine: Scalars['Boolean']['output'];
  history: Array<History>;
  indicationRef: IndicationRefModel;
  interestAndFineValues: PaymentInterestAndFineValues;
  isLate: Scalars['Boolean']['output'];
  items: Array<ItemModel>;
  lateDays: Scalars['Float']['output'];
  originalAmountCents: Scalars['Int']['output'];
  originalDueDate: Scalars['DateTime']['output'];
  paidAmountCents?: Maybe<Scalars['Float']['output']>;
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  payment: Array<PaymentModel>;
  paymentType?: Maybe<EInvoicePaymentType>;
  status: EInvoiceStatus;
  totalConsumptionValueCents: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** invoice pagination */
export type InvoicePaginateModel = {
  data: Array<InvoiceModel>;
  meta: InvoiceMetaModel;
};

export type InvoicePaymentModel = {
  barcode?: Maybe<Scalars['String']['output']>;
  digitableLine?: Maybe<Scalars['String']['output']>;
  invoiceBase64?: Maybe<Scalars['String']['output']>;
  paidAt?: Maybe<Scalars['String']['output']>;
  paidValue?: Maybe<Scalars['Float']['output']>;
  pixQrcode?: Maybe<Scalars['String']['output']>;
  pixText?: Maybe<Scalars['String']['output']>;
};

export type InvoiceRequestSecondCopyInput = {
  dueDate: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
};

/** Invoice simulate due date change response */
export type InvoiceSimulateDueDateChangeModel = {
  /** Valor total da fatura em centavos */
  amountCents: Scalars['Float']['output'];
  /** Dias de diferença entre a data solicitada e a data válida */
  daysDifference: Scalars['Float']['output'];
  /** Valor da multa em centavos */
  fineAmountCents: Scalars['Float']['output'];
  /** Valor dos juros em centavos */
  interestAmountCents: Scalars['Float']['output'];
  invoiceId: Scalars['String']['output'];
  /** Valor original da fatura em centavos */
  invoiceValueCents: Scalars['Float']['output'];
  /** Se multa e juros foram perdoados */
  isInterestAndFineWaived: Scalars['Boolean']['output'];
  /** Dias de atraso em relação ao vencimento original */
  lateDays: Scalars['Float']['output'];
  /** Data solicitada pelo analista */
  requestedDueDate: Scalars['DateTime']['output'];
  /** Data válida (próximo dia útil se necessário) */
  validDueDate: Scalars['DateTime']['output'];
};

export type ItemModel = {
  description: Scalars['String']['output'];
  qtd?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  valueAmountCents: Scalars['Int']['output'];
  valueCentsUnit?: Maybe<Scalars['Int']['output']>;
};

export type JwtUserGraphql = {
  customerId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['String']['output']>;
  partnerOwner?: Maybe<Scalars['Boolean']['output']>;
  phone: Scalars['String']['output'];
  type: EUserType;
};

export type JwtUserGraphqlDto = {
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type JwtUserGraphqlModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type JwtUserTokenGraphql = {
  accessControlRef: UserAccessControlGraphql;
  roles: Array<Scalars['String']['output']>;
  user: JwtUserGraphql;
};

export type LegalRepresentativeAddGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  customerId: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<CustomerFileCreateGraphqlDto>>;
  identificationNumber: Scalars['String']['input'];
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type LegalRepresentativeModel = {
  address?: Maybe<AddressGraphqlModel>;
  bank?: Maybe<BankGraphqlModel>;
  document?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  files?: Maybe<Array<CustomerFileModel>>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type LegalRepresentativeRemoveGraphqlDto = {
  customerId: Scalars['String']['input'];
  document: Scalars['String']['input'];
};

export type LegalRepresentativeUpdateGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  customerId: Scalars['String']['input'];
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ListAllInvoicesFiltersGraphqlDto = {
  contractId?: InputMaybe<Scalars['String']['input']>;
};

export type LoggedUserOutput = {
  /** Generated accessToken of the user */
  accessToken: Scalars['String']['output'];
};

export type Meta = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

export type Metadata = {
  contractId: Scalars['String']['output'];
};

export type Module = {
  actions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type ModuleDto = {
  actions: Array<ActionDto>;
  internalName: Scalars['String']['output'];
  publicName: Scalars['String']['output'];
};

export type ModuleInput = {
  actions: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type MonthlyConsumptionDto = {
  april?: InputMaybe<Scalars['Int']['input']>;
  august?: InputMaybe<Scalars['Int']['input']>;
  december?: InputMaybe<Scalars['Int']['input']>;
  february?: InputMaybe<Scalars['Int']['input']>;
  january?: InputMaybe<Scalars['Int']['input']>;
  july?: InputMaybe<Scalars['Int']['input']>;
  june?: InputMaybe<Scalars['Int']['input']>;
  march?: InputMaybe<Scalars['Int']['input']>;
  may?: InputMaybe<Scalars['Int']['input']>;
  november?: InputMaybe<Scalars['Int']['input']>;
  october?: InputMaybe<Scalars['Int']['input']>;
  september?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  accessControlCreate: AccessControlModel;
  accessControlDelete: Scalars['Boolean']['output'];
  accessControlUpdate: AccessControlModel;
  activateBulkContract: ContractActivateBulkModel;
  activateContract: ContractModel;
  activateDistributor?: Maybe<DistributorModel>;
  addNoteToProposal: ProposalModel;
  affiliatePartnerUserChangePassword: AffiliatePartnerUserRecoverPasswordModel;
  affiliatePartnerUserRecoverPassword?: Maybe<AffiliatePartnerUserRecoverPasswordModel>;
  analyseLegalRepresentativeData: ProposalModel;
  analyseRegistrationData: ProposalModel;
  calculateCommission: CalculateCommissionResponseDto;
  cancelContract: ContractModel;
  cancelProposal: ProposalModel;
  consortiumCreate: ConsortiumModel;
  consortiumDelete: Scalars['Boolean']['output'];
  consortiumUpdate: ConsortiumModel;
  contractAddEnergyBillInfo: ContractModel;
  contractAddObservation: ContractModel;
  contractAnalyzeLegalRepresentativeData: ContractModel;
  contractAnalyzeRegistrationData: ContractModel;
  contractChangeBenefit: ContractModel;
  contractChangeFlagCanCreateInvoices: ContractModel;
  contractChangePowerPlan: ContractModel;
  contractChangeSingleAccount: ContractModel;
  contractCreate: ContractModel;
  contractDelete: Scalars['Boolean']['output'];
  contractFilesAnalysis: ContractModel;
  contractRegenerateTermAdhesionOrAssociation?: Maybe<ContractModel>;
  contractRequestTermAdhesionOrAssociation?: Maybe<ContractModel>;
  contractRequestTermOfManagement?: Maybe<ContractModel>;
  contractSolveCustomerPendencies: ContractModel;
  contractSolveLegalRepresentativePendencies: ContractModel;
  contractSyncDocumentWithClickSign?: Maybe<ContractModel>;
  contractUpdate: ContractModel;
  contractUpdateCommercialCondition: ContractModel;
  contractUpdateEnergyBillInfo: ContractModel;
  contractUpdateManuallyTermManagement?: Maybe<ContractModel>;
  contractUpdateManuallyTermManagementApproveOrRepprove?: Maybe<ContractModel>;
  createAffiliatePartnerUser: AffiliatePartnerUserModel;
  createCustomerUser: CustomerUserModel;
  createIndication: IndicationModel;
  createProposalPdf: FileModel;
  createSimulationPdf: FileModel;
  createSimulationWithCashbackPdf: FileModel;
  createUser: UserModel;
  customerAddLegalRepresentant: CustomerModel;
  customerAreaCreateDigitalAccount: CustomerModel;
  customerCreate: CustomerModel;
  customerCreateDigitalAccount: CustomerModel;
  customerCreateUnLogged: CustomerModel;
  customerPayInvoicesWithCashback: CustomerUseCashbackModel;
  customerRemoveLegalRepresentant: CustomerModel;
  customerRequestInvoiceSecondCopy?: Maybe<CustomerModel>;
  customerUpdateById: CustomerModel;
  customerUpdateLegalRepresentant: CustomerModel;
  customerUserChangePassword: CustomerUserRecoverPasswordModel;
  customerUserRecoverPassword: CustomerUserRecoverPasswordModel;
  customerWithdrawRequest: CustomerWithdrawModel;
  dashboardHistoryInvoicesCustomerUser: InvoiceDashboardHistoryInvoiceArrayModel;
  dashboardHistoryInvoicesRewardsCustomerUser: InvoiceDashboardHistoryRewardsInvoiceArrayModel;
  dashboardInvoicesInfoCustomerUser: InvoiceDashboardInfoModel;
  dashboardUnifiedCustomerUser: InvoiceDashboardUnifiedModel;
  deactivateContract: ContractModel;
  deactivateDistributor?: Maybe<DistributorModel>;
  dealershipCreate: DealershipModel;
  dealershipDelete: Scalars['Boolean']['output'];
  dealershipResolutionClasseUpdate: DealershipModel;
  dealershipUpdate: DealershipModel;
  deleteAffiliatePartnerUser: AffiliatePartnerDeleteUserModel;
  deleteCustomerUser: CustomerUserModel;
  deleteUser: UserModel;
  discountTableCreate: DiscountTableModel;
  discountTableDelete?: Maybe<DiscountTableModel>;
  discountTableUpdate: DiscountTableModel;
  forInDeactivationContract: ContractModel;
  formalizeIndicationProposal: ProposalModel;
  generateNewTermOfAdhesion: ProposalModel;
  getCustomerNameByHash: Scalars['String']['output'];
  listAllInvoicesCustomerUser: PaginatedInvoiceDigitalAccountModel;
  loginAffiliatePartnerUser: AffiliatePartnerUserLoggedUserOutput;
  loginCustomerUser: CustomerUserLoggedUserOutput;
  loginUser: LoggedUserOutput;
  logoutCustomerUser: CustomerUserLoggedUserOutput;
  notificationCreate: NotificationModel;
  notifyCustomerFinishedDocumentation: ProposalModel;
  notifyFinishedDocumentation: Scalars['Boolean']['output'];
  openedOrClickedPushNotification: NotificationModel;
  partnerAffiliateUserApprove: PartnerAffiliateUserModel;
  partnerAffiliateUserReject: PartnerAffiliateUserModel;
  partnerCreate: PartnerModel;
  partnerDelete: Scalars['Boolean']['output'];
  partnerUpdate: PartnerModel;
  powerGeneratorAreaGetDashboardInfo: DashboardInfoResponse;
  powerGeneratorAreaLogin: PowerGeneratorAreaOutput;
  powerGeneratorCreate: PowerGeneratorModel;
  powerGeneratorDelete: Scalars['Boolean']['output'];
  powerGeneratorUpdate: PowerGeneratorModel;
  powerPlantCreate: PowerPlantModel;
  powerPlantDelete: Scalars['Boolean']['output'];
  powerPlantUpdate: PowerPlantModel;
  proposalAddEnergyBillInfo: ProposalModel;
  proposalAddLegalRepresentative: ProposalModel;
  proposalAddPreProposal: ProposalModel;
  proposalCreate: ProposalModel;
  proposalFilesAnalysis: ProposalModel;
  proposalFormalization: ProposalModel;
  proposalRemoveLegalRepresentative: ProposalModel;
  proposalUpdate: ProposalModel;
  proposalUpdateLegalRepresentative: ProposalModel;
  proposalUpdateManuallyTermManagement?: Maybe<ProposalModel>;
  proposalUpdateManuallyTermManagementApproveOrRepprove?: Maybe<ProposalModel>;
  providerInvoiceCancel: InvoiceModel;
  providerInvoiceChangeDueDate: ProviderInvoiceModel;
  receivedPushNotification: NotificationModel;
  regenerateApiKeyFromPartner: PartnerModel;
  reportExternalPayment: Scalars['Boolean']['output'];
  requestCustomerBankData: Scalars['String']['output'];
  sellerCreate: SellerModel;
  sellerDelete: Scalars['Boolean']['output'];
  sellerUpdate: SellerModel;
  sendContractToSign: ContractModel;
  sendPushNotification: NotificationModel;
  sendPushNotificationAll: NotificationModel;
  signedUrlLogin: Scalars['String']['output'];
  solveProposalCustomerPendencies: ProposalModel;
  solveProposalLegalRepresentantPendencies: ProposalModel;
  updateAffiliatePartnerUser: AffiliatePartnerUserModel;
  updateAffiliatePartnerUserApproved: AffiliatePartnerUserModel;
  updateCustomerDigitalAccountByHash: CustomerDigitalAccountInfoDto;
  updateDistributorsFromAPI: Array<DistributorModel>;
  updateIndication: IndicationModel;
  updateIndicationAddEnergyBillInfo: Scalars['Boolean']['output'];
  updateIndicationFiles: Scalars['Boolean']['output'];
  updateIndicationLegalRepresentatives: Scalars['Boolean']['output'];
  updateInvoicesToExternalNegotiation: UpdateInvoiceToExternalNegotiationModel;
  updatePartnerAreaPartnerIcone: PartnerModel;
  updatePartnerAreaPartnerLogo: PartnerModel;
  updatePartnerDefaultConfiguration: PartnerModel;
  updatePartnerDiscountsOffered: PartnerDiscountOfferedModel;
  updatePartnerWebhook: PartnerModel;
  updatePushNotifications: CustomerUserLoggedUserOutput;
  updateSalesFunnelStage: ProposalModel;
  updateUser: UserModel;
  userChangePassword: RecoverPasswordModel;
  userContractChangeBenefit: ContractModel;
  userContractChangeSingleAccount: ContractModel;
  userContractUpdateDealershipLogin: ContractModel;
  userRecoverPassword: RecoverPasswordModel;
};


export type MutationAccessControlCreateArgs = {
  params: AccessControlCreateDto;
};


export type MutationAccessControlDeleteArgs = {
  params: AccessControlDeleteDto;
};


export type MutationAccessControlUpdateArgs = {
  params: AccessControlUpdateDto;
};


export type MutationActivateBulkContractArgs = {
  contractIds: Array<Scalars['String']['input']>;
};


export type MutationActivateContractArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationActivateDistributorArgs = {
  distributorId: Scalars['String']['input'];
};


export type MutationAddNoteToProposalArgs = {
  params: AddNoteGraphqlDto;
};


export type MutationAffiliatePartnerUserChangePasswordArgs = {
  RecoverPasswordChangeInput: AffiliatePartnerUserRecoverPasswordChangeInput;
};


export type MutationAffiliatePartnerUserRecoverPasswordArgs = {
  RecoverPasswordInput: AffiliatePartnerUserRecoverPasswordInput;
};


export type MutationAnalyseLegalRepresentativeDataArgs = {
  params: AnalyseLegalRepresentativeDataDto;
};


export type MutationAnalyseRegistrationDataArgs = {
  params: AnalyseRegistrationDataDto;
};


export type MutationCalculateCommissionArgs = {
  params: CalculateCommissionParamsDto;
};


export type MutationCancelContractArgs = {
  params: CancelContractDtoGraphql;
};


export type MutationCancelProposalArgs = {
  params: CancelProposalGraphqlDto;
};


export type MutationConsortiumCreateArgs = {
  params: ConsortiumCreateDtoGraphql;
};


export type MutationConsortiumDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationConsortiumUpdateArgs = {
  params: ConsortiumUpdateDtoGraphql;
};


export type MutationContractAddEnergyBillInfoArgs = {
  params: ContractAddEnergyBillInfoGraphqlDto;
};


export type MutationContractAddObservationArgs = {
  params: ObservationCreateDtoGraphql;
};


export type MutationContractAnalyzeLegalRepresentativeDataArgs = {
  params: ContractAnalyzeLegalRepresentativeDataDto;
};


export type MutationContractAnalyzeRegistrationDataArgs = {
  params: ContractAnalyzeRegistrationDataDto;
};


export type MutationContractChangeBenefitArgs = {
  params: ContractChangeBenefitDto;
};


export type MutationContractChangeFlagCanCreateInvoicesArgs = {
  canCreateInvoices: Scalars['Boolean']['input'];
  contractId: Scalars['String']['input'];
};


export type MutationContractChangePowerPlanArgs = {
  params: ContractChangePowerPlantDto;
};


export type MutationContractChangeSingleAccountArgs = {
  params: ContractChangeSingleAccountDto;
};


export type MutationContractCreateArgs = {
  params: ContractCreateDtoGraphql;
};


export type MutationContractDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationContractFilesAnalysisArgs = {
  id: Scalars['String']['input'];
  params: ContractAnalysisFilesDto;
};


export type MutationContractRegenerateTermAdhesionOrAssociationArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationContractRequestTermAdhesionOrAssociationArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationContractRequestTermOfManagementArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationContractSolveCustomerPendenciesArgs = {
  params: ContractSolveCustomerPendenciesGraphqlDto;
};


export type MutationContractSolveLegalRepresentativePendenciesArgs = {
  params: ContractSolveLegalRepresentantPendenciesGraphqlDto;
};


export type MutationContractSyncDocumentWithClickSignArgs = {
  contractId: Scalars['String']['input'];
  documentKey: Scalars['String']['input'];
};


export type MutationContractUpdateArgs = {
  params: ContractUpdateDtoGraphql;
};


export type MutationContractUpdateCommercialConditionArgs = {
  params: ContractUpdateCommercialCondition;
};


export type MutationContractUpdateEnergyBillInfoArgs = {
  params: ContractUpdateEnergyBillInfo;
};


export type MutationContractUpdateManuallyTermManagementArgs = {
  params: ContractUpdateManuallyTermManagement;
};


export type MutationContractUpdateManuallyTermManagementApproveOrRepproveArgs = {
  params: ContractUpdateManuallyTermManagementApproveDto;
};


export type MutationCreateAffiliatePartnerUserArgs = {
  userCreateInput: AffiliatePartnerUserCreateInput;
};


export type MutationCreateCustomerUserArgs = {
  userCreateInput: CustomerUserCreateInput;
};


export type MutationCreateIndicationArgs = {
  params: CreateIndicationPartnerDto;
};


export type MutationCreateProposalPdfArgs = {
  params: CreateProposalPdfGraphql;
};


export type MutationCreateSimulationPdfArgs = {
  params: CreateSimulationPdfGraphql;
};


export type MutationCreateSimulationWithCashbackPdfArgs = {
  params: CreateSimulationPdfGraphql;
};


export type MutationCreateUserArgs = {
  userCreateInput: UserCreateInput;
};


export type MutationCustomerAddLegalRepresentantArgs = {
  params: LegalRepresentativeAddGraphqlDto;
};


export type MutationCustomerAreaCreateDigitalAccountArgs = {
  params: CustomerCreateDigitalAccountGraphqlDto;
};


export type MutationCustomerCreateArgs = {
  params: CustomerCreateGraphqlDto;
};


export type MutationCustomerCreateDigitalAccountArgs = {
  params: CustomerCreateDigitalAccountGraphqlDto;
};


export type MutationCustomerCreateUnLoggedArgs = {
  params: CustomerCreateGraphqlDto;
};


export type MutationCustomerPayInvoicesWithCashbackArgs = {
  CustomerCashbackInvoicePayDto: CustomerCashbackInvoicePayDto;
};


export type MutationCustomerRemoveLegalRepresentantArgs = {
  params: LegalRepresentativeRemoveGraphqlDto;
};


export type MutationCustomerRequestInvoiceSecondCopyArgs = {
  params: InvoiceRequestSecondCopyInput;
};


export type MutationCustomerUpdateByIdArgs = {
  id: Scalars['String']['input'];
  params: CustomerUpdateGraphqlDto;
};


export type MutationCustomerUpdateLegalRepresentantArgs = {
  params: LegalRepresentativeUpdateGraphqlDto;
};


export type MutationCustomerUserChangePasswordArgs = {
  RecoverPasswordChangeInput: CustomerUserRecoverPasswordChangeInput;
};


export type MutationCustomerUserRecoverPasswordArgs = {
  RecoverPasswordInput: CustomerUserRecoverPasswordInput;
};


export type MutationCustomerWithdrawRequestArgs = {
  CustomerWithdrawRequestInput: CustomerWithdrawRequestInputDto;
};


export type MutationDashboardHistoryInvoicesCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationDashboardHistoryInvoicesRewardsCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationDashboardInvoicesInfoCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationDashboardUnifiedCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationDeactivateContractArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationDeactivateDistributorArgs = {
  distributorId: Scalars['String']['input'];
};


export type MutationDealershipCreateArgs = {
  params: DealershipCreateDto;
};


export type MutationDealershipDeleteArgs = {
  params: DealershipDeleteDto;
};


export type MutationDealershipResolutionClasseUpdateArgs = {
  id: Scalars['String']['input'];
  params: Array<DealershipResolutionClassDto>;
};


export type MutationDealershipUpdateArgs = {
  params: DealershipUpdateDto;
};


export type MutationDeleteAffiliatePartnerUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteCustomerUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDiscountTableCreateArgs = {
  params: CreateDiscountDto;
};


export type MutationDiscountTableDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDiscountTableUpdateArgs = {
  id: Scalars['String']['input'];
  params: UpdateDiscountDto;
};


export type MutationForInDeactivationContractArgs = {
  canCreateInvoices: Scalars['Boolean']['input'];
  contractId: Scalars['String']['input'];
};


export type MutationFormalizeIndicationProposalArgs = {
  indicationId: Scalars['String']['input'];
};


export type MutationGenerateNewTermOfAdhesionArgs = {
  proposalId: Scalars['String']['input'];
};


export type MutationListAllInvoicesCustomerUserArgs = {
  filters: ListAllInvoicesFiltersGraphqlDto;
};


export type MutationLoginAffiliatePartnerUserArgs = {
  authUserInput: AuthAffiliatePartnerUserArgs;
};


export type MutationLoginCustomerUserArgs = {
  authUserInput: AuthCustomerUserArgs;
};


export type MutationLoginUserArgs = {
  authUserInput: AuthUserArgs;
};


export type MutationLogoutCustomerUserArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationNotificationCreateArgs = {
  params: NotificationCreateDto;
};


export type MutationNotifyCustomerFinishedDocumentationArgs = {
  params: NotifyCustomerFinishedDocumentationGraphqlDto;
};


export type MutationNotifyFinishedDocumentationArgs = {
  params: ContractNotifyPartnerFinishedDocumentationGraphqlDto;
};


export type MutationOpenedOrClickedPushNotificationArgs = {
  params: Scalars['String']['input'];
};


export type MutationPartnerAffiliateUserApproveArgs = {
  id: Scalars['String']['input'];
};


export type MutationPartnerAffiliateUserRejectArgs = {
  id: Scalars['String']['input'];
  justification: Scalars['String']['input'];
};


export type MutationPartnerCreateArgs = {
  params: PartnerCreateDto;
};


export type MutationPartnerDeleteArgs = {
  params: PartnerDeleteDto;
};


export type MutationPartnerUpdateArgs = {
  params: PartnerUpdateDto;
};


export type MutationPowerGeneratorAreaLoginArgs = {
  installation: Scalars['String']['input'];
  powerPlantId: Scalars['String']['input'];
};


export type MutationPowerGeneratorCreateArgs = {
  params: PowerGeneratorCreateDto;
};


export type MutationPowerGeneratorDeleteArgs = {
  params: PowerGeneratorDeleteDto;
};


export type MutationPowerGeneratorUpdateArgs = {
  params: PowerGeneratorUpdateDto;
};


export type MutationPowerPlantCreateArgs = {
  params: PowerPlantCreateDto;
};


export type MutationPowerPlantDeleteArgs = {
  params: PowerPlantDeleteDto;
};


export type MutationPowerPlantUpdateArgs = {
  params: PowerPlantUpdateDto;
};


export type MutationProposalAddEnergyBillInfoArgs = {
  params: ProposalAddEnergyBillInfoGraphqlDto;
};


export type MutationProposalAddLegalRepresentativeArgs = {
  params: ProposalAddLegalRepresentativeGraphqlDto;
};


export type MutationProposalAddPreProposalArgs = {
  params: ProposalAddPreProposalGraphqlDto;
};


export type MutationProposalCreateArgs = {
  params: ProposalCreateGraphqlDto;
};


export type MutationProposalFilesAnalysisArgs = {
  id: Scalars['String']['input'];
  params: ProposalAnalysisFilesDto;
};


export type MutationProposalFormalizationArgs = {
  proposalId: Scalars['String']['input'];
};


export type MutationProposalRemoveLegalRepresentativeArgs = {
  params: ProposalRemoveLegalRepresentativeGraphqlDto;
};


export type MutationProposalUpdateArgs = {
  params: ProposalUpdateGraphqlDto;
};


export type MutationProposalUpdateLegalRepresentativeArgs = {
  params: ProposalUpdateLegalRepresentativeGraphqlDto;
};


export type MutationProposalUpdateManuallyTermManagementArgs = {
  params: ProposalUpdateManuallyTermManagement;
};


export type MutationProposalUpdateManuallyTermManagementApproveOrRepproveArgs = {
  params: ProposalUpdateManuallyTermManagementApproveDto;
};


export type MutationProviderInvoiceCancelArgs = {
  params: ProviderInvoiceCancelDto;
};


export type MutationProviderInvoiceChangeDueDateArgs = {
  params: ContractInvoiceChangeDueDateDto;
};


export type MutationReceivedPushNotificationArgs = {
  params: Scalars['String']['input'];
};


export type MutationReportExternalPaymentArgs = {
  params: ReportExternalPaymentDto;
};


export type MutationRequestCustomerBankDataArgs = {
  contractId: Scalars['String']['input'];
};


export type MutationSellerCreateArgs = {
  params: SellerCreateDto;
};


export type MutationSellerDeleteArgs = {
  params: SellerDeleteDto;
};


export type MutationSellerUpdateArgs = {
  params: SellerUpdateDto;
};


export type MutationSendContractToSignArgs = {
  params: SendContractToSignDtoGraphql;
};


export type MutationSendPushNotificationArgs = {
  params: SendPushNotificationDto;
};


export type MutationSendPushNotificationAllArgs = {
  params: SendPushNotificationDto;
};


export type MutationSolveProposalCustomerPendenciesArgs = {
  params: SolveProposalCustomerPendenciesGraphqlDto;
};


export type MutationSolveProposalLegalRepresentantPendenciesArgs = {
  params: SolveProposalLegalRepresentantPendenciesGraphqlDto;
};


export type MutationUpdateAffiliatePartnerUserArgs = {
  id: Scalars['String']['input'];
  userUpdateInput: AffiliatePartnerUserUpdateInput;
};


export type MutationUpdateAffiliatePartnerUserApprovedArgs = {
  id: Scalars['String']['input'];
  userUpdateInput: AffiliatePartnerUserApprovedUpdateInput;
};


export type MutationUpdateCustomerDigitalAccountByHashArgs = {
  hash: Scalars['String']['input'];
  input: DigitalAccountUpdateDto;
};


export type MutationUpdateIndicationArgs = {
  params: UpdateIndicationPartnerDto;
};


export type MutationUpdateIndicationAddEnergyBillInfoArgs = {
  params: UpdateIndicationEnergyBillInfoDto;
};


export type MutationUpdateIndicationFilesArgs = {
  params: UpdateIndicationFilesDto;
};


export type MutationUpdateIndicationLegalRepresentativesArgs = {
  params: UpdateIndicationLegalRepresentativeGraphqlDto;
};


export type MutationUpdateInvoicesToExternalNegotiationArgs = {
  invoiceIds: Array<Scalars['String']['input']>;
};


export type MutationUpdatePartnerAreaPartnerIconeArgs = {
  partnerIcone: FileUploadInputTypeDto;
};


export type MutationUpdatePartnerAreaPartnerLogoArgs = {
  partnerLogo: FileUploadInputTypeDto;
};


export type MutationUpdatePartnerDefaultConfigurationArgs = {
  UpdatePartnerDefaultConfigurationDto: UpdatePartnerDefaultConfigurationDto;
};


export type MutationUpdatePartnerDiscountsOfferedArgs = {
  UpdatePartnerDiscountOfferedDto: UpdatePartnerDiscountOfferedDto;
};


export type MutationUpdatePartnerWebhookArgs = {
  updatePartnerWebhookDto: UpdatePartnerWebhookDto;
};


export type MutationUpdatePushNotificationsArgs = {
  isPushNotificationEnabled: Scalars['Boolean']['input'];
  sessionId: Scalars['String']['input'];
};


export type MutationUpdateSalesFunnelStageArgs = {
  params: UpdateSalesFunnelStageDto;
};


export type MutationUpdateUserArgs = {
  id: Scalars['String']['input'];
  userUpdateInput: UserUpdateInput;
};


export type MutationUserChangePasswordArgs = {
  RecoverPasswordChangeInput: RecoverPasswordChangeInput;
};


export type MutationUserContractChangeBenefitArgs = {
  params: ContractChangeBenefitDto;
};


export type MutationUserContractChangeSingleAccountArgs = {
  params: ContractChangeSingleAccountDto;
};


export type MutationUserContractUpdateDealershipLoginArgs = {
  params: CustomerUserContractUpdateDealershipLoginDto;
};


export type MutationUserRecoverPasswordArgs = {
  RecoverPasswordInput: RecoverPasswordInput;
};

export type NoteModel = {
  analystId: Scalars['ID']['output'];
  analystName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<BusinessProposalFileModel>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NotificationAttachmentModel = {
  fileInBase64: Scalars['String']['output'];
  mimetype?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type NotificationCreateAttachmentDto = {
  fileInBase64: Scalars['String']['input'];
  mimetype?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type NotificationCreateDto = {
  attachments?: InputMaybe<Array<NotificationCreateAttachmentDto>>;
  bcc?: InputMaybe<NotificationCreateToDto>;
  bccList?: InputMaybe<Array<NotificationCreateToDto>>;
  cc?: InputMaybe<NotificationCreateToDto>;
  ccList?: InputMaybe<Array<NotificationCreateToDto>>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  idempotence?: InputMaybe<Scalars['String']['input']>;
  message: NotificationCreateMessageDto;
  options?: InputMaybe<NotificationCreateOptionDto>;
  reployTo?: InputMaybe<NotificationCreateToDto>;
  subject: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  to: NotificationCreateToDto;
  toList?: InputMaybe<Array<NotificationCreateToDto>>;
};

export type NotificationCreateMessageDto = {
  html?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCreateOptionDto = {
  personalization?: InputMaybe<Array<NotificationCreatePersonalizationDto>>;
  schedulerTimeStamp?: InputMaybe<Scalars['Float']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCreatePersonalizationDataDto = {
  allMonthsReference?: InputMaybe<Scalars['String']['input']>;
  barCode?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  contractNumber?: InputMaybe<Scalars['String']['input']>;
  formatedValue?: InputMaybe<Scalars['String']['input']>;
  haveUniffyAccount?: InputMaybe<Scalars['String']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceMonth?: InputMaybe<Scalars['String']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
  invoicesLength?: InputMaybe<Scalars['String']['input']>;
  isEligibleCashback?: InputMaybe<Scalars['String']['input']>;
  isFirstInvoiceAndLossBenefit?: InputMaybe<Scalars['Boolean']['input']>;
  isInvoiceLate?: InputMaybe<Scalars['Boolean']['input']>;
  isReducedAccountPartner?: InputMaybe<Scalars['Boolean']['input']>;
  lastMonthReference?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkSignIn?: InputMaybe<Scalars['String']['input']>;
  linkToProposal?: InputMaybe<Scalars['String']['input']>;
  listRejectData: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  month?: InputMaybe<Scalars['String']['input']>;
  monthReference?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameConsumeUnit?: InputMaybe<Scalars['String']['input']>;
  needLoginDealership?: InputMaybe<Scalars['Boolean']['input']>;
  newDueDate?: InputMaybe<Scalars['String']['input']>;
  newInvoiceValue?: InputMaybe<Scalars['String']['input']>;
  oldInvoiceAmount?: InputMaybe<Scalars['String']['input']>;
  partnerLogo?: InputMaybe<PartnerLogo>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  percentage?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vencimentAt?: InputMaybe<Scalars['String']['input']>;
  whatsappLink?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationCreatePersonalizationDto = {
  data: NotificationCreatePersonalizationDataDto;
  email: Scalars['String']['input'];
};

export type NotificationCreateToDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  token?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationListDto = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<NotificationListSort>;
};

export type NotificationListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type NotificationMessageModel = {
  html?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type NotificationModel = {
  _id: Scalars['ID']['output'];
  attachments?: Maybe<Array<NotificationAttachmentModel>>;
  bcc?: Maybe<Array<NotificationToModel>>;
  cc?: Maybe<Array<NotificationToModel>>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  message: NotificationMessageModel;
  messageKey: Scalars['String']['output'];
  options?: Maybe<NotificationOptionModel>;
  reployTo?: Maybe<NotificationToModel>;
  status: Scalars['String']['output'];
  steps: NotificationStepModel;
  subject: Scalars['String']['output'];
  to: Array<NotificationToModel>;
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationOptionModel = {
  personalization?: Maybe<Array<NotificationPersonalizationModel>>;
  schedulerTimeStamp?: Maybe<Scalars['Float']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
};

export type NotificationPersonalizationDataModel = {
  name: Scalars['String']['output'];
};

export type NotificationPersonalizationModel = {
  data: NotificationPersonalizationDataModel;
  email: Scalars['String']['output'];
};

export type NotificationStepModel = {
  bounced?: Maybe<Scalars['DateTime']['output']>;
  canceled?: Maybe<Scalars['DateTime']['output']>;
  clicked?: Maybe<Scalars['DateTime']['output']>;
  delivered?: Maybe<Scalars['DateTime']['output']>;
  opened?: Maybe<Scalars['DateTime']['output']>;
  pending?: Maybe<Scalars['DateTime']['output']>;
  sended?: Maybe<Scalars['DateTime']['output']>;
  spam?: Maybe<Scalars['DateTime']['output']>;
  unsubscribed?: Maybe<Scalars['DateTime']['output']>;
};

export type NotificationToModel = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type NotifyCustomerFinishedDocumentationGraphqlDto = {
  proposalId: Scalars['String']['input'];
  recipients: Array<ENotificationRecipient>;
};

export type ObservationCreateDtoGraphql = {
  _id: Scalars['String']['input'];
  fileKey?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationModel = {
  analystId: Scalars['String']['output'];
  analystName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<ContractFileModel>;
  text?: Maybe<Scalars['String']['output']>;
};

export type OwnerResModel = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PaginatedAccessControlModel = {
  data: Array<AccessControlModel>;
  meta: Meta;
};

export type PaginatedCustomerModel = {
  data: Array<CustomerModel>;
  meta: Meta;
};

export type PaginatedDigitalAccountWalletExtractModel = {
  data: Array<DigitalAccountWalletExtractResponseModel>;
  meta: Meta;
  status: Scalars['Float']['output'];
};

export type PaginatedInvoiceDigitalAccountModel = {
  data: Array<InvoiceListDigitalAccountModel>;
  meta: Meta;
};

export type PaginatedNotificationModel = {
  data: Array<NotificationModel>;
  meta: Meta;
};

export type PaginatedPowerGeneratorModel = {
  data: Array<PowerGeneratorModel>;
  meta: Meta;
};

export type PartnerAffiliateUserAccessControl = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PartnerAffiliateUserFileModel = {
  file: FileUploadModel;
  type: EAffiliatePartnerUserFileType;
};

export type PartnerAffiliateUserHistoryModel = {
  author: EAffiliatePartnerUserHistoryAuthor;
  date: Scalars['DateTime']['output'];
  event: EAffiliatePartnerUserHistoryEvent;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type PartnerAffiliateUserListDto = {
  inAccessStatus?: InputMaybe<Array<EAffiliatePartnerUserAccessStatus>>;
  inStatus?: InputMaybe<Array<EAffiliatePartnerUserStatus>>;
  nameOrEmailOrCpf?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<PartnerAffiliateUserListSort>;
};

export type PartnerAffiliateUserListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** metadados de paginação */
export type PartnerAffiliateUserMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** preposto do parceiro (visão backoffice) */
export type PartnerAffiliateUserModel = {
  _id: Scalars['ID']['output'];
  accessControlRef: PartnerAffiliateUserAccessControl;
  accessStatus: EAffiliatePartnerUserAccessStatus;
  address?: Maybe<AddressGraphqlModel>;
  captureSource?: Maybe<Scalars['String']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  facebook?: Maybe<Scalars['String']['output']>;
  files: Array<PartnerAffiliateUserFileModel>;
  history: Array<PartnerAffiliateUserHistoryModel>;
  instagram?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  owner: Scalars['Boolean']['output'];
  partnerRef?: Maybe<PartnerAffiliateUserPartnerRef>;
  phone?: Maybe<Scalars['String']['output']>;
  professionalHistory: Array<PartnerAffiliateUserProfessionalReferenceModel>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  site?: Maybe<Scalars['String']['output']>;
  status: EAffiliatePartnerUserStatus;
  type?: Maybe<EUserType>;
  updatedAt: Scalars['DateTime']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type PartnerAffiliateUserPartnerRef = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type PartnerAffiliateUserProfessionalReferenceModel = {
  companyName?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
};

/** paginação de prepostos (backoffice) */
export type PartnerAffiliateUsersPaginateModel = {
  data: Array<PartnerAffiliateUserModel>;
  meta: PartnerAffiliateUserMetaModel;
};

export type PartnerAnticipatedCommissioningParamsSchema = {
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionExceptionGroups: Array<CommissionExceptionGroupSchema>;
  commissionedInvoices: Scalars['Float']['output'];
};

export type PartnerConfigurationCreateDto = {
  allowAffiliateLink: Scalars['Boolean']['input'];
  allowManualProposal: Scalars['Boolean']['input'];
  allowViewIndicationData?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  icone?: InputMaybe<FileUploadInputTypeDto>;
  logo?: InputMaybe<FileUploadInputTypeDto>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerConfigurationSchema = {
  allowAffiliateLink: Scalars['Boolean']['output'];
  allowManualProposal: Scalars['Boolean']['output'];
  allowViewIndicationData?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  icone?: Maybe<PartnerFileUploadModel>;
  logo?: Maybe<PartnerFileUploadModel>;
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type PartnerConfigurationUpdateDto = {
  allowAffiliateLink?: InputMaybe<Scalars['Boolean']['input']>;
  allowManualProposal?: InputMaybe<Scalars['Boolean']['input']>;
  allowViewIndicationData?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  icone?: InputMaybe<FileUploadInputTypeDto>;
  logo?: InputMaybe<FileUploadInputTypeDto>;
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerCreateDto = {
  allowFormalizeProposal: Scalars['Boolean']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  configuration: PartnerConfigurationCreateDto;
  contactPerson?: InputMaybe<ContactPersonCreateDto>;
  discountsException: Array<PartnerDiscountExceptionCreateDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  managerId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  partnershipConditions: PartnershipConditionsCreateDto;
  personType: EPersonType;
  phone: Scalars['String']['input'];
  site?: InputMaybe<Scalars['String']['input']>;
  status: EPartnerStatus;
};

export type PartnerDealershipConditionsListDto = {
  locationUf?: InputMaybe<EBrazilStates>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerDealershipConditionsListSort>;
};

export type PartnerDealershipConditionsListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type PartnerDealershipConditionsMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** dealership conditions */
export type PartnerDealershipConditionsModel = {
  ceilingReferencePercentage: Scalars['Float']['output'];
  customerPFDiscountMax?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountMin?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountOffered?: Maybe<Scalars['Float']['output']>;
  customerPFDiscountSuggested?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountMax?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountMin?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountOffered?: Maybe<Scalars['Float']['output']>;
  customerPJDiscountSuggested?: Maybe<Scalars['Float']['output']>;
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
  uf: Scalars['String']['output'];
};

/** dealership conditions pagination */
export type PartnerDealershipConditionsPaginateModel = {
  data: Array<PartnerDealershipConditionsModel>;
  meta: PartnerDealershipConditionsMetaModel;
};

export type PartnerDeleteDto = {
  _id: Scalars['String']['input'];
};

export type PartnerDiscountExceptionCreateDto = {
  customerPFDiscountMax: Scalars['Float']['input'];
  customerPFDiscountMin: Scalars['Float']['input'];
  customerPFDiscountSuggested: Scalars['Float']['input'];
  customerPJDiscountMax: Scalars['Float']['input'];
  customerPJDiscountMin: Scalars['Float']['input'];
  customerPJDiscountSuggested: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
};

export type PartnerDiscountOfferedCreateDto = {
  customerPFDiscountOffered: Scalars['Float']['input'];
  customerPJDiscountOffered: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
  dealershipName: Scalars['String']['input'];
};

/** partner dealership discount offered */
export type PartnerDiscountOfferedModel = {
  customerPFDiscountOffered: Scalars['Float']['output'];
  customerPJDiscountOffered: Scalars['Float']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
};

export type PartnerDiscountOfferedToUpdateDto = {
  customerPFDiscountOffered: Scalars['Float']['input'];
  customerPJDiscountOffered: Scalars['Float']['input'];
  dealershipId: Scalars['String']['input'];
};

export type PartnerFileUploadModel = {
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  key: Scalars['String']['output'];
  storageService: EStorageService;
};

export type PartnerHistorySchema = {
  action: Scalars['String']['output'];
  newData?: Maybe<Scalars['JSON']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  oldData?: Maybe<Scalars['JSON']['output']>;
  userId: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type PartnerInfoUserModel = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type PartnerListDto = {
  nameDocumentOrPhone?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PartnerListSort>;
};

export type PartnerListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type PartnerLogo = {
  url?: InputMaybe<Scalars['String']['input']>;
};

/** partner managers list */
export type PartnerManagerModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['String']['output']>;
};

export type PartnerManagerSchema = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  partnerId?: Maybe<Scalars['String']['output']>;
};

/** paginate metadata */
export type PartnerMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** partners */
export type PartnerModel = {
  _id: Scalars['ID']['output'];
  allowFormalizeProposal: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  configuration: PartnerConfigurationSchema;
  contactPerson?: Maybe<ContactPersonSchema>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discountsException: Array<DiscountExceptionSchema>;
  discountsOffered: Array<DiscountOfferedSchema>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  history: Array<PartnerHistorySchema>;
  manager?: Maybe<PartnerManagerSchema>;
  name: Scalars['String']['output'];
  partnershipConditions?: Maybe<PartnershipConditionsSchema>;
  personType: EPersonType;
  phone: Scalars['String']['output'];
  site?: Maybe<Scalars['String']['output']>;
  status: EPartnerStatus;
  updatedAt: Scalars['DateTime']['output'];
};

/** partner pagination */
export type PartnerPaginateModel = {
  data: Array<PartnerModel>;
  meta: PartnerMetaModel;
};

export type PartnerRecurringCommissioningParamsSchema = {
  alwaysCommissionedInvoices: Scalars['Boolean']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionedInvoices?: Maybe<Scalars['Float']['output']>;
};

export type PartnerRefInputModel = {
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PartnerRefModel = {
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type PartnerUpdateDto = {
  allowFormalizeProposal?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  configuration?: InputMaybe<PartnerConfigurationUpdateDto>;
  contactPerson?: InputMaybe<ContactPersonUpdateDto>;
  discountsException?: InputMaybe<Array<PartnerDiscountExceptionCreateDto>>;
  discountsOffered?: InputMaybe<Array<PartnerDiscountOfferedCreateDto>>;
  email?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['String']['input'];
  partnershipConditions?: InputMaybe<PartnershipConditionsUpdateDto>;
  phone?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EPartnerStatus>;
};

export type PartnershipConditionsCreateDto = {
  anticipated?: InputMaybe<AnticipatedCommissioningParamsDto>;
  recurring?: InputMaybe<RecurringCommissioningParamsDto>;
};

export type PartnershipConditionsSchema = {
  anticipated?: Maybe<PartnerAnticipatedCommissioningParamsSchema>;
  recurring?: Maybe<PartnerRecurringCommissioningParamsSchema>;
};

export type PartnershipConditionsUpdateDto = {
  anticipated?: InputMaybe<AnticipatedCommissioningUpdateParamsDto>;
  recurring?: InputMaybe<RecurringCommissioningUpdateParamsDto>;
};

export type PaymentInterestAndFineValues = {
  finesPercentage: Scalars['Float']['output'];
  finesValueCents: Scalars['Float']['output'];
  interestPercentage: Scalars['Float']['output'];
  interestValueCents: Scalars['Float']['output'];
};

export type PaymentModel = {
  active: Scalars['Boolean']['output'];
  barcode: Scalars['String']['output'];
  billingType: EBillingType;
  createdAt: Scalars['DateTime']['output'];
  digitableLine: Scalars['String']['output'];
  digitalAccountId: Scalars['String']['output'];
  dueDate: Scalars['DateTime']['output'];
  hasInterestAndFine: Scalars['Boolean']['output'];
  history: Array<History>;
  interestAndFineValues: PaymentInterestAndFineValues;
  invoiceId: Scalars['ID']['output'];
  invoiceKey?: Maybe<Scalars['String']['output']>;
  isInterestAndFineWaived: Scalars['Boolean']['output'];
  paidAt?: Maybe<Scalars['DateTime']['output']>;
  paidValue?: Maybe<Scalars['Float']['output']>;
  pixQrcode?: Maybe<Scalars['String']['output']>;
  pixText?: Maybe<Scalars['String']['output']>;
  secondCopy: Scalars['Boolean']['output'];
  splits: Array<DigitalAccountInvoiceSplitModel>;
  status: EInvoiceStatus;
  template: EInvoiceTemplate;
  unifiedInvoice: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
};

export type PowerGeneratorAreaOutput = {
  /** Generated accessToken of the user */
  accessToken: Scalars['String']['output'];
};

export type PowerGeneratorCreateDto = {
  active: Scalars['Boolean']['input'];
  isDesperta: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  representatives: Array<PowerGeneratorRepresentativeInput>;
};

export type PowerGeneratorDeleteDto = {
  _id: Scalars['String']['input'];
};

export type PowerGeneratorListDto = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  isDesperta?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  representatives?: InputMaybe<Array<PowerGeneratorRepresentativeInput>>;
  sort?: InputMaybe<PowerGeneratorListSort>;
};

export type PowerGeneratorListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

export type PowerGeneratorModel = {
  _id: Scalars['ID']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  isDesperta: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  representatives: Array<PowerGeneratorRepresentativeModel>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PowerGeneratorRepresentativeInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type PowerGeneratorRepresentativeModel = {
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type PowerGeneratorUpdateDto = {
  _id: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  isDesperta?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  representatives?: InputMaybe<Array<PowerGeneratorRepresentativeInput>>;
};

export type PowerPlantCashbackInfoModel = {
  active: Scalars['Boolean']['output'];
};

export type PowerPlantCreateDto = {
  acceptsPF: Scalars['Boolean']['input'];
  acceptsPJ: Scalars['Boolean']['input'];
  accessKeyExtra?: InputMaybe<Scalars['String']['input']>;
  accessKeyLogin?: InputMaybe<Scalars['String']['input']>;
  accessKeyPassword?: InputMaybe<Scalars['String']['input']>;
  address: AddressGraphqlDto;
  clientNumber: Scalars['String']['input'];
  corporateName: Scalars['String']['input'];
  dealershipId: Scalars['String']['input'];
  discountConfiguration?: InputMaybe<PowerPlantDiscountConfigurationCreateDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  generatorId: Scalars['String']['input'];
  installation: Scalars['String']['input'];
  modality?: InputMaybe<EPowerPlantModality>;
  name: Scalars['String']['input'];
  observation: Scalars['String']['input'];
  operationStartDate?: InputMaybe<Scalars['String']['input']>;
  productionKwh: Scalars['Float']['input'];
  productionMwac: Scalars['Float']['input'];
};

export type PowerPlantDeleteDto = {
  _id: Scalars['String']['input'];
};

export type PowerPlantDiscountConfigurationCreateDto = {
  discount: PowerPlantDiscountPersonCreateDto;
  useDealershipDiscountPercentage: Scalars['Boolean']['input'];
};

export type PowerPlantDiscountConfigurationModel = {
  discount: PowerPlantDiscountPersonModel;
  useDealershipDiscountPercentage: Scalars['Boolean']['output'];
};

export type PowerPlantDiscountPersonCreateDto = {
  pf: Scalars['Float']['input'];
  pj: Scalars['Float']['input'];
};

export type PowerPlantDiscountPersonModel = {
  pf: Scalars['Float']['output'];
  pj: Scalars['Float']['output'];
};

export type PowerPlantListDto = {
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PowerPlantListSort>;
};

export type PowerPlantListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type PowerPlantMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** powerPlant */
export type PowerPlantModel = {
  _id: Scalars['ID']['output'];
  acceptsPF: Scalars['Boolean']['output'];
  acceptsPJ: Scalars['Boolean']['output'];
  accessKeyExtra?: Maybe<Scalars['String']['output']>;
  accessKeyLogin?: Maybe<Scalars['String']['output']>;
  accessKeyPassword?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  address?: Maybe<AddressGraphqlModel>;
  cashbackInfo?: Maybe<PowerPlantCashbackInfoModel>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  corporateName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dealershipId: Scalars['String']['output'];
  deletedAt: Scalars['DateTime']['output'];
  discountConfiguration?: Maybe<PowerPlantDiscountConfigurationModel>;
  document?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  generatorId: Scalars['String']['output'];
  installation: Scalars['String']['output'];
  isDesperta: Scalars['Boolean']['output'];
  modality?: Maybe<EPowerPlantModality>;
  name: Scalars['String']['output'];
  observation: Scalars['String']['output'];
  operationStartDate?: Maybe<Scalars['DateTime']['output']>;
  productionKwh: Scalars['Float']['output'];
  productionMwac: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** power plants pagination */
export type PowerPlantPaginateModel = {
  data: Array<PowerPlantModel>;
  meta: PowerPlantMetaModel;
};

export type PowerPlantUpdateDto = {
  _id: Scalars['String']['input'];
  acceptsPF?: InputMaybe<Scalars['Boolean']['input']>;
  acceptsPJ?: InputMaybe<Scalars['Boolean']['input']>;
  accessKeyExtra?: InputMaybe<Scalars['String']['input']>;
  accessKeyLogin?: InputMaybe<Scalars['String']['input']>;
  accessKeyPassword?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<AddressGraphqlDto>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  corporateName?: InputMaybe<Scalars['String']['input']>;
  discountConfiguration?: InputMaybe<PowerPlantDiscountConfigurationCreateDto>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  installation?: InputMaybe<Scalars['String']['input']>;
  modality?: InputMaybe<EPowerPlantModality>;
  name?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  operationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  productionKwh?: InputMaybe<Scalars['Float']['input']>;
  productionMwac?: InputMaybe<Scalars['Float']['input']>;
};

export type PreProposalModel = {
  averageEconomyPercentage: Scalars['Float']['output'];
  averageEnergyBillValue: Scalars['Float']['output'];
  averageMonthSavingValue: Scalars['Float']['output'];
  averageYearSavingValue: Scalars['Float']['output'];
  consumerInKwh?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dealershipId: Scalars['String']['output'];
  dealershipName: Scalars['String']['output'];
  file: BusinessProposalFileModel;
  rateWithTaxesCents?: Maybe<Scalars['Float']['output']>;
  realConsumerValueCents?: Maybe<Scalars['Float']['output']>;
  savingAmountCents?: Maybe<Scalars['Float']['output']>;
  streetLightingCents?: Maybe<Scalars['Float']['output']>;
};

export type ProposalAddEnergyBillInfoGraphqlDto = {
  AmountCents?: InputMaybe<Scalars['Float']['input']>;
  address?: InputMaybe<AddressGraphqlDto>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<ProposalFileCreateGraphqlDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  proposalId: Scalars['String']['input'];
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type ProposalAddLegalRepresentativeGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
};

export type ProposalAddPreProposalGraphqlDto = {
  proposalId: Scalars['String']['input'];
};

export type ProposalAnalysisFilesDto = {
  approve: Scalars['Boolean']['input'];
  legalRepresentativeDocument?: InputMaybe<Scalars['String']['input']>;
  types: Array<EProposalFileType>;
};

export type ProposalCashbackInfoModel = {
  active: Scalars['Boolean']['output'];
  cashbackPercentagePf: Scalars['Float']['output'];
  cashbackPercentagePj: Scalars['Float']['output'];
};

export type ProposalCreateGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  averageEnergyBillValue: Scalars['Float']['input'];
  consortiumId?: InputMaybe<Scalars['String']['input']>;
  dealershipId: Scalars['String']['input'];
  dealershipLogin?: InputMaybe<ProposalDealershipLoginDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  fidelityMonths?: InputMaybe<Scalars['Float']['input']>;
  legalRepresentative?: InputMaybe<Array<CustomerLegalRepresentativeGraphqlDto>>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<EProposalOrigin>;
  personType: EPersonType;
  phone: Scalars['String']['input'];
  uf: Scalars['String']['input'];
  utmInfo?: InputMaybe<UtmInfoDtoGraphql>;
};

export type ProposalCustomerPendencies = {
  averageEnergyBillValue?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['Boolean']['input']>;
  dealershipName?: InputMaybe<Scalars['Boolean']['input']>;
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  nationality?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['Boolean']['input']>;
  uf?: InputMaybe<Scalars['Boolean']['input']>;
  zipcode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalCustomerPendenciesFields = {
  averageEnergyBillValue: CustomerPendencyFields;
  city: CustomerPendencyFields;
  dealershipName: CustomerPendencyFields;
  document: CustomerPendencyFields;
  email: CustomerPendencyFields;
  legalRepresentative: CustomerPendencyFields;
  name: CustomerPendencyFields;
  neighborhood: CustomerPendencyFields;
  nickname: CustomerPendencyFields;
  number: CustomerPendencyFields;
  phone: CustomerPendencyFields;
  state: CustomerPendencyFields;
  street: CustomerPendencyFields;
  uf: CustomerPendencyFields;
  zipcode: CustomerPendencyFields;
};

export type ProposalCustomerRefModel = {
  address?: Maybe<AddressGraphqlModel>;
  averageEnergyBillValue?: Maybe<Scalars['Float']['output']>;
  dealershipId?: Maybe<Scalars['String']['output']>;
  dealershipName?: Maybe<Scalars['String']['output']>;
  document: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hasPendencies?: Maybe<Scalars['Boolean']['output']>;
  legalRepresentative?: Maybe<Array<ProposalLegalRepresentativeModel>>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nationality?: Maybe<Scalars['String']['output']>;
  pendencies?: Maybe<ProposalCustomerPendenciesFields>;
  personType: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  uf?: Maybe<Scalars['String']['output']>;
};

export type ProposalDealershipLoginDto = {
  extraPassword?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ProposalDealershipLoginModel = {
  extraPassword?: Maybe<Scalars['String']['output']>;
  login: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type ProposalFileCreateGraphqlDto = {
  file: FileUploadInputTypeDto;
  status: EProposalFileStatus;
  type: EProposalFileType;
};

export type ProposalFileModel = {
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  analysedBy?: Maybe<Scalars['String']['output']>;
  file?: Maybe<FileUploadModel>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  sendAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<EProposalFileStatus>;
  type?: Maybe<EProposalFileType>;
};

export type ProposalLegalRepresentativeModel = {
  address?: Maybe<AddressGraphqlModel>;
  bank?: Maybe<BankGraphqlModel>;
  document: Scalars['String']['output'];
  email: Scalars['String']['output'];
  files?: Maybe<Array<ProposalFileModel>>;
  identificationNumber?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<EMaritalStatus>;
  name?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  pendencies?: Maybe<ProposalLegalRepresentativePendenciesFields>;
  phone: Scalars['String']['output'];
};

export type ProposalLegalRepresentativePendenciesFields = {
  city: CustomerPendencyFields;
  complement: CustomerPendencyFields;
  customerPjRepresentativeDocumentWithPhotoBack: CustomerPendencyFields;
  customerPjRepresentativeDocumentWithPhotoFront: CustomerPendencyFields;
  document: CustomerPendencyFields;
  email: CustomerPendencyFields;
  name: CustomerPendencyFields;
  neighborhood: CustomerPendencyFields;
  number: CustomerPendencyFields;
  phone: CustomerPendencyFields;
  state: CustomerPendencyFields;
  zipcode: CustomerPendencyFields;
};

export type ProposalLegalRepresentativesPendencies = {
  city?: InputMaybe<Scalars['Boolean']['input']>;
  complement?: InputMaybe<Scalars['Boolean']['input']>;
  customerPjRepresentativeDocumentWithPhotoBack?: InputMaybe<Scalars['Boolean']['input']>;
  customerPjRepresentativeDocumentWithPhotoFront?: InputMaybe<Scalars['Boolean']['input']>;
  document?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  maritalStatus?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  neighborhood?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['Boolean']['input']>;
  zipcode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProposalListDto = {
  averageEnergyBillValueMax?: InputMaybe<Scalars['Int']['input']>;
  averageEnergyBillValueMin?: InputMaybe<Scalars['Int']['input']>;
  createBy?: InputMaybe<JwtUserGraphqlDto>;
  dateRange?: InputMaybe<DateRangeGraphqlSchema>;
  hasAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  hasPendencies?: InputMaybe<Scalars['Boolean']['input']>;
  inOrigin?: InputMaybe<Array<EProposalOrigin>>;
  inPendencies?: InputMaybe<Array<EProposalFilterListPendencies>>;
  inPendenciesStatus?: InputMaybe<Array<EPendenciesStatus>>;
  inStatus?: InputMaybe<Array<EProposalStatus>>;
  nameOrDocument?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  salesFunnelInStage?: InputMaybe<Array<EStage>>;
  sort?: InputMaybe<ProposalListSort>;
};

export type ProposalListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type ProposalMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** proposal */
export type ProposalModel = {
  _id: Scalars['ID']['output'];
  businessProposals: Array<BusinessProposalModel>;
  cashbackInfo?: Maybe<ProposalCashbackInfoModel>;
  consortiumId?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  createBy?: Maybe<JwtUserGraphqlModel>;
  createdAt: Scalars['DateTime']['output'];
  customerIndicationRef?: Maybe<CustomerIndicationReferenceModel>;
  customerRef: ProposalCustomerRefModel;
  dealershipLogin?: Maybe<ProposalDealershipLoginModel>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  energyBillInfo?: Maybe<PropsoalEnergyBillInfo>;
  fidelityMonths?: Maybe<Scalars['Float']['output']>;
  files?: Maybe<Array<ProposalFileModel>>;
  hasAnalysis: Scalars['Boolean']['output'];
  hash: Scalars['String']['output'];
  indicationRef?: Maybe<IndicationRefModel>;
  lossReason?: Maybe<Scalars['String']['output']>;
  monthlyConsumption?: Maybe<ProposalMonthlyConsumption>;
  notes?: Maybe<Array<NoteModel>>;
  origin: EProposalOrigin;
  preProposals?: Maybe<Array<PreProposalModel>>;
  rejectedInfo?: Maybe<RejectInfoModel>;
  salesFunnel?: Maybe<SalesFunnelModel>;
  sellerRef?: Maybe<SellerRefModel>;
  status: EProposalStatus;
  supportRef?: Maybe<SellerRefModel>;
  termOfAdhesion?: Maybe<TermOfAdhesionModel>;
  updatedAt: Scalars['DateTime']['output'];
  utmInfo?: Maybe<ProposalUtmInfo>;
};

export type ProposalMonthlyConsumption = {
  april?: Maybe<Scalars['Int']['output']>;
  august?: Maybe<Scalars['Int']['output']>;
  december?: Maybe<Scalars['Int']['output']>;
  february?: Maybe<Scalars['Int']['output']>;
  january?: Maybe<Scalars['Int']['output']>;
  july?: Maybe<Scalars['Int']['output']>;
  june?: Maybe<Scalars['Int']['output']>;
  march?: Maybe<Scalars['Int']['output']>;
  may?: Maybe<Scalars['Int']['output']>;
  november?: Maybe<Scalars['Int']['output']>;
  october?: Maybe<Scalars['Int']['output']>;
  september?: Maybe<Scalars['Int']['output']>;
};

/** proposals pagination */
export type ProposalPaginateModel = {
  data: Array<ProposalModel>;
  meta: ProposalMetaModel;
};

export type ProposalRemoveLegalRepresentativeGraphqlDto = {
  document: Scalars['String']['input'];
  proposalId: Scalars['String']['input'];
};

export type ProposalSellerModel = {
  changeAt: Scalars['DateTime']['output'];
  changeBy: ESellerChangeBy;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  user?: Maybe<SellerUserModel>;
};

export type ProposalUpdateGraphqlDto = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  averageEnergyBillValue?: InputMaybe<Scalars['Float']['input']>;
  consortiumId?: InputMaybe<Scalars['String']['input']>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipLogin?: InputMaybe<ProposalDealershipLoginDto>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fidelityMonths?: InputMaybe<Scalars['Float']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<EPersonType>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sellerUserId?: InputMaybe<Scalars['String']['input']>;
  supportUserId?: InputMaybe<Scalars['String']['input']>;
  uf?: InputMaybe<Scalars['String']['input']>;
};

export type ProposalUpdateLegalRepresentativeGraphqlDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  documentNumber: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  proposalId: Scalars['String']['input'];
};

export type ProposalUpdateManuallyTermManagement = {
  file: FilesUploadInputGraphqlDto;
  proposalId: Scalars['String']['input'];
};

export type ProposalUpdateManuallyTermManagementApproveDto = {
  approve: Scalars['Boolean']['input'];
  proposalId: Scalars['String']['input'];
  refusedReason?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
};

export type ProposalUtmInfo = {
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

export type PropsoalEnergyBillInfo = {
  AmountCents?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<AddressGraphqlModel>;
  avarageConsumption?: Maybe<Scalars['Float']['output']>;
  clientNumber?: Maybe<Scalars['String']['output']>;
  consumerClassification?: Maybe<EConsumerUnitClassification>;
  dealershipId?: Maybe<Scalars['String']['output']>;
  dealershipName?: Maybe<Scalars['String']['output']>;
  distributionTaxes?: Maybe<Scalars['Float']['output']>;
  energyBillFile?: Maybe<ProposalFileModel>;
  energyTaxes?: Maybe<Scalars['Float']['output']>;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  installationNumber?: Maybe<Scalars['String']['output']>;
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceDueDay?: Maybe<Scalars['Float']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  tariffClassification?: Maybe<ETariffClassification>;
  tension?: Maybe<EConsumerUnitTension>;
  tusdValue?: Maybe<Scalars['Float']['output']>;
};

export type ProviderInvoiceCancelDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['String']['input'];
  reason?: InputMaybe<EInvoiceCancelReason>;
};

export type ProviderInvoiceHistoryModel = {
  action: Scalars['String']['output'];
  ocurredAt: Scalars['DateTime']['output'];
  status: EProviderInvoiceStatus;
};

/** Provider Invoices */
export type ProviderInvoiceModel = {
  _id: Scalars['ID']['output'];
  contractId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customerDocument: Scalars['String']['output'];
  customerId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  digitalAccountInvoiceId?: Maybe<Scalars['String']['output']>;
  hasNewStandardInstallationNumber?: Maybe<Scalars['Boolean']['output']>;
  history: Array<ProviderInvoiceHistoryModel>;
  installationNumber: Scalars['String']['output'];
  installationNumberMigratedAt?: Maybe<Scalars['DateTime']['output']>;
  oldInstallationNumber?: Maybe<Scalars['String']['output']>;
  provider: EProviderInvoice;
  providerData: Scalars['String']['output'];
  reference: ProviderInvoiceReferenceModel;
  status: EProviderInvoiceStatus;
  type: EProviderInvoiceType;
  updatedAt: Scalars['DateTime']['output'];
  valueCents: Scalars['Float']['output'];
};

export type ProviderInvoiceReferenceComposedModel = {
  energyCreditBalanceKwh: Scalars['Float']['output'];
  energyCreditProducedKwh: Scalars['Float']['output'];
  energyCreditUsedKwh: Scalars['Float']['output'];
  energyUsedKwh: Scalars['Float']['output'];
  valueDealershipCents: Scalars['Float']['output'];
  valueDiscountPowerPlantCents: Scalars['Float']['output'];
  valueTotalPowerPlantCents: Scalars['Float']['output'];
};

export type ProviderInvoiceReferenceModel = {
  month: Scalars['String']['output'];
  values: ProviderInvoiceReferenceComposedModel;
  year: Scalars['String']['output'];
};

export type Query = {
  accessControlGet?: Maybe<AccessControlModel>;
  accessControlList: PaginatedAccessControlModel;
  actionList: Array<Scalars['String']['output']>;
  affiliatePartnerGetMe: AffiliatePartnerUserModel;
  affiliatePartnerGetMyPartner: PartnerModel;
  affiliatePartnerUserGet: AffiliatePartnerUserModel;
  affiliatePartnerUserList: AffiliatePartnerUsersPaginateModel;
  calculateAverageConsumption: Scalars['Int']['output'];
  consortiumGet?: Maybe<ConsortiumModel>;
  consortiumList: ConsortiumPaginateModel;
  contractGet?: Maybe<ContractModel>;
  contractList: ContractPaginateModel;
  customerCalculateNewDueDateInvoiceId: InvoiceCalculateNewDueDate;
  customerGet?: Maybe<CustomerModel>;
  customerGetMe: CustomerModel;
  customerInvoicePayWithCashbackAvaliable: CustomerUseCashbackModel;
  customerList: PaginatedCustomerModel;
  customerUserGet: CustomerUserModel;
  customerUserGetMe: CustomerUserModel;
  customerUserGetMyContracts: EnrichedContractPaginateModel;
  customerUserList: CustomerUsersPaginateModel;
  dashboardsGetEmbedInfo: DashboardEmbedInfo;
  dashboardsList: Array<Dashboard>;
  dealershipGet?: Maybe<DealershipModel>;
  dealershipList: DealershipPaginateModel;
  discountTableById?: Maybe<DiscountTableDto>;
  discountTableByList: DiscountTablePaginateDto;
  fileGet: FileModel;
  fileGetByKey: FileModel;
  fileList: FilesPaginateModel;
  getAuthUser: JwtUserTokenGraphql;
  getCommissionMetrics: CommissionMetricsDto;
  getCommissions: CommissionPaginateModel;
  getCustomerInfoByHash?: Maybe<CustomerDigitalAccountInfoDto>;
  getDigitalAccountWalletExtractByCustomerId?: Maybe<PaginatedDigitalAccountWalletExtractModel>;
  getDistributors: DistributorPaginateModel;
  getIndicationById: IndicationModel;
  getIndicationMetrics: IndicationMetricsDto;
  getIndicationRelatedEntitiesById: GetIndicationRelatedEntitiesByIdResponseDto;
  getIndications: IndicationPaginateModel;
  getMyDigitalAccountBalanceCustomerUser?: Maybe<DigitalAccountBalanceModel>;
  getMyDigitalAccountWalletExtractCustomerUser?: Maybe<PaginatedDigitalAccountWalletExtractModel>;
  getPartnerAreaDashboard: EmbedInfo;
  getWalletBalanceByCustomerId?: Maybe<AccountWalletBalanceModel>;
  invoiceList: InvoicePaginateModel;
  modules: Array<ModuleDto>;
  modulesList: Array<Scalars['String']['output']>;
  notificationGet?: Maybe<NotificationModel>;
  notificationList: PaginatedNotificationModel;
  paginateDealershipConditions: PartnerDealershipConditionsPaginateModel;
  partnerAffiliateUserGet: PartnerAffiliateUserModel;
  partnerAffiliateUserList: PartnerAffiliateUsersPaginateModel;
  partnerGet?: Maybe<PartnerModel>;
  partnerGetManagers: Array<PartnerManagerModel>;
  partnerList: PartnerPaginateModel;
  powerGeneratorGet?: Maybe<PowerGeneratorModel>;
  powerGeneratorList: PaginatedPowerGeneratorModel;
  powerPlantGet?: Maybe<PowerPlantModel>;
  powerPlantList: PowerPlantPaginateModel;
  proposalGet?: Maybe<ProposalModel>;
  proposalList: ProposalPaginateModel;
  providerInvoiceSimulateDueDateChange: InvoiceSimulateDueDateChangeModel;
  reenqueueInvoicesWithUnsyncedCommissionStatus: Array<InvoiceModel>;
  sellerGet?: Maybe<SellerModel>;
  sellerList: SellerPaginateModel;
  userGet: UserModel;
  userList: UsersPaginateModel;
};


export type QueryAccessControlGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryAccessControlListArgs = {
  params?: InputMaybe<AccessControlListDto>;
};


export type QueryActionListArgs = {
  module?: InputMaybe<EModule>;
};


export type QueryAffiliatePartnerUserGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryAffiliatePartnerUserListArgs = {
  params?: InputMaybe<AffiliatePartnerUserPaginateArgs>;
};


export type QueryCalculateAverageConsumptionArgs = {
  params: MonthlyConsumptionDto;
};


export type QueryConsortiumGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryConsortiumListArgs = {
  params?: InputMaybe<ConsortiumListDtoGraphql>;
};


export type QueryContractGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryContractListArgs = {
  params?: InputMaybe<ContractListDtoGraphql>;
};


export type QueryCustomerCalculateNewDueDateInvoiceIdArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryCustomerGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerListArgs = {
  params?: InputMaybe<CustomerListGraphqlDto>;
};


export type QueryCustomerUserGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerUserGetMyContractsArgs = {
  filters: GetMyContractsGraphql;
};


export type QueryCustomerUserListArgs = {
  params?: InputMaybe<CustomerUserPaginateArgs>;
};


export type QueryDashboardsGetEmbedInfoArgs = {
  internalId: Scalars['String']['input'];
};


export type QueryDealershipGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryDealershipListArgs = {
  params?: InputMaybe<DealershipListDto>;
};


export type QueryDiscountTableByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryDiscountTableByListArgs = {
  params: DiscountTableListDto;
};


export type QueryFileGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryFileGetByKeyArgs = {
  key: Scalars['String']['input'];
};


export type QueryFileListArgs = {
  params?: InputMaybe<FilePaginateArgs>;
};


export type QueryGetCommissionMetricsArgs = {
  params?: InputMaybe<CommissionMetricsArgs>;
};


export type QueryGetCommissionsArgs = {
  params?: InputMaybe<CommissionPaginateArgs>;
};


export type QueryGetCustomerInfoByHashArgs = {
  hash: Scalars['String']['input'];
};


export type QueryGetDigitalAccountWalletExtractByCustomerIdArgs = {
  customerId: Scalars['String']['input'];
  filters: FilterDigitalAccountWalletExtractGraphqlDto;
};


export type QueryGetDistributorsArgs = {
  params: DistributorListDto;
};


export type QueryGetIndicationByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIndicationMetricsArgs = {
  params?: InputMaybe<IndicationPaginateArgs>;
};


export type QueryGetIndicationRelatedEntitiesByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetIndicationsArgs = {
  params?: InputMaybe<IndicationPaginateArgs>;
};


export type QueryGetMyDigitalAccountWalletExtractCustomerUserArgs = {
  filters: FilterDigitalAccountWalletExtractGraphqlDto;
};


export type QueryGetWalletBalanceByCustomerIdArgs = {
  customerId: Scalars['String']['input'];
};


export type QueryInvoiceListArgs = {
  params?: InputMaybe<InvoiceListDto>;
};


export type QueryNotificationGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationListArgs = {
  params?: InputMaybe<NotificationListDto>;
};


export type QueryPaginateDealershipConditionsArgs = {
  params?: InputMaybe<PartnerDealershipConditionsListDto>;
};


export type QueryPartnerAffiliateUserGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerAffiliateUserListArgs = {
  params?: InputMaybe<PartnerAffiliateUserListDto>;
};


export type QueryPartnerGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerListArgs = {
  params?: InputMaybe<PartnerListDto>;
};


export type QueryPowerGeneratorGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryPowerGeneratorListArgs = {
  params?: InputMaybe<PowerGeneratorListDto>;
};


export type QueryPowerPlantGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryPowerPlantListArgs = {
  params?: InputMaybe<PowerPlantListDto>;
};


export type QueryProposalGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryProposalListArgs = {
  params?: InputMaybe<ProposalListDto>;
};


export type QueryProviderInvoiceSimulateDueDateChangeArgs = {
  params: ContractInvoiceSimulateDueDateChangeDto;
};


export type QuerySellerGetArgs = {
  id: Scalars['String']['input'];
};


export type QuerySellerListArgs = {
  params?: InputMaybe<SellerListDto>;
};


export type QueryUserGetArgs = {
  id: Scalars['String']['input'];
};


export type QueryUserListArgs = {
  params?: InputMaybe<UserPaginateArgs>;
};

export type RecoverPasswordChangeInput = {
  newPassword: Scalars['String']['input'];
  retypeNewPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RecoverPasswordInput = {
  email: Scalars['String']['input'];
};

/** recoverPassword */
export type RecoverPasswordModel = {
  _id: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  status: EPasswordRecoverStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userRef: UserRefModel;
};

export type RecurringCommissionResponseDto = {
  additionalCommissionPercentage: Scalars['Float']['output'];
  baseCommissionPercentage: Scalars['Float']['output'];
  commissionAmountPercentage: Scalars['Float']['output'];
};

export type RecurringCommissioningParamsDto = {
  alwaysCommissionedInvoices: Scalars['Boolean']['input'];
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionedInvoices?: InputMaybe<Scalars['Float']['input']>;
};

export type RecurringCommissioningUpdateParamsDto = {
  alwaysCommissionedInvoices: Scalars['Boolean']['input'];
  baseCommissionPercentage: Scalars['Float']['input'];
  commissionedInvoices?: InputMaybe<Scalars['Float']['input']>;
};

export type ReferenceOrderModel = {
  month: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export type RejectInfoModel = {
  reason?: Maybe<Scalars['String']['output']>;
  rejectedAt: Scalars['DateTime']['output'];
  rejectedBy: JwtUserGraphqlModel;
};

export type ReportExternalPaymentDto = {
  finesAmountCents?: InputMaybe<Scalars['Float']['input']>;
  finesAndInterestWereCharged: Scalars['Boolean']['input'];
  finesPercentage?: InputMaybe<Scalars['Float']['input']>;
  interestAmountCents?: InputMaybe<Scalars['Float']['input']>;
  interestPercentage?: InputMaybe<Scalars['Float']['input']>;
  invoiceId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paidAmountCents: Scalars['Float']['input'];
  paymentDate: Scalars['DateTime']['input'];
};

export type RewardCreateDto = {
  history: Array<RewardHistoryUpdateDto>;
  percent: Scalars['Float']['input'];
  type: ERewardType;
};

export type RewardHistoryModel = {
  description: Scalars['String']['output'];
  ocurredAt: Scalars['DateTime']['output'];
};

export type RewardHistoryUpdateDto = {
  description: Scalars['String']['input'];
  ocurredAt: Scalars['DateTime']['input'];
};

export type RewardModel = {
  history?: Maybe<Array<RewardHistoryModel>>;
  percent: Scalars['Float']['output'];
  type: ERewardType;
};

export type RewardUpdateDto = {
  history?: InputMaybe<Array<RewardHistoryUpdateDto>>;
  percent: Scalars['Float']['input'];
  type: ERewardType;
};

export type SalesFunnelBase = {
  changedBy: EChangedBy;
  date: Scalars['DateTime']['output'];
  stage: EStage;
  user?: Maybe<Scalars['String']['output']>;
};

export type SalesFunnelModel = {
  changedBy: EChangedBy;
  date: Scalars['DateTime']['output'];
  history: Array<SalesFunnelBase>;
  stage: EStage;
  user?: Maybe<Scalars['String']['output']>;
};

export type SalesmanRefInputModel = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type SalesmanRefModel = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SellerCreateDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SellerDeleteDto = {
  _id: Scalars['String']['input'];
};

export type SellerListDto = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
  sort?: InputMaybe<SellerListSort>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SellerListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type SellerMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** sellers */
export type SellerModel = {
  _id: Scalars['ID']['output'];
  address?: Maybe<AddressGraphqlModel>;
  bank?: Maybe<BankGraphqlModel>;
  bankAccount: Scalars['String']['output'];
  bankAgency: Scalars['String']['output'];
  birthDate: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  documentNumber: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['String']['output'];
};

/** sellers pagination */
export type SellerPaginateModel = {
  data: Array<SellerModel>;
  meta: SellerMetaModel;
};

export type SellerRefModel = {
  changeAt: Scalars['DateTime']['output'];
  changeBy: ESellerChangeBy;
  email: Scalars['String']['output'];
  history: Array<ProposalSellerModel>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  user?: Maybe<SellerUserModel>;
};

export type SellerUpdateDto = {
  _id: Scalars['String']['input'];
  address?: InputMaybe<AddressGraphqlDto>;
  bank?: InputMaybe<BankGraphqlDto>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SellerUserModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SendContractToSignDtoGraphql = {
  contractId: Scalars['String']['input'];
};

export type SendPushNotificationDto = {
  badge?: InputMaybe<Scalars['Float']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<Scalars['JSONObject']['input']>;
  mutableContent?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sound?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  to: Array<SendPushNotificationTo>;
  ttl?: InputMaybe<Scalars['Float']['input']>;
  /** type of push notification */
  type: Scalars['String']['input'];
};

export type SendPushNotificationTo = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  token?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SingleAccountHitoryCustomerAreaModel = {
  active: Scalars['Boolean']['output'];
  adhesionAt?: Maybe<Scalars['DateTime']['output']>;
  adhesionBy?: Maybe<EAdhesionBySingleAccount>;
  adhesionResponsibility?: Maybe<Scalars['String']['output']>;
  ocurredAt: Scalars['DateTime']['output'];
};

export type SingleAccountHitoryModel = {
  active: Scalars['Boolean']['output'];
  adhesionAt?: Maybe<Scalars['DateTime']['output']>;
  adhesionBy?: Maybe<EAdhesionBySingleAccount>;
  adhesionResponsibility?: Maybe<Scalars['String']['output']>;
  ocurredAt: Scalars['DateTime']['output'];
};

export type SolveProposalCustomerPendenciesGraphqlDto = {
  pendencies: Array<EProposalCustomerPendencies>;
  proposalId: Scalars['String']['input'];
};

export type SolveProposalLegalRepresentantPendenciesGraphqlDto = {
  document: Scalars['String']['input'];
  pendencies: Array<EProposalLegalRepresentantPendencies>;
  proposalId: Scalars['String']['input'];
};

export type SpecialDiscountCreateDto = {
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['Float']['input'];
};

export type SpecialDiscountModel = {
  discountPercent: Scalars['Float']['output'];
  month: Scalars['Float']['output'];
};

export type SpecialDiscountUpdateDto = {
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['Float']['input'];
};

export type TermOfAdhesionModel = {
  _id: Scalars['String']['output'];
  approveManual?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  manualOrAutomatic?: Maybe<ETermOfManagementType>;
  name: Scalars['String']['output'];
  refusedReason?: Maybe<Scalars['String']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  signedDocumentUrl?: Maybe<Scalars['String']['output']>;
  signerEmail?: Maybe<Scalars['String']['output']>;
  signerUrl?: Maybe<Scalars['String']['output']>;
  signers: Array<DocumentSignerModel>;
  status: EDocumentSignStatus;
  updatedAt: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type TermOfManagementCreateGraphqlDto = {
  active: Scalars['Boolean']['input'];
  canceledAt?: InputMaybe<Scalars['String']['input']>;
  canceledBy?: InputMaybe<Scalars['String']['input']>;
  createdAt: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  documentSignId?: InputMaybe<Scalars['String']['input']>;
  file: ContractFileCreateDto;
  origin: Scalars['String']['input'];
  replaced: Scalars['Boolean']['input'];
  signatureLink: Scalars['String']['input'];
  signedAt?: InputMaybe<Scalars['String']['input']>;
  signerEmail?: InputMaybe<Scalars['String']['input']>;
  status: ETermStatus;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type TrackOperationResModel = {
  geoLocation?: Maybe<GeoLocationResModel>;
  ip: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  owner: OwnerResModel;
};

export type UpdateDiscountDto = {
  /** Informar valor entre 0 e 100 % */
  discountPercentage?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EDiscountTableType>;
};

export type UpdateIndicationDealershipLoginDto = {
  extraPassword?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type UpdateIndicationEnergyBillInfoDto = {
  AmountCents: Scalars['Float']['input'];
  address?: InputMaybe<AddressDto>;
  avarageConsumption?: InputMaybe<Scalars['Float']['input']>;
  clientNumber?: InputMaybe<Scalars['String']['input']>;
  consumerClassification?: InputMaybe<EConsumerUnitClassification>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipName?: InputMaybe<Scalars['String']['input']>;
  distributionTaxes?: InputMaybe<Scalars['Float']['input']>;
  energyBillFile?: InputMaybe<IndicationProposalFileDto>;
  energyTaxes?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['String']['input'];
  installationNumber?: InputMaybe<Scalars['String']['input']>;
  invoiceDueDay?: InputMaybe<Scalars['Float']['input']>;
  tariffClassification?: InputMaybe<ETariffClassification>;
  tension?: InputMaybe<EConsumerUnitTension>;
  tusdValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateIndicationFilesDto = {
  file: FilesUploadInputGraphqlDto;
  id: Scalars['String']['input'];
  legalRepresentativeDocument?: InputMaybe<Scalars['String']['input']>;
  type: EProposalFileType;
};

export type UpdateIndicationLegalRepresentativeFileGraphqlDto = {
  file?: InputMaybe<FilesUploadInputGraphqlDto>;
  sendAt: Scalars['DateTime']['input'];
  status?: InputMaybe<ECustomerFileStatus>;
  type?: InputMaybe<ECustomerFileType>;
};

export type UpdateIndicationLegalRepresentativeGraphqlDto = {
  id: Scalars['String']['input'];
  legalRepresentatives: Array<UpdateLegalRepresentativeIndicationDto>;
};

export type UpdateIndicationPartnerDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  averageEnergyBillValueCents?: InputMaybe<Scalars['Float']['input']>;
  customerDiscountOffered?: InputMaybe<Scalars['Float']['input']>;
  dealerShipName?: InputMaybe<Scalars['String']['input']>;
  dealershipId?: InputMaybe<Scalars['String']['input']>;
  dealershipLogin?: InputMaybe<UpdateIndicationDealershipLoginDto>;
  document?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  maritalStatus?: InputMaybe<EMaritalStatus>;
  monthlyConsumption?: InputMaybe<MonthlyConsumptionDto>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  personType?: InputMaybe<EPersonType>;
  phone?: InputMaybe<Scalars['String']['input']>;
  uf?: InputMaybe<Scalars['String']['input']>;
};

/** Update invoices to externalNegotiation status error */
export type UpdateInvoiceToExternalNegotiationErrorModel = {
  error: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Update invoices to externalNegotiation status */
export type UpdateInvoiceToExternalNegotiationModel = {
  notUpdated: Array<UpdateInvoiceToExternalNegotiationErrorModel>;
  updated?: Maybe<Array<Scalars['String']['output']>>;
};

export type UpdateLegalRepresentativeIndicationDto = {
  address?: InputMaybe<AddressGraphqlDto>;
  document: Scalars['String']['input'];
  email: Scalars['String']['input'];
  files?: InputMaybe<Array<UpdateIndicationLegalRepresentativeFileGraphqlDto>>;
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<EMaritalStatus>;
  name: Scalars['String']['input'];
  nationality?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type UpdatePartnerDefaultConfigurationDto = {
  allowAffiliateLink: Scalars['Boolean']['input'];
  allowManualProposal: Scalars['Boolean']['input'];
};

export type UpdatePartnerDiscountOfferedDto = {
  discountOffered: PartnerDiscountOfferedToUpdateDto;
};

export type UpdatePartnerWebhookDto = {
  url: Scalars['String']['input'];
};

export type UpdateSalesFunnelStageDto = {
  lossReason?: InputMaybe<ELossReason>;
  newStage: EStage;
  proposalId: Scalars['String']['input'];
};

/** User Access control */
export type UserAccessControl = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserAccessControlGraphql = {
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type UserCreateInput = {
  /** access control id of the user */
  accessControlId: Scalars['String']['input'];
  /** access control name of the user */
  accessControlName: Scalars['String']['input'];
  /** username of the user */
  email: Scalars['String']['input'];
  /** name of the user */
  name: Scalars['String']['input'];
  /** password of the user */
  password: Scalars['String']['input'];
  /** phone of the user */
  phone: Scalars['String']['input'];
  /** status of the user */
  status: Scalars['String']['input'];
  /** type of user */
  type: Scalars['String']['input'];
  /** username of the user */
  username: Scalars['String']['input'];
};

export type UserCustomerRefModel = {
  document: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  personType: EPersonType;
  phone?: Maybe<Scalars['String']['output']>;
};

export type UserFilterArgs = {
  accessControlId?: InputMaybe<Array<Scalars['String']['input']>>;
  nameOrUsernameOrEmail?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EUserStatus>;
};

export type UserListSort = {
  field: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** paginate metadata */
export type UserMetaModel = {
  currentPage: Scalars['Int']['output'];
  documentCounts: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
};

/** user */
export type UserModel = {
  _id: Scalars['ID']['output'];
  accessControlRef: UserAccessControl;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  status: EUserStatus;
  type?: Maybe<EUserType>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type UserPaginateArgs = {
  filter?: InputMaybe<UserFilterArgs>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<UserListSort>;
};

export type UserRefModel = {
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type UserUpdateInput = {
  /** access control id of the user */
  accessControlId?: InputMaybe<Scalars['String']['input']>;
  /** access control name of the user */
  accessControlName?: InputMaybe<Scalars['String']['input']>;
  /** username of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** name of the user */
  name?: InputMaybe<Scalars['String']['input']>;
  /** phone of the user */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** status of the user */
  status?: InputMaybe<Scalars['String']['input']>;
  /** type of user */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** users pagination */
export type UsersPaginateModel = {
  data: Array<UserModel>;
  meta: UserMetaModel;
};

export type UtmInfoDtoGraphql = {
  utm_campaign: Scalars['String']['input'];
  utm_content: Scalars['String']['input'];
  utm_medium: Scalars['String']['input'];
  utm_source: Scalars['String']['input'];
  utm_term: Scalars['String']['input'];
};

export type AffiliatePartnerUserChangePasswordMutationVariables = Exact<{
  params: AffiliatePartnerUserRecoverPasswordChangeInput;
}>;


export type AffiliatePartnerUserChangePasswordMutation = { affiliatePartnerUserChangePassword: { _id: string } };

export type AffiliatePartnerUserRecoverPasswordMutationVariables = Exact<{
  params: AffiliatePartnerUserRecoverPasswordInput;
}>;


export type AffiliatePartnerUserRecoverPasswordMutation = { affiliatePartnerUserRecoverPassword?: { _id: string } | null };

export type CalculateCommissionMutationVariables = Exact<{
  params: CalculateCommissionParamsDto;
}>;


export type CalculateCommissionMutation = { calculateCommission: { anticipated?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number } | null, recurring?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number } | null } };

export type ContractUpdateMutationVariables = Exact<{
  params: ContractUpdateDtoGraphql;
}>;


export type ContractUpdateMutation = { contractUpdate: { _id: string, billingType?: EBillingType | null, previousGenerationBalance?: number | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null } };

export type ContractUpdateEnergyBillInfoMutationVariables = Exact<{
  params: ContractUpdateEnergyBillInfo;
}>;


export type ContractUpdateEnergyBillInfoMutation = { contractUpdateEnergyBillInfo: { _id: string, previousGenerationBalance?: number | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null } };

export type CreateAffiliatePartnerUserMutationVariables = Exact<{
  params: AffiliatePartnerUserCreateInput;
}>;


export type CreateAffiliatePartnerUserMutation = { createAffiliatePartnerUser: { _id: string, name: string, email: string, phone?: string | null, status: EAffiliatePartnerUserStatus, createdAt: any } };

export type CreateIndicationMutationVariables = Exact<{
  params: CreateIndicationPartnerDto;
}>;


export type CreateIndicationMutation = { createIndication: { _id: string, status: EIndicationStatus, averageEnergyBillValueCents: number, origin: EIndicationOrigin, createdAt: any, updatedAt: any, metadata: { preProposalFileKey?: string | null }, salesmanRef: { name: string }, customerRef: { name: string } } };

export type CustomerUpdateByIdMutationVariables = Exact<{
  id: Scalars['String']['input'];
  params: CustomerUpdateGraphqlDto;
}>;


export type CustomerUpdateByIdMutation = { customerUpdateById: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, bank?: { account: string, agency: string, code: string, type: EBankAccountType } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } };

export type CustomerUpdateLegalRepresentantMutationVariables = Exact<{
  params: LegalRepresentativeUpdateGraphqlDto;
}>;


export type CustomerUpdateLegalRepresentantMutation = { customerUpdateLegalRepresentant: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, bank?: { account: string, agency: string, code: string, type: EBankAccountType } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, identificationNumber?: string | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } };

export type FormalizeIndicationProposalMutationVariables = Exact<{
  indicationId: Scalars['String']['input'];
}>;


export type FormalizeIndicationProposalMutation = { formalizeIndicationProposal: { status: EProposalStatus, consortiumId?: string | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, refusedReason?: string | null, approveManual?: boolean | null, manualOrAutomatic?: ETermOfManagementType | null, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null } };

export type LoginAffiliatePartnerUserMutationVariables = Exact<{
  params: AuthAffiliatePartnerUserArgs;
}>;


export type LoginAffiliatePartnerUserMutation = { loginAffiliatePartnerUser: { accessToken: string } };

export type RegenerateApiKeyFromPartnerMutationVariables = Exact<{ [key: string]: never; }>;


export type RegenerateApiKeyFromPartnerMutation = { regenerateApiKeyFromPartner: { configuration: { apiKey?: string | null } } };

export type SolveProposalCustomerPendenciesMutationVariables = Exact<{
  params: SolveProposalCustomerPendenciesGraphqlDto;
}>;


export type SolveProposalCustomerPendenciesMutation = { solveProposalCustomerPendencies: { customerRef: { pendencies?: { averageEnergyBillValue: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, city: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, document: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, email: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, name: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, neighborhood: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, number: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, phone: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, state: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, street: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, uf: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, zipcode: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null } } | null } } };

export type UpdateAffiliatePartnerUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  params: AffiliatePartnerUserUpdateInput;
}>;


export type UpdateAffiliatePartnerUserMutation = { updateAffiliatePartnerUser: { _id: string, name: string, email: string, phone?: string | null, status: EAffiliatePartnerUserStatus, createdAt: any } };

export type UpdateAffiliatePartnerUserApprovedMutationVariables = Exact<{
  id: Scalars['String']['input'];
  userUpdateInput: AffiliatePartnerUserApprovedUpdateInput;
}>;


export type UpdateAffiliatePartnerUserApprovedMutation = { updateAffiliatePartnerUserApproved: { _id: string, email: string, accessStatus: EAffiliatePartnerUserAccessStatus } };

export type UpdateIndicationMutationVariables = Exact<{
  params: UpdateIndicationPartnerDto;
}>;


export type UpdateIndicationMutation = { updateIndication: { _id: string, status: EIndicationStatus, metadata: { preProposalFileKey?: string | null }, condition?: { dealershipId: string, dealershipName: string } | null, customerRef: { name: string, document: string, email: string, phone: string, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } } };

export type UpdateIndicationAddEnergyBillInfoMutationVariables = Exact<{
  params: UpdateIndicationEnergyBillInfoDto;
}>;


export type UpdateIndicationAddEnergyBillInfoMutation = { updateIndicationAddEnergyBillInfo: boolean };

export type UpdateIndicationFilesMutationVariables = Exact<{
  params: UpdateIndicationFilesDto;
}>;


export type UpdateIndicationFilesMutation = { updateIndicationFiles: boolean };

export type UpdateIndicationLegalRepresentativesMutationVariables = Exact<{
  params: UpdateIndicationLegalRepresentativeGraphqlDto;
}>;


export type UpdateIndicationLegalRepresentativesMutation = { updateIndicationLegalRepresentatives: boolean };

export type UpdatePartnerAreaPartnerIconeMutationVariables = Exact<{
  params: FileUploadInputTypeDto;
}>;


export type UpdatePartnerAreaPartnerIconeMutation = { updatePartnerAreaPartnerIcone: { configuration: { icone?: { fileUrl: string } | null } } };

export type UpdatePartnerAreaPartnerLogoMutationVariables = Exact<{
  params: FileUploadInputTypeDto;
}>;


export type UpdatePartnerAreaPartnerLogoMutation = { updatePartnerAreaPartnerLogo: { configuration: { logo?: { fileUrl: string } | null } } };

export type UpdatePartnerDefaultConfigurationMutationVariables = Exact<{
  params: UpdatePartnerDefaultConfigurationDto;
}>;


export type UpdatePartnerDefaultConfigurationMutation = { updatePartnerDefaultConfiguration: { configuration: { allowAffiliateLink: boolean, allowManualProposal: boolean } } };

export type UpdatePartnerDiscountsOfferedMutationVariables = Exact<{
  params: UpdatePartnerDiscountOfferedDto;
}>;


export type UpdatePartnerDiscountsOfferedMutation = { updatePartnerDiscountsOffered: { customerPFDiscountOffered: number, customerPJDiscountOffered: number, dealershipId: string, dealershipName: string } };

export type UpdatePartnerWebhookMutationVariables = Exact<{
  params: UpdatePartnerWebhookDto;
}>;


export type UpdatePartnerWebhookMutation = { updatePartnerWebhook: { configuration: { webhookUrl?: string | null } } };

export type AffiliatePartnerGetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type AffiliatePartnerGetMeQuery = { affiliatePartnerGetMe: { _id: string, email: string, name: string, phone?: string | null, createdAt: any, type?: EUserType | null, status: EAffiliatePartnerUserStatus, updatedAt: any, owner: boolean, partnerRef?: { id: string, name: string } | null } };

export type AffiliatePartnerGetMyPartnerQueryVariables = Exact<{ [key: string]: never; }>;


export type AffiliatePartnerGetMyPartnerQuery = { affiliatePartnerGetMyPartner: { _id: string, site?: string | null, allowFormalizeProposal: boolean, status: EPartnerStatus, name: string, createdAt: any, document: string, email: string, phone: string, code?: string | null, contactPerson?: { email: string, name: string, phone: string } | null, partnershipConditions?: { recurring?: { alwaysCommissionedInvoices: boolean, baseCommissionPercentage: number, commissionedInvoices?: number | null } | null, anticipated?: { baseCommissionPercentage: number, commissionedInvoices: number, commissionExceptionGroups: Array<{ baseCommissionPercentage: number, commissionedInvoices: number, dealerships: Array<string>, id: string }> } | null } | null, configuration: { allowAffiliateLink: boolean, allowManualProposal: boolean, apiKey?: string | null, webhookUrl?: string | null, icone?: { fileUrl: string } | null, logo?: { fileUrl: string } | null } } };

export type AffiliatePartnerUserGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AffiliatePartnerUserGetQuery = { affiliatePartnerUserGet: { _id: string, name: string, email: string, phone?: string | null, cpf?: string | null, status: EAffiliatePartnerUserStatus, accessStatus: EAffiliatePartnerUserAccessStatus, captureSource?: string | null, linkedin?: string | null, facebook?: string | null, instagram?: string | null, site?: string | null, createdAt: any, address?: { zipcode: string, street: string, number: string, neighborhood: string, complement?: string | null, city: string, state: string, country: string } | null, professionalHistory: Array<{ companyName?: string | null, role?: string | null, segment?: string | null, observation?: string | null }>, files: Array<{ type: EAffiliatePartnerUserFileType, file: { key: string, fileName: string, fileUrl: string } }> } };

export type AffiliatePartnerUserListQueryVariables = Exact<{
  params?: InputMaybe<AffiliatePartnerUserPaginateArgs>;
}>;


export type AffiliatePartnerUserListQuery = { affiliatePartnerUserList: { data: Array<{ _id: string, name: string, email: string, phone?: string | null, status: EAffiliatePartnerUserStatus }>, meta: { currentPage: number, documentCounts: number, pageSize: number } } };

export type CustomerGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CustomerGetQuery = { customerGet?: { _id: string, uf?: string | null, name: string, phone: string, email: string, status: ECustomerStatus, document: string, createdAt: any, personType: EPersonType, digitalAccount?: { id?: string | null, name: string, status: string } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, legalRepresentatives?: Array<{ name?: string | null, email: string, phone: string, document?: string | null, identificationNumber?: string | null, bank?: { code: string, type: EBankAccountType, account: string, agency: string } | null, address?: { city: string, state: string, number: string, street: string, zipcode: string, complement?: string | null, neighborhood: string } | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null }> | null, files?: Array<{ sendAt?: string | null, status?: ECustomerFileStatus | null, type?: ECustomerFileType | null, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null, bank?: { code: string, type: EBankAccountType, account: string, agency: string } | null } | null };

export type DealershipGetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DealershipGetQuery = { dealershipGet?: { _id: string, needLoginDealership: boolean, name?: string | null, distributorId?: string | null, locationUf?: string | null, maxDiscountPercentagePf?: number | null, maxDiscountPercentagePj?: number | null, available: boolean, resolutionAneel?: { linkUrl: string, modality?: EDealershipResolutionModality | null, resolutionHomologed: string, validity: string } | null, resolutionClasses: Array<{ class: EDealershipResolutuionClass, cofinsPercentage: number, fcp?: number | null, icmsPercentage: number, pisPercentage: number, teValueCents: number, tusdValueCents: number, wireBCalculationBaseValueCents?: number | null }>, minimumExceptionValue?: { value: number, allowException: boolean } | null, partnerBenefitToCustomer: { customerPFDiscountMax?: number | null, customerPFDiscountMin?: number | null, customerPJDiscountMax?: number | null, customerPJDiscountMin?: number | null, customerPFDiscountSuggested?: number | null, customerPJDiscountSuggested?: number | null } } | null };

export type DealershipListQueryVariables = Exact<{
  params?: InputMaybe<DealershipListDto>;
}>;


export type DealershipListQuery = { dealershipList: { meta: { currentPage: number, documentCounts: number, pageSize: number }, data: Array<{ _id: string, name?: string | null, locationUf?: string | null, maxDiscountPercentagePf?: number | null, maxDiscountPercentagePj?: number | null, available: boolean, partnerBenefitToCustomer: { customerPFDiscountMax?: number | null, customerPFDiscountMin?: number | null, customerPFDiscountSuggested?: number | null, customerPJDiscountMax?: number | null, customerPJDiscountMin?: number | null, customerPJDiscountSuggested?: number | null }, minimumExceptionValue?: { value: number, allowException: boolean } | null }> } };

export type GetCommissionsWithMetricsQueryVariables = Exact<{
  params?: InputMaybe<CommissionPaginateArgs>;
  metricParams?: InputMaybe<CommissionMetricsArgs>;
}>;


export type GetCommissionsWithMetricsQuery = { getCommissions: { data: Array<{ _id: string, createdAt: any, dueDate: any, status: ECommissionStatus, valueCents: number, indicationRef: { salesman: { id: string, name: string } } }>, meta: { currentPage: number, documentCounts: number, pageSize: number } }, getCommissionMetrics: { expectedRevenueCents: number, receivableRevenueCents: number } };

export type GetCommissionsQueryVariables = Exact<{
  params?: InputMaybe<CommissionPaginateArgs>;
}>;


export type GetCommissionsQuery = { getCommissions: { data: Array<{ _id: string, createdAt: any, dueDate: any, status: ECommissionStatus, valueCents: number, indicationRef: { salesman: { id: string, name: string } } }>, meta: { currentPage: number, documentCounts: number, pageSize: number } } };

export type GetCommissionMetricsQueryVariables = Exact<{
  params?: InputMaybe<CommissionMetricsArgs>;
}>;


export type GetCommissionMetricsQuery = { getCommissionMetrics: { expectedRevenueCents: number, receivableRevenueCents: number } };

export type GetIndicationProposalByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetIndicationProposalByIdQuery = { getIndicationRelatedEntitiesById: { contract?: { _id: string, isDocumentsAudited: boolean, cancellationRequestedAt?: any | null, cancellationRequestedBy?: string | null, previousGenerationBalance?: number | null, billingType?: EBillingType | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, activatedAt?: any | null, activatedBy?: string | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType, email?: string | null, phone?: string | null, legalRepresentatives?: Array<{ document: string, email: string, name: string, phone: string, files?: Array<{ acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null, status: EProposalFileStatus, type: EProposalFileType, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null, pendencies?: { city: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, complement: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, document: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, email: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, name: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, neighborhood: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, number: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, phone: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, state: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, zipCode: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null } } | null }> | null, pendencies?: { city: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, email: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, name: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, neighborhood: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, number: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, phone: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, state: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, street: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, zipCode: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, uf: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null } } | null }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, type?: ETermOfManagementType | null, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, uuid?: string | null, refusedReason?: string | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null, indicationRef?: { expired?: boolean | null, id: string, type: EIndicationType, condition?: { customerDiscountMax: number, customerDiscountMin: number, customerDiscountOffered: number, customerDiscountSuggested: number, dealershipId: string, dealershipName: string, uf: string, anticipated?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionExceptionGroupId?: string | null, commissionedInvoices: number } | null, recurring?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, alwaysCommissionedInvoices: boolean, commissionedInvoices?: number | null } | null } | null, partner?: { document: string, email: string, id: string, name: string, phone: string } | null, salesman: { id: string, name: string } } | null, customerIndicationRef?: { customerId: string, customerName: string } | null, files?: Array<{ acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null, status: EProposalFileStatus, type: EProposalFileType, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } | null, proposal?: { _id: string, status: EProposalStatus, createdAt: any, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, customerRef: { personType: string, name: string, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, legalRepresentative?: Array<{ name?: string | null, document: string, identificationNumber?: string | null, email: string, phone: string, pendencies?: { name: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, document: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, email: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, phone: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, zipcode: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, number: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, complement: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, neighborhood: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, city: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, state: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null } } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, rejectedAt?: any | null, analysedBy?: string | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string } | null }> | null }> | null, pendencies?: { dealershipName: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, averageEnergyBillValue: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, city: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, document: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, email: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, name: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, neighborhood: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, number: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, phone: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, state: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, street: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, uf: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null }, zipcode: { acceptedAt?: any | null, rejectedAt?: any | null, sendedAt?: any | null } } | null }, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, indicationRef?: { partner?: { name: string } | null, salesman: { name: string } } | null, createBy?: { name: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string } | null }> | null } | null } };

export type GetIndicationsQueryVariables = Exact<{
  params?: InputMaybe<IndicationPaginateArgs>;
}>;


export type GetIndicationsQuery = { getIndications: { data: Array<{ _id: string, status: EIndicationStatus, averageEnergyBillValueCents: number, origin: EIndicationOrigin, createdAt: any, updatedAt: any, errorMessage?: string | null, metadata: { preProposalFileKey?: string | null }, salesmanRef: { name: string }, customerRef: { name: string } }>, meta: { currentPage: number, documentCounts: number, pageSize: number } } };

export type GetIndicationsCsvQueryVariables = Exact<{
  params?: InputMaybe<IndicationPaginateArgs>;
}>;


export type GetIndicationsCsvQuery = { getIndications: { data: Array<{ status: EIndicationStatus, averageEnergyBillValueCents: number, origin: EIndicationOrigin, createdAt: any, updatedAt: any, errorMessage?: string | null, condition?: { uf: string, dealershipName: string, anticipated?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionExceptionGroupId?: string | null, commissionedInvoices: number } | null } | null, salesmanRef: { name: string }, customerRef: { name: string } }>, meta: { currentPage: number, documentCounts: number, pageSize: number } } };

export type GetPartnerAreaDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPartnerAreaDashboardQuery = { getPartnerAreaDashboard: { embedToken: string, embedUrl: string, reportId: string } };

export type GetProposalAndIndicationByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetProposalAndIndicationByIdQuery = { getIndicationById: { _id: string, status: EIndicationStatus, averageEnergyBillValueCents: number, condition?: { uf: string, dealershipId: string, dealershipName: string, customerDiscountOffered: number, recurring?: { additionalCommissionPercentage: number, alwaysCommissionedInvoices: boolean, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionedInvoices?: number | null } | null, anticipated?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionExceptionGroupId?: string | null, commissionedInvoices: number } | null } | null, customerRef: { name: string, document: string, email: string, phone: string, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } }, getIndicationRelatedEntitiesById: { contract?: { _id: string, isDocumentsAudited: boolean, cancellationRequestedAt?: any | null, cancellationRequestedBy?: string | null, previousGenerationBalance?: number | null, billingType?: EBillingType | null, consortiumId?: string | null, contractType?: Array<string> | null, contractedSharePercent?: number | null, createdAt?: any | null, customerId: string, fidelityMonths?: number | null, gracePeriodMonths?: number | null, participationKwh?: number | null, powerPlantId?: string | null, powerGeneratorId?: string | null, proposalId?: string | null, signDate?: any | null, status?: EContractStatus | null, updatedAt?: any | null, validityMonths?: number | null, activatedAt?: any | null, activatedBy?: string | null, canceledReason?: string | null, customerRef: { document: string, name: string, personType: EPersonType, email?: string | null, phone?: string | null, legalRepresentatives?: Array<{ document: string, email: string, name: string, phone: string, files?: Array<{ acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null, status: EProposalFileStatus, type: EProposalFileType, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null, pendencies?: { city: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, complement: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, document: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, email: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, name: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, neighborhood: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, number: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, phone: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, state: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, zipCode: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null } } | null }> | null, pendencies?: { city: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, email: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, name: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, neighborhood: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, number: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, phone: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, state: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, street: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, zipCode: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null }, uf: { acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null } } | null }, reward?: { type: ERewardType, percent: number, history?: Array<{ description: string }> | null } | null, specialDiscount?: Array<{ discountPercent: number, month: number }> | null, termOfAdhesion?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, signatureLink?: string | null, signedAt?: string | null, signerEmail: string, status: ETermStatus, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, termOfManagement?: Array<{ active: boolean, canceledAt?: string | null, canceledBy?: string | null, createdAt: string, createdBy: string, type?: ETermOfManagementType | null, origin?: string | null, replaced: boolean, signatureLink?: string | null, signedAt?: any | null, signerEmail?: string | null, status: ETermStatus, uuid?: string | null, refusedReason?: string | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null, storageService?: EStorageService | null } | null }> | null, energyBillInfo?: { AmountCents?: number | null, avarageConsumption?: number | null, avarageBillAmountCents?: number | null, name?: string | null, clientNumber?: string | null, consumerClassification?: EConsumerUnitClassification | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, energyBillFile?: { fileName?: string | null, fileUrl?: string | null } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null, indicationRef?: { expired?: boolean | null, id: string, type: EIndicationType, condition?: { customerDiscountMax: number, customerDiscountMin: number, customerDiscountOffered: number, customerDiscountSuggested: number, dealershipId: string, dealershipName: string, uf: string, anticipated?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionExceptionGroupId?: string | null, commissionedInvoices: number } | null, recurring?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, alwaysCommissionedInvoices: boolean, commissionedInvoices?: number | null } | null } | null, partner?: { document: string, email: string, id: string, name: string, phone: string } | null, salesman: { id: string, name: string } } | null, customerIndicationRef?: { customerId: string, customerName: string } | null, files?: Array<{ acceptedAt?: any | null, analyzedBy?: string | null, rejectedAt?: any | null, sentAt?: any | null, status: EProposalFileStatus, type: EProposalFileType, file?: { fileName: string, fileUrl: string, key: string, storageService: string } | null }> | null } | null, proposal?: { _id: string, consortiumId?: string | null, contractId?: string | null, lossReason?: string | null, fidelityMonths?: number | null, hasAnalysis: boolean, hash: string, origin: EProposalOrigin, status: EProposalStatus, updatedAt: any, createdAt: any, sellerRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, supportRef?: { changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, history: Array<{ changeAt: any, changeBy: ESellerChangeBy, email: string, id: string, name: string, user?: { email: string, id: string, name: string } | null }>, user?: { email: string, id: string, name: string } | null } | null, dealershipLogin?: { extraPassword?: string | null, login: string, password: string } | null, rejectedInfo?: { reason?: string | null, rejectedAt: any, rejectedBy: { id: string, name: string } } | null, salesFunnel?: { stage: EStage, changedBy: EChangedBy, date: any, user?: string | null, history: Array<{ changedBy: EChangedBy, date: any, stage: EStage, user?: string | null }> } | null, indicationRef?: { condition?: { customerDiscountMax: number, customerDiscountMin: number, customerDiscountOffered: number, customerDiscountSuggested: number, dealershipId: string, dealershipName: string, uf: string, anticipated?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionExceptionGroupId?: string | null, commissionedInvoices: number } | null, recurring?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, alwaysCommissionedInvoices: boolean, commissionedInvoices?: number | null } | null } | null, salesman: { id: string, name: string }, partner?: { name: string } | null } | null, cashbackInfo?: { active: boolean, cashbackPercentagePf: number, cashbackPercentagePj: number } | null, notes?: Array<{ analystId: string, createdAt: any, text?: string | null, analystName: string }> | null, preProposals?: Array<{ dealershipName: string, dealershipId: string, file: { fileName?: string | null, fileUrl?: string | null, key?: string | null } }> | null, termOfAdhesion?: { _id: string, name: string, signedAt?: string | null, signedDocumentUrl?: string | null, signerUrl?: string | null, refusedReason?: string | null, approveManual?: boolean | null, manualOrAutomatic?: ETermOfManagementType | null, status: EDocumentSignStatus, signers: Array<{ email: string, id?: string | null, name: string, requestSignId?: string | null }> } | null, businessProposals: Array<{ acceptedAt?: any | null, businessProposalDespertaNumber?: number | null, businessProposalPartnerNumber?: number | null, createdAt: any, invoiceValueWithPartner?: number | null, monthlyEconomyPercent: number, observation?: string | null, powerPlantId?: string | null, powerGeneratorId: string, rejectedAt?: any | null, rejectedBy?: string | null, updatedAt?: any | null, tariffGreenFlag: number, tariffRedFlagP1: number, tariffRedFlagP2: number, tariffPurpleFlag: number, tariffYellowFlag: number, status: EBusinessProposalStatus, contractOfAdhesion?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null, file?: { fileName?: string | null, fileUrl?: string | null, key?: string | null } | null }>, files?: Array<{ status?: EProposalFileStatus | null, type?: EProposalFileType | null, sendAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, acceptedAt?: any | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null, customerRef: { hasPendencies?: boolean | null, averageEnergyBillValue?: number | null, uf?: string | null, dealershipId?: string | null, dealershipName?: string | null, name: string, document: string, personType: string, email?: string | null, phone?: string | null, pendencies?: { averageEnergyBillValue: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, dealershipName: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, street: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, uf: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null } } | null, legalRepresentative?: Array<{ identificationNumber?: string | null, name?: string | null, document: string, email: string, phone: string, pendencies?: { city: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, complement: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, zipcode: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, document: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, email: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, name: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, neighborhood: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, number: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, phone: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null }, state: { rejectedAt?: any | null, solvedAt?: any | null, acceptedAt?: any | null, analysedBy?: string | null, sendedAt?: any | null } } | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null, files?: Array<{ acceptedAt?: any | null, analysedBy?: string | null, rejectedAt?: any | null, sendAt?: any | null, status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null }> | null }> | null, address?: { city: string, complement?: string | null, country: string, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null }, createBy?: { id: string, name: string, email: string, phone: string, type: string } | null, energyBillInfo?: { AmountCents?: number | null, consumerClassification?: EConsumerUnitClassification | null, avarageConsumption?: number | null, clientNumber?: string | null, dealershipId?: string | null, dealershipName?: string | null, distributionTaxes?: number | null, energyTaxes?: number | null, installationNumber?: string | null, invoiceDueDay?: number | null, tariffClassification?: ETariffClassification | null, tension?: EConsumerUnitTension | null, tusdValue?: number | null, energyBillFile?: { status?: EProposalFileStatus | null, type?: EProposalFileType | null, file?: { fileName: string, fileUrl: string, key: string } | null } | null, address?: { city: string, complement?: string | null, neighborhood: string, number: string, state: string, street: string, zipcode: string } | null } | null, monthlyConsumption?: { january?: number | null, february?: number | null, march?: number | null, april?: number | null, may?: number | null, june?: number | null, july?: number | null, august?: number | null, september?: number | null, october?: number | null, november?: number | null, december?: number | null } | null, customerIndicationRef?: { customerId: string, customerName: string } | null } | null } };

export type GetCommissionsCsvQueryVariables = Exact<{
  params?: InputMaybe<CommissionPaginateArgs>;
}>;


export type GetCommissionsCsvQuery = { getCommissions: { data: Array<{ _id: string, createdAt: any, dueDate: any, updatedAt: any, status: ECommissionStatus, valueCents: number, indicationRef: { condition?: { uf: string, dealershipName: string, recurring?: { additionalCommissionPercentage: number, alwaysCommissionedInvoices: boolean, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionedInvoices?: number | null } | null, anticipated?: { additionalCommissionPercentage: number, baseCommissionPercentage: number, commissionAmountPercentage: number, commissionExceptionGroupId?: string | null, commissionedInvoices: number } | null } | null, salesman: { id: string, name: string } } }>, meta: { currentPage: number, documentCounts: number, pageSize: number } } };

export type HomePerformancesQueryVariables = Exact<{
  paramsIndications?: InputMaybe<IndicationPaginateArgs>;
  paramsComissions?: InputMaybe<CommissionMetricsArgs>;
}>;


export type HomePerformancesQuery = { getIndicationMetrics: { indicationCount: number, signedContract: number }, getCommissionMetrics: { expectedRevenueCents: number, receivableRevenueCents: number } };

export type PaginateDealershipConditionsQueryVariables = Exact<{
  params?: InputMaybe<PartnerDealershipConditionsListDto>;
}>;


export type PaginateDealershipConditionsQuery = { paginateDealershipConditions: { data: Array<{ ceilingReferencePercentage: number, customerPFDiscountMax?: number | null, customerPFDiscountMin?: number | null, customerPFDiscountOffered?: number | null, customerPFDiscountSuggested?: number | null, customerPJDiscountMax?: number | null, customerPJDiscountMin?: number | null, customerPJDiscountOffered?: number | null, customerPJDiscountSuggested?: number | null, dealershipId: string, dealershipName: string, uf: string }>, meta: { currentPage: number, documentCounts: number, pageSize: number } } };


export const AffiliatePartnerUserChangePasswordDocument = gql`
    mutation AffiliatePartnerUserChangePassword($params: AffiliatePartnerUserRecoverPasswordChangeInput!) {
  affiliatePartnerUserChangePassword(RecoverPasswordChangeInput: $params) {
    _id
  }
}
    `;
export type AffiliatePartnerUserChangePasswordMutationFn = Apollo.MutationFunction<AffiliatePartnerUserChangePasswordMutation, AffiliatePartnerUserChangePasswordMutationVariables>;

/**
 * __useAffiliatePartnerUserChangePasswordMutation__
 *
 * To run a mutation, you first call `useAffiliatePartnerUserChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAffiliatePartnerUserChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [affiliatePartnerUserChangePasswordMutation, { data, loading, error }] = useAffiliatePartnerUserChangePasswordMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAffiliatePartnerUserChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<AffiliatePartnerUserChangePasswordMutation, AffiliatePartnerUserChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AffiliatePartnerUserChangePasswordMutation, AffiliatePartnerUserChangePasswordMutationVariables>(AffiliatePartnerUserChangePasswordDocument, options);
      }
export type AffiliatePartnerUserChangePasswordMutationHookResult = ReturnType<typeof useAffiliatePartnerUserChangePasswordMutation>;
export type AffiliatePartnerUserChangePasswordMutationResult = Apollo.MutationResult<AffiliatePartnerUserChangePasswordMutation>;
export type AffiliatePartnerUserChangePasswordMutationOptions = Apollo.BaseMutationOptions<AffiliatePartnerUserChangePasswordMutation, AffiliatePartnerUserChangePasswordMutationVariables>;
export const AffiliatePartnerUserRecoverPasswordDocument = gql`
    mutation AffiliatePartnerUserRecoverPassword($params: AffiliatePartnerUserRecoverPasswordInput!) {
  affiliatePartnerUserRecoverPassword(RecoverPasswordInput: $params) {
    _id
  }
}
    `;
export type AffiliatePartnerUserRecoverPasswordMutationFn = Apollo.MutationFunction<AffiliatePartnerUserRecoverPasswordMutation, AffiliatePartnerUserRecoverPasswordMutationVariables>;

/**
 * __useAffiliatePartnerUserRecoverPasswordMutation__
 *
 * To run a mutation, you first call `useAffiliatePartnerUserRecoverPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAffiliatePartnerUserRecoverPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [affiliatePartnerUserRecoverPasswordMutation, { data, loading, error }] = useAffiliatePartnerUserRecoverPasswordMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAffiliatePartnerUserRecoverPasswordMutation(baseOptions?: Apollo.MutationHookOptions<AffiliatePartnerUserRecoverPasswordMutation, AffiliatePartnerUserRecoverPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AffiliatePartnerUserRecoverPasswordMutation, AffiliatePartnerUserRecoverPasswordMutationVariables>(AffiliatePartnerUserRecoverPasswordDocument, options);
      }
export type AffiliatePartnerUserRecoverPasswordMutationHookResult = ReturnType<typeof useAffiliatePartnerUserRecoverPasswordMutation>;
export type AffiliatePartnerUserRecoverPasswordMutationResult = Apollo.MutationResult<AffiliatePartnerUserRecoverPasswordMutation>;
export type AffiliatePartnerUserRecoverPasswordMutationOptions = Apollo.BaseMutationOptions<AffiliatePartnerUserRecoverPasswordMutation, AffiliatePartnerUserRecoverPasswordMutationVariables>;
export const CalculateCommissionDocument = gql`
    mutation CalculateCommission($params: CalculateCommissionParamsDto!) {
  calculateCommission(params: $params) {
    anticipated {
      additionalCommissionPercentage
      baseCommissionPercentage
      commissionAmountPercentage
    }
    recurring {
      additionalCommissionPercentage
      baseCommissionPercentage
      commissionAmountPercentage
    }
  }
}
    `;
export type CalculateCommissionMutationFn = Apollo.MutationFunction<CalculateCommissionMutation, CalculateCommissionMutationVariables>;

/**
 * __useCalculateCommissionMutation__
 *
 * To run a mutation, you first call `useCalculateCommissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalculateCommissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calculateCommissionMutation, { data, loading, error }] = useCalculateCommissionMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCalculateCommissionMutation(baseOptions?: Apollo.MutationHookOptions<CalculateCommissionMutation, CalculateCommissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalculateCommissionMutation, CalculateCommissionMutationVariables>(CalculateCommissionDocument, options);
      }
export type CalculateCommissionMutationHookResult = ReturnType<typeof useCalculateCommissionMutation>;
export type CalculateCommissionMutationResult = Apollo.MutationResult<CalculateCommissionMutation>;
export type CalculateCommissionMutationOptions = Apollo.BaseMutationOptions<CalculateCommissionMutation, CalculateCommissionMutationVariables>;
export const ContractUpdateDocument = gql`
    mutation ContractUpdate($params: ContractUpdateDTOGraphql!) {
  contractUpdate(params: $params) {
    _id
    billingType
    previousGenerationBalance
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      signerEmail
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      invoiceDueDay
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    canceledReason
    monthlyConsumption {
      january
      february
      march
      april
      may
      june
      july
      august
      september
      october
      november
      december
    }
  }
}
    `;
export type ContractUpdateMutationFn = Apollo.MutationFunction<ContractUpdateMutation, ContractUpdateMutationVariables>;

/**
 * __useContractUpdateMutation__
 *
 * To run a mutation, you first call `useContractUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractUpdateMutation, { data, loading, error }] = useContractUpdateMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ContractUpdateMutation, ContractUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractUpdateMutation, ContractUpdateMutationVariables>(ContractUpdateDocument, options);
      }
export type ContractUpdateMutationHookResult = ReturnType<typeof useContractUpdateMutation>;
export type ContractUpdateMutationResult = Apollo.MutationResult<ContractUpdateMutation>;
export type ContractUpdateMutationOptions = Apollo.BaseMutationOptions<ContractUpdateMutation, ContractUpdateMutationVariables>;
export const ContractUpdateEnergyBillInfoDocument = gql`
    mutation ContractUpdateEnergyBillInfo($params: ContractUpdateEnergyBillInfo!) {
  contractUpdateEnergyBillInfo(params: $params) {
    _id
    previousGenerationBalance
    consortiumId
    contractType
    contractedSharePercent
    createdAt
    customerId
    customerRef {
      document
      name
      personType
    }
    fidelityMonths
    gracePeriodMonths
    reward {
      history {
        description
      }
      type
      percent
    }
    participationKwh
    powerPlantId
    powerGeneratorId
    proposalId
    signDate
    specialDiscount {
      discountPercent
      month
    }
    status
    termOfAdhesion {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      signatureLink
      signedAt
      signerEmail
      status
    }
    termOfManagement {
      active
      canceledAt
      canceledBy
      createdAt
      createdBy
      file {
        fileName
        fileUrl
        key
        storageService
      }
      origin
      replaced
      signatureLink
      signedAt
      status
    }
    contractType
    updatedAt
    validityMonths
    energyBillInfo {
      AmountCents
      address {
        city
        complement
        country
        neighborhood
        number
        state
        street
        zipcode
      }
      avarageConsumption
      avarageBillAmountCents
      name
      clientNumber
      consumerClassification
      dealershipId
      dealershipName
      distributionTaxes
      energyBillFile {
        fileName
        fileUrl
      }
      energyTaxes
      installationNumber
      invoiceDueDay
      tariffClassification
      tension
      tusdValue
    }
    dealershipLogin {
      extraPassword
      login
      password
    }
    canceledReason
  }
}
    `;
export type ContractUpdateEnergyBillInfoMutationFn = Apollo.MutationFunction<ContractUpdateEnergyBillInfoMutation, ContractUpdateEnergyBillInfoMutationVariables>;

/**
 * __useContractUpdateEnergyBillInfoMutation__
 *
 * To run a mutation, you first call `useContractUpdateEnergyBillInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContractUpdateEnergyBillInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contractUpdateEnergyBillInfoMutation, { data, loading, error }] = useContractUpdateEnergyBillInfoMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useContractUpdateEnergyBillInfoMutation(baseOptions?: Apollo.MutationHookOptions<ContractUpdateEnergyBillInfoMutation, ContractUpdateEnergyBillInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContractUpdateEnergyBillInfoMutation, ContractUpdateEnergyBillInfoMutationVariables>(ContractUpdateEnergyBillInfoDocument, options);
      }
export type ContractUpdateEnergyBillInfoMutationHookResult = ReturnType<typeof useContractUpdateEnergyBillInfoMutation>;
export type ContractUpdateEnergyBillInfoMutationResult = Apollo.MutationResult<ContractUpdateEnergyBillInfoMutation>;
export type ContractUpdateEnergyBillInfoMutationOptions = Apollo.BaseMutationOptions<ContractUpdateEnergyBillInfoMutation, ContractUpdateEnergyBillInfoMutationVariables>;
export const CreateAffiliatePartnerUserDocument = gql`
    mutation CreateAffiliatePartnerUser($params: AffiliatePartnerUserCreateInput!) {
  createAffiliatePartnerUser(userCreateInput: $params) {
    _id
    name
    email
    phone
    status
    createdAt
  }
}
    `;
export type CreateAffiliatePartnerUserMutationFn = Apollo.MutationFunction<CreateAffiliatePartnerUserMutation, CreateAffiliatePartnerUserMutationVariables>;

/**
 * __useCreateAffiliatePartnerUserMutation__
 *
 * To run a mutation, you first call `useCreateAffiliatePartnerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAffiliatePartnerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAffiliatePartnerUserMutation, { data, loading, error }] = useCreateAffiliatePartnerUserMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateAffiliatePartnerUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAffiliatePartnerUserMutation, CreateAffiliatePartnerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAffiliatePartnerUserMutation, CreateAffiliatePartnerUserMutationVariables>(CreateAffiliatePartnerUserDocument, options);
      }
export type CreateAffiliatePartnerUserMutationHookResult = ReturnType<typeof useCreateAffiliatePartnerUserMutation>;
export type CreateAffiliatePartnerUserMutationResult = Apollo.MutationResult<CreateAffiliatePartnerUserMutation>;
export type CreateAffiliatePartnerUserMutationOptions = Apollo.BaseMutationOptions<CreateAffiliatePartnerUserMutation, CreateAffiliatePartnerUserMutationVariables>;
export const CreateIndicationDocument = gql`
    mutation CreateIndication($params: CreateIndicationPartnerDto!) {
  createIndication(params: $params) {
    _id
    status
    averageEnergyBillValueCents
    origin
    createdAt
    updatedAt
    metadata {
      preProposalFileKey
    }
    salesmanRef {
      name
    }
    customerRef {
      name
    }
  }
}
    `;
export type CreateIndicationMutationFn = Apollo.MutationFunction<CreateIndicationMutation, CreateIndicationMutationVariables>;

/**
 * __useCreateIndicationMutation__
 *
 * To run a mutation, you first call `useCreateIndicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndicationMutation, { data, loading, error }] = useCreateIndicationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateIndicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndicationMutation, CreateIndicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndicationMutation, CreateIndicationMutationVariables>(CreateIndicationDocument, options);
      }
export type CreateIndicationMutationHookResult = ReturnType<typeof useCreateIndicationMutation>;
export type CreateIndicationMutationResult = Apollo.MutationResult<CreateIndicationMutation>;
export type CreateIndicationMutationOptions = Apollo.BaseMutationOptions<CreateIndicationMutation, CreateIndicationMutationVariables>;
export const CustomerUpdateByIdDocument = gql`
    mutation CustomerUpdateById($id: String!, $params: CustomerUpdateGraphqlDTO!) {
  customerUpdateById(id: $id, params: $params) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    bank {
      account
      agency
      code
      type
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      identificationNumber
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type CustomerUpdateByIdMutationFn = Apollo.MutationFunction<CustomerUpdateByIdMutation, CustomerUpdateByIdMutationVariables>;

/**
 * __useCustomerUpdateByIdMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateByIdMutation, { data, loading, error }] = useCustomerUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<CustomerUpdateByIdMutation, CustomerUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerUpdateByIdMutation, CustomerUpdateByIdMutationVariables>(CustomerUpdateByIdDocument, options);
      }
export type CustomerUpdateByIdMutationHookResult = ReturnType<typeof useCustomerUpdateByIdMutation>;
export type CustomerUpdateByIdMutationResult = Apollo.MutationResult<CustomerUpdateByIdMutation>;
export type CustomerUpdateByIdMutationOptions = Apollo.BaseMutationOptions<CustomerUpdateByIdMutation, CustomerUpdateByIdMutationVariables>;
export const CustomerUpdateLegalRepresentantDocument = gql`
    mutation CustomerUpdateLegalRepresentant($params: LegalRepresentativeUpdateGraphqlDto!) {
  customerUpdateLegalRepresentant(params: $params) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    bank {
      account
      agency
      code
      type
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      identificationNumber
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
  }
}
    `;
export type CustomerUpdateLegalRepresentantMutationFn = Apollo.MutationFunction<CustomerUpdateLegalRepresentantMutation, CustomerUpdateLegalRepresentantMutationVariables>;

/**
 * __useCustomerUpdateLegalRepresentantMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateLegalRepresentantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateLegalRepresentantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateLegalRepresentantMutation, { data, loading, error }] = useCustomerUpdateLegalRepresentantMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCustomerUpdateLegalRepresentantMutation(baseOptions?: Apollo.MutationHookOptions<CustomerUpdateLegalRepresentantMutation, CustomerUpdateLegalRepresentantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomerUpdateLegalRepresentantMutation, CustomerUpdateLegalRepresentantMutationVariables>(CustomerUpdateLegalRepresentantDocument, options);
      }
export type CustomerUpdateLegalRepresentantMutationHookResult = ReturnType<typeof useCustomerUpdateLegalRepresentantMutation>;
export type CustomerUpdateLegalRepresentantMutationResult = Apollo.MutationResult<CustomerUpdateLegalRepresentantMutation>;
export type CustomerUpdateLegalRepresentantMutationOptions = Apollo.BaseMutationOptions<CustomerUpdateLegalRepresentantMutation, CustomerUpdateLegalRepresentantMutationVariables>;
export const FormalizeIndicationProposalDocument = gql`
    mutation FormalizeIndicationProposal($indicationId: String!) {
  formalizeIndicationProposal(indicationId: $indicationId) {
    status
    termOfAdhesion {
      _id
      name
      signedAt
      signedDocumentUrl
      signerUrl
      refusedReason
      approveManual
      manualOrAutomatic
      signers {
        email
        id
        name
        requestSignId
      }
    }
    consortiumId
  }
}
    `;
export type FormalizeIndicationProposalMutationFn = Apollo.MutationFunction<FormalizeIndicationProposalMutation, FormalizeIndicationProposalMutationVariables>;

/**
 * __useFormalizeIndicationProposalMutation__
 *
 * To run a mutation, you first call `useFormalizeIndicationProposalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFormalizeIndicationProposalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [formalizeIndicationProposalMutation, { data, loading, error }] = useFormalizeIndicationProposalMutation({
 *   variables: {
 *      indicationId: // value for 'indicationId'
 *   },
 * });
 */
export function useFormalizeIndicationProposalMutation(baseOptions?: Apollo.MutationHookOptions<FormalizeIndicationProposalMutation, FormalizeIndicationProposalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FormalizeIndicationProposalMutation, FormalizeIndicationProposalMutationVariables>(FormalizeIndicationProposalDocument, options);
      }
export type FormalizeIndicationProposalMutationHookResult = ReturnType<typeof useFormalizeIndicationProposalMutation>;
export type FormalizeIndicationProposalMutationResult = Apollo.MutationResult<FormalizeIndicationProposalMutation>;
export type FormalizeIndicationProposalMutationOptions = Apollo.BaseMutationOptions<FormalizeIndicationProposalMutation, FormalizeIndicationProposalMutationVariables>;
export const LoginAffiliatePartnerUserDocument = gql`
    mutation LoginAffiliatePartnerUser($params: AuthAffiliatePartnerUserArgs!) {
  loginAffiliatePartnerUser(authUserInput: $params) {
    accessToken
  }
}
    `;
export type LoginAffiliatePartnerUserMutationFn = Apollo.MutationFunction<LoginAffiliatePartnerUserMutation, LoginAffiliatePartnerUserMutationVariables>;

/**
 * __useLoginAffiliatePartnerUserMutation__
 *
 * To run a mutation, you first call `useLoginAffiliatePartnerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAffiliatePartnerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAffiliatePartnerUserMutation, { data, loading, error }] = useLoginAffiliatePartnerUserMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useLoginAffiliatePartnerUserMutation(baseOptions?: Apollo.MutationHookOptions<LoginAffiliatePartnerUserMutation, LoginAffiliatePartnerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginAffiliatePartnerUserMutation, LoginAffiliatePartnerUserMutationVariables>(LoginAffiliatePartnerUserDocument, options);
      }
export type LoginAffiliatePartnerUserMutationHookResult = ReturnType<typeof useLoginAffiliatePartnerUserMutation>;
export type LoginAffiliatePartnerUserMutationResult = Apollo.MutationResult<LoginAffiliatePartnerUserMutation>;
export type LoginAffiliatePartnerUserMutationOptions = Apollo.BaseMutationOptions<LoginAffiliatePartnerUserMutation, LoginAffiliatePartnerUserMutationVariables>;
export const RegenerateApiKeyFromPartnerDocument = gql`
    mutation RegenerateApiKeyFromPartner {
  regenerateApiKeyFromPartner {
    configuration {
      apiKey
    }
  }
}
    `;
export type RegenerateApiKeyFromPartnerMutationFn = Apollo.MutationFunction<RegenerateApiKeyFromPartnerMutation, RegenerateApiKeyFromPartnerMutationVariables>;

/**
 * __useRegenerateApiKeyFromPartnerMutation__
 *
 * To run a mutation, you first call `useRegenerateApiKeyFromPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateApiKeyFromPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateApiKeyFromPartnerMutation, { data, loading, error }] = useRegenerateApiKeyFromPartnerMutation({
 *   variables: {
 *   },
 * });
 */
export function useRegenerateApiKeyFromPartnerMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateApiKeyFromPartnerMutation, RegenerateApiKeyFromPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateApiKeyFromPartnerMutation, RegenerateApiKeyFromPartnerMutationVariables>(RegenerateApiKeyFromPartnerDocument, options);
      }
export type RegenerateApiKeyFromPartnerMutationHookResult = ReturnType<typeof useRegenerateApiKeyFromPartnerMutation>;
export type RegenerateApiKeyFromPartnerMutationResult = Apollo.MutationResult<RegenerateApiKeyFromPartnerMutation>;
export type RegenerateApiKeyFromPartnerMutationOptions = Apollo.BaseMutationOptions<RegenerateApiKeyFromPartnerMutation, RegenerateApiKeyFromPartnerMutationVariables>;
export const SolveProposalCustomerPendenciesDocument = gql`
    mutation SolveProposalCustomerPendencies($params: SolveProposalCustomerPendenciesGraphqlDTO!) {
  solveProposalCustomerPendencies(params: $params) {
    customerRef {
      pendencies {
        averageEnergyBillValue {
          acceptedAt
          rejectedAt
          sendedAt
        }
        city {
          acceptedAt
          rejectedAt
          sendedAt
        }
        document {
          acceptedAt
          rejectedAt
          sendedAt
        }
        email {
          acceptedAt
          rejectedAt
          sendedAt
        }
        name {
          acceptedAt
          rejectedAt
          sendedAt
        }
        neighborhood {
          acceptedAt
          rejectedAt
          sendedAt
        }
        number {
          acceptedAt
          rejectedAt
          sendedAt
        }
        phone {
          acceptedAt
          rejectedAt
          sendedAt
        }
        state {
          acceptedAt
          rejectedAt
          sendedAt
        }
        street {
          acceptedAt
          rejectedAt
          sendedAt
        }
        uf {
          acceptedAt
          rejectedAt
          sendedAt
        }
        zipcode {
          acceptedAt
          rejectedAt
          sendedAt
        }
      }
    }
  }
}
    `;
export type SolveProposalCustomerPendenciesMutationFn = Apollo.MutationFunction<SolveProposalCustomerPendenciesMutation, SolveProposalCustomerPendenciesMutationVariables>;

/**
 * __useSolveProposalCustomerPendenciesMutation__
 *
 * To run a mutation, you first call `useSolveProposalCustomerPendenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSolveProposalCustomerPendenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [solveProposalCustomerPendenciesMutation, { data, loading, error }] = useSolveProposalCustomerPendenciesMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useSolveProposalCustomerPendenciesMutation(baseOptions?: Apollo.MutationHookOptions<SolveProposalCustomerPendenciesMutation, SolveProposalCustomerPendenciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SolveProposalCustomerPendenciesMutation, SolveProposalCustomerPendenciesMutationVariables>(SolveProposalCustomerPendenciesDocument, options);
      }
export type SolveProposalCustomerPendenciesMutationHookResult = ReturnType<typeof useSolveProposalCustomerPendenciesMutation>;
export type SolveProposalCustomerPendenciesMutationResult = Apollo.MutationResult<SolveProposalCustomerPendenciesMutation>;
export type SolveProposalCustomerPendenciesMutationOptions = Apollo.BaseMutationOptions<SolveProposalCustomerPendenciesMutation, SolveProposalCustomerPendenciesMutationVariables>;
export const UpdateAffiliatePartnerUserDocument = gql`
    mutation UpdateAffiliatePartnerUser($id: String!, $params: AffiliatePartnerUserUpdateInput!) {
  updateAffiliatePartnerUser(id: $id, userUpdateInput: $params) {
    _id
    name
    email
    phone
    status
    createdAt
  }
}
    `;
export type UpdateAffiliatePartnerUserMutationFn = Apollo.MutationFunction<UpdateAffiliatePartnerUserMutation, UpdateAffiliatePartnerUserMutationVariables>;

/**
 * __useUpdateAffiliatePartnerUserMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliatePartnerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliatePartnerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliatePartnerUserMutation, { data, loading, error }] = useUpdateAffiliatePartnerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateAffiliatePartnerUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAffiliatePartnerUserMutation, UpdateAffiliatePartnerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAffiliatePartnerUserMutation, UpdateAffiliatePartnerUserMutationVariables>(UpdateAffiliatePartnerUserDocument, options);
      }
export type UpdateAffiliatePartnerUserMutationHookResult = ReturnType<typeof useUpdateAffiliatePartnerUserMutation>;
export type UpdateAffiliatePartnerUserMutationResult = Apollo.MutationResult<UpdateAffiliatePartnerUserMutation>;
export type UpdateAffiliatePartnerUserMutationOptions = Apollo.BaseMutationOptions<UpdateAffiliatePartnerUserMutation, UpdateAffiliatePartnerUserMutationVariables>;
export const UpdateAffiliatePartnerUserApprovedDocument = gql`
    mutation UpdateAffiliatePartnerUserApproved($id: String!, $userUpdateInput: AffiliatePartnerUserApprovedUpdateInput!) {
  updateAffiliatePartnerUserApproved(id: $id, userUpdateInput: $userUpdateInput) {
    _id
    email
    accessStatus
  }
}
    `;
export type UpdateAffiliatePartnerUserApprovedMutationFn = Apollo.MutationFunction<UpdateAffiliatePartnerUserApprovedMutation, UpdateAffiliatePartnerUserApprovedMutationVariables>;

/**
 * __useUpdateAffiliatePartnerUserApprovedMutation__
 *
 * To run a mutation, you first call `useUpdateAffiliatePartnerUserApprovedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAffiliatePartnerUserApprovedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAffiliatePartnerUserApprovedMutation, { data, loading, error }] = useUpdateAffiliatePartnerUserApprovedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userUpdateInput: // value for 'userUpdateInput'
 *   },
 * });
 */
export function useUpdateAffiliatePartnerUserApprovedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAffiliatePartnerUserApprovedMutation, UpdateAffiliatePartnerUserApprovedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAffiliatePartnerUserApprovedMutation, UpdateAffiliatePartnerUserApprovedMutationVariables>(UpdateAffiliatePartnerUserApprovedDocument, options);
      }
export type UpdateAffiliatePartnerUserApprovedMutationHookResult = ReturnType<typeof useUpdateAffiliatePartnerUserApprovedMutation>;
export type UpdateAffiliatePartnerUserApprovedMutationResult = Apollo.MutationResult<UpdateAffiliatePartnerUserApprovedMutation>;
export type UpdateAffiliatePartnerUserApprovedMutationOptions = Apollo.BaseMutationOptions<UpdateAffiliatePartnerUserApprovedMutation, UpdateAffiliatePartnerUserApprovedMutationVariables>;
export const UpdateIndicationDocument = gql`
    mutation UpdateIndication($params: UpdateIndicationPartnerDto!) {
  updateIndication(params: $params) {
    _id
    status
    metadata {
      preProposalFileKey
    }
    condition {
      dealershipId
      dealershipName
    }
    customerRef {
      name
      document
      email
      phone
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
}
    `;
export type UpdateIndicationMutationFn = Apollo.MutationFunction<UpdateIndicationMutation, UpdateIndicationMutationVariables>;

/**
 * __useUpdateIndicationMutation__
 *
 * To run a mutation, you first call `useUpdateIndicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicationMutation, { data, loading, error }] = useUpdateIndicationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateIndicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicationMutation, UpdateIndicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicationMutation, UpdateIndicationMutationVariables>(UpdateIndicationDocument, options);
      }
export type UpdateIndicationMutationHookResult = ReturnType<typeof useUpdateIndicationMutation>;
export type UpdateIndicationMutationResult = Apollo.MutationResult<UpdateIndicationMutation>;
export type UpdateIndicationMutationOptions = Apollo.BaseMutationOptions<UpdateIndicationMutation, UpdateIndicationMutationVariables>;
export const UpdateIndicationAddEnergyBillInfoDocument = gql`
    mutation UpdateIndicationAddEnergyBillInfo($params: UpdateIndicationEnergyBillInfoDto!) {
  updateIndicationAddEnergyBillInfo(params: $params)
}
    `;
export type UpdateIndicationAddEnergyBillInfoMutationFn = Apollo.MutationFunction<UpdateIndicationAddEnergyBillInfoMutation, UpdateIndicationAddEnergyBillInfoMutationVariables>;

/**
 * __useUpdateIndicationAddEnergyBillInfoMutation__
 *
 * To run a mutation, you first call `useUpdateIndicationAddEnergyBillInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicationAddEnergyBillInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicationAddEnergyBillInfoMutation, { data, loading, error }] = useUpdateIndicationAddEnergyBillInfoMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateIndicationAddEnergyBillInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicationAddEnergyBillInfoMutation, UpdateIndicationAddEnergyBillInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicationAddEnergyBillInfoMutation, UpdateIndicationAddEnergyBillInfoMutationVariables>(UpdateIndicationAddEnergyBillInfoDocument, options);
      }
export type UpdateIndicationAddEnergyBillInfoMutationHookResult = ReturnType<typeof useUpdateIndicationAddEnergyBillInfoMutation>;
export type UpdateIndicationAddEnergyBillInfoMutationResult = Apollo.MutationResult<UpdateIndicationAddEnergyBillInfoMutation>;
export type UpdateIndicationAddEnergyBillInfoMutationOptions = Apollo.BaseMutationOptions<UpdateIndicationAddEnergyBillInfoMutation, UpdateIndicationAddEnergyBillInfoMutationVariables>;
export const UpdateIndicationFilesDocument = gql`
    mutation UpdateIndicationFiles($params: UpdateIndicationFilesDto!) {
  updateIndicationFiles(params: $params)
}
    `;
export type UpdateIndicationFilesMutationFn = Apollo.MutationFunction<UpdateIndicationFilesMutation, UpdateIndicationFilesMutationVariables>;

/**
 * __useUpdateIndicationFilesMutation__
 *
 * To run a mutation, you first call `useUpdateIndicationFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicationFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicationFilesMutation, { data, loading, error }] = useUpdateIndicationFilesMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateIndicationFilesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicationFilesMutation, UpdateIndicationFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicationFilesMutation, UpdateIndicationFilesMutationVariables>(UpdateIndicationFilesDocument, options);
      }
export type UpdateIndicationFilesMutationHookResult = ReturnType<typeof useUpdateIndicationFilesMutation>;
export type UpdateIndicationFilesMutationResult = Apollo.MutationResult<UpdateIndicationFilesMutation>;
export type UpdateIndicationFilesMutationOptions = Apollo.BaseMutationOptions<UpdateIndicationFilesMutation, UpdateIndicationFilesMutationVariables>;
export const UpdateIndicationLegalRepresentativesDocument = gql`
    mutation UpdateIndicationLegalRepresentatives($params: UpdateIndicationLegalRepresentativeGraphqlDto!) {
  updateIndicationLegalRepresentatives(params: $params)
}
    `;
export type UpdateIndicationLegalRepresentativesMutationFn = Apollo.MutationFunction<UpdateIndicationLegalRepresentativesMutation, UpdateIndicationLegalRepresentativesMutationVariables>;

/**
 * __useUpdateIndicationLegalRepresentativesMutation__
 *
 * To run a mutation, you first call `useUpdateIndicationLegalRepresentativesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicationLegalRepresentativesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicationLegalRepresentativesMutation, { data, loading, error }] = useUpdateIndicationLegalRepresentativesMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdateIndicationLegalRepresentativesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicationLegalRepresentativesMutation, UpdateIndicationLegalRepresentativesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicationLegalRepresentativesMutation, UpdateIndicationLegalRepresentativesMutationVariables>(UpdateIndicationLegalRepresentativesDocument, options);
      }
export type UpdateIndicationLegalRepresentativesMutationHookResult = ReturnType<typeof useUpdateIndicationLegalRepresentativesMutation>;
export type UpdateIndicationLegalRepresentativesMutationResult = Apollo.MutationResult<UpdateIndicationLegalRepresentativesMutation>;
export type UpdateIndicationLegalRepresentativesMutationOptions = Apollo.BaseMutationOptions<UpdateIndicationLegalRepresentativesMutation, UpdateIndicationLegalRepresentativesMutationVariables>;
export const UpdatePartnerAreaPartnerIconeDocument = gql`
    mutation UpdatePartnerAreaPartnerIcone($params: FileUploadInputTypeDto!) {
  updatePartnerAreaPartnerIcone(partnerIcone: $params) {
    configuration {
      icone {
        fileUrl
      }
    }
  }
}
    `;
export type UpdatePartnerAreaPartnerIconeMutationFn = Apollo.MutationFunction<UpdatePartnerAreaPartnerIconeMutation, UpdatePartnerAreaPartnerIconeMutationVariables>;

/**
 * __useUpdatePartnerAreaPartnerIconeMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerAreaPartnerIconeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerAreaPartnerIconeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerAreaPartnerIconeMutation, { data, loading, error }] = useUpdatePartnerAreaPartnerIconeMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdatePartnerAreaPartnerIconeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerAreaPartnerIconeMutation, UpdatePartnerAreaPartnerIconeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerAreaPartnerIconeMutation, UpdatePartnerAreaPartnerIconeMutationVariables>(UpdatePartnerAreaPartnerIconeDocument, options);
      }
export type UpdatePartnerAreaPartnerIconeMutationHookResult = ReturnType<typeof useUpdatePartnerAreaPartnerIconeMutation>;
export type UpdatePartnerAreaPartnerIconeMutationResult = Apollo.MutationResult<UpdatePartnerAreaPartnerIconeMutation>;
export type UpdatePartnerAreaPartnerIconeMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerAreaPartnerIconeMutation, UpdatePartnerAreaPartnerIconeMutationVariables>;
export const UpdatePartnerAreaPartnerLogoDocument = gql`
    mutation UpdatePartnerAreaPartnerLogo($params: FileUploadInputTypeDto!) {
  updatePartnerAreaPartnerLogo(partnerLogo: $params) {
    configuration {
      logo {
        fileUrl
      }
    }
  }
}
    `;
export type UpdatePartnerAreaPartnerLogoMutationFn = Apollo.MutationFunction<UpdatePartnerAreaPartnerLogoMutation, UpdatePartnerAreaPartnerLogoMutationVariables>;

/**
 * __useUpdatePartnerAreaPartnerLogoMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerAreaPartnerLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerAreaPartnerLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerAreaPartnerLogoMutation, { data, loading, error }] = useUpdatePartnerAreaPartnerLogoMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdatePartnerAreaPartnerLogoMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerAreaPartnerLogoMutation, UpdatePartnerAreaPartnerLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerAreaPartnerLogoMutation, UpdatePartnerAreaPartnerLogoMutationVariables>(UpdatePartnerAreaPartnerLogoDocument, options);
      }
export type UpdatePartnerAreaPartnerLogoMutationHookResult = ReturnType<typeof useUpdatePartnerAreaPartnerLogoMutation>;
export type UpdatePartnerAreaPartnerLogoMutationResult = Apollo.MutationResult<UpdatePartnerAreaPartnerLogoMutation>;
export type UpdatePartnerAreaPartnerLogoMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerAreaPartnerLogoMutation, UpdatePartnerAreaPartnerLogoMutationVariables>;
export const UpdatePartnerDefaultConfigurationDocument = gql`
    mutation UpdatePartnerDefaultConfiguration($params: UpdatePartnerDefaultConfigurationDto!) {
  updatePartnerDefaultConfiguration(UpdatePartnerDefaultConfigurationDto: $params) {
    configuration {
      allowAffiliateLink
      allowManualProposal
    }
  }
}
    `;
export type UpdatePartnerDefaultConfigurationMutationFn = Apollo.MutationFunction<UpdatePartnerDefaultConfigurationMutation, UpdatePartnerDefaultConfigurationMutationVariables>;

/**
 * __useUpdatePartnerDefaultConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerDefaultConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerDefaultConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerDefaultConfigurationMutation, { data, loading, error }] = useUpdatePartnerDefaultConfigurationMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdatePartnerDefaultConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerDefaultConfigurationMutation, UpdatePartnerDefaultConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerDefaultConfigurationMutation, UpdatePartnerDefaultConfigurationMutationVariables>(UpdatePartnerDefaultConfigurationDocument, options);
      }
export type UpdatePartnerDefaultConfigurationMutationHookResult = ReturnType<typeof useUpdatePartnerDefaultConfigurationMutation>;
export type UpdatePartnerDefaultConfigurationMutationResult = Apollo.MutationResult<UpdatePartnerDefaultConfigurationMutation>;
export type UpdatePartnerDefaultConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerDefaultConfigurationMutation, UpdatePartnerDefaultConfigurationMutationVariables>;
export const UpdatePartnerDiscountsOfferedDocument = gql`
    mutation UpdatePartnerDiscountsOffered($params: UpdatePartnerDiscountOfferedDto!) {
  updatePartnerDiscountsOffered(UpdatePartnerDiscountOfferedDto: $params) {
    customerPFDiscountOffered
    customerPJDiscountOffered
    dealershipId
    dealershipName
  }
}
    `;
export type UpdatePartnerDiscountsOfferedMutationFn = Apollo.MutationFunction<UpdatePartnerDiscountsOfferedMutation, UpdatePartnerDiscountsOfferedMutationVariables>;

/**
 * __useUpdatePartnerDiscountsOfferedMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerDiscountsOfferedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerDiscountsOfferedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerDiscountsOfferedMutation, { data, loading, error }] = useUpdatePartnerDiscountsOfferedMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdatePartnerDiscountsOfferedMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerDiscountsOfferedMutation, UpdatePartnerDiscountsOfferedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerDiscountsOfferedMutation, UpdatePartnerDiscountsOfferedMutationVariables>(UpdatePartnerDiscountsOfferedDocument, options);
      }
export type UpdatePartnerDiscountsOfferedMutationHookResult = ReturnType<typeof useUpdatePartnerDiscountsOfferedMutation>;
export type UpdatePartnerDiscountsOfferedMutationResult = Apollo.MutationResult<UpdatePartnerDiscountsOfferedMutation>;
export type UpdatePartnerDiscountsOfferedMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerDiscountsOfferedMutation, UpdatePartnerDiscountsOfferedMutationVariables>;
export const UpdatePartnerWebhookDocument = gql`
    mutation UpdatePartnerWebhook($params: UpdatePartnerWebhookDto!) {
  updatePartnerWebhook(updatePartnerWebhookDto: $params) {
    configuration {
      webhookUrl
    }
  }
}
    `;
export type UpdatePartnerWebhookMutationFn = Apollo.MutationFunction<UpdatePartnerWebhookMutation, UpdatePartnerWebhookMutationVariables>;

/**
 * __useUpdatePartnerWebhookMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerWebhookMutation, { data, loading, error }] = useUpdatePartnerWebhookMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUpdatePartnerWebhookMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerWebhookMutation, UpdatePartnerWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerWebhookMutation, UpdatePartnerWebhookMutationVariables>(UpdatePartnerWebhookDocument, options);
      }
export type UpdatePartnerWebhookMutationHookResult = ReturnType<typeof useUpdatePartnerWebhookMutation>;
export type UpdatePartnerWebhookMutationResult = Apollo.MutationResult<UpdatePartnerWebhookMutation>;
export type UpdatePartnerWebhookMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerWebhookMutation, UpdatePartnerWebhookMutationVariables>;
export const AffiliatePartnerGetMeDocument = gql`
    query AffiliatePartnerGetMe {
  affiliatePartnerGetMe {
    _id
    email
    name
    phone
    createdAt
    type
    status
    partnerRef {
      id
      name
    }
    updatedAt
    owner
  }
}
    `;

/**
 * __useAffiliatePartnerGetMeQuery__
 *
 * To run a query within a React component, call `useAffiliatePartnerGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatePartnerGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatePartnerGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAffiliatePartnerGetMeQuery(baseOptions?: Apollo.QueryHookOptions<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>(AffiliatePartnerGetMeDocument, options);
      }
export function useAffiliatePartnerGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>(AffiliatePartnerGetMeDocument, options);
        }
// @ts-ignore
export function useAffiliatePartnerGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>): Apollo.UseSuspenseQueryResult<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>;
export function useAffiliatePartnerGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>): Apollo.UseSuspenseQueryResult<AffiliatePartnerGetMeQuery | undefined, AffiliatePartnerGetMeQueryVariables>;
export function useAffiliatePartnerGetMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>(AffiliatePartnerGetMeDocument, options);
        }
export type AffiliatePartnerGetMeQueryHookResult = ReturnType<typeof useAffiliatePartnerGetMeQuery>;
export type AffiliatePartnerGetMeLazyQueryHookResult = ReturnType<typeof useAffiliatePartnerGetMeLazyQuery>;
export type AffiliatePartnerGetMeSuspenseQueryHookResult = ReturnType<typeof useAffiliatePartnerGetMeSuspenseQuery>;
export type AffiliatePartnerGetMeQueryResult = Apollo.QueryResult<AffiliatePartnerGetMeQuery, AffiliatePartnerGetMeQueryVariables>;
export const AffiliatePartnerGetMyPartnerDocument = gql`
    query AffiliatePartnerGetMyPartner {
  affiliatePartnerGetMyPartner {
    _id
    site
    allowFormalizeProposal
    status
    name
    createdAt
    document
    email
    phone
    code
    contactPerson {
      email
      name
      phone
    }
    partnershipConditions {
      recurring {
        alwaysCommissionedInvoices
        baseCommissionPercentage
        commissionedInvoices
      }
      anticipated {
        baseCommissionPercentage
        commissionExceptionGroups {
          baseCommissionPercentage
          commissionedInvoices
          dealerships
          id
        }
        commissionedInvoices
      }
    }
    configuration {
      allowAffiliateLink
      allowManualProposal
      apiKey
      webhookUrl
      icone {
        fileUrl
      }
      logo {
        fileUrl
      }
    }
  }
}
    `;

/**
 * __useAffiliatePartnerGetMyPartnerQuery__
 *
 * To run a query within a React component, call `useAffiliatePartnerGetMyPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatePartnerGetMyPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatePartnerGetMyPartnerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAffiliatePartnerGetMyPartnerQuery(baseOptions?: Apollo.QueryHookOptions<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>(AffiliatePartnerGetMyPartnerDocument, options);
      }
export function useAffiliatePartnerGetMyPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>(AffiliatePartnerGetMyPartnerDocument, options);
        }
// @ts-ignore
export function useAffiliatePartnerGetMyPartnerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>): Apollo.UseSuspenseQueryResult<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>;
export function useAffiliatePartnerGetMyPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>): Apollo.UseSuspenseQueryResult<AffiliatePartnerGetMyPartnerQuery | undefined, AffiliatePartnerGetMyPartnerQueryVariables>;
export function useAffiliatePartnerGetMyPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>(AffiliatePartnerGetMyPartnerDocument, options);
        }
export type AffiliatePartnerGetMyPartnerQueryHookResult = ReturnType<typeof useAffiliatePartnerGetMyPartnerQuery>;
export type AffiliatePartnerGetMyPartnerLazyQueryHookResult = ReturnType<typeof useAffiliatePartnerGetMyPartnerLazyQuery>;
export type AffiliatePartnerGetMyPartnerSuspenseQueryHookResult = ReturnType<typeof useAffiliatePartnerGetMyPartnerSuspenseQuery>;
export type AffiliatePartnerGetMyPartnerQueryResult = Apollo.QueryResult<AffiliatePartnerGetMyPartnerQuery, AffiliatePartnerGetMyPartnerQueryVariables>;
export const AffiliatePartnerUserGetDocument = gql`
    query AffiliatePartnerUserGet($id: String!) {
  affiliatePartnerUserGet(id: $id) {
    _id
    name
    email
    phone
    cpf
    status
    accessStatus
    captureSource
    linkedin
    facebook
    instagram
    site
    address {
      zipcode
      street
      number
      neighborhood
      complement
      city
      state
      country
    }
    professionalHistory {
      companyName
      role
      segment
      observation
    }
    files {
      type
      file {
        key
        fileName
        fileUrl
      }
    }
    createdAt
  }
}
    `;

/**
 * __useAffiliatePartnerUserGetQuery__
 *
 * To run a query within a React component, call `useAffiliatePartnerUserGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatePartnerUserGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatePartnerUserGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAffiliatePartnerUserGetQuery(baseOptions: Apollo.QueryHookOptions<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables> & ({ variables: AffiliatePartnerUserGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>(AffiliatePartnerUserGetDocument, options);
      }
export function useAffiliatePartnerUserGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>(AffiliatePartnerUserGetDocument, options);
        }
// @ts-ignore
export function useAffiliatePartnerUserGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>): Apollo.UseSuspenseQueryResult<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>;
export function useAffiliatePartnerUserGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>): Apollo.UseSuspenseQueryResult<AffiliatePartnerUserGetQuery | undefined, AffiliatePartnerUserGetQueryVariables>;
export function useAffiliatePartnerUserGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>(AffiliatePartnerUserGetDocument, options);
        }
export type AffiliatePartnerUserGetQueryHookResult = ReturnType<typeof useAffiliatePartnerUserGetQuery>;
export type AffiliatePartnerUserGetLazyQueryHookResult = ReturnType<typeof useAffiliatePartnerUserGetLazyQuery>;
export type AffiliatePartnerUserGetSuspenseQueryHookResult = ReturnType<typeof useAffiliatePartnerUserGetSuspenseQuery>;
export type AffiliatePartnerUserGetQueryResult = Apollo.QueryResult<AffiliatePartnerUserGetQuery, AffiliatePartnerUserGetQueryVariables>;
export const AffiliatePartnerUserListDocument = gql`
    query AffiliatePartnerUserList($params: AffiliatePartnerUserPaginateArgs) {
  affiliatePartnerUserList(params: $params) {
    data {
      _id
      name
      email
      phone
      status
    }
    meta {
      currentPage
      documentCounts
      pageSize
    }
  }
}
    `;

/**
 * __useAffiliatePartnerUserListQuery__
 *
 * To run a query within a React component, call `useAffiliatePartnerUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAffiliatePartnerUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAffiliatePartnerUserListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useAffiliatePartnerUserListQuery(baseOptions?: Apollo.QueryHookOptions<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>(AffiliatePartnerUserListDocument, options);
      }
export function useAffiliatePartnerUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>(AffiliatePartnerUserListDocument, options);
        }
// @ts-ignore
export function useAffiliatePartnerUserListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>): Apollo.UseSuspenseQueryResult<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>;
export function useAffiliatePartnerUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>): Apollo.UseSuspenseQueryResult<AffiliatePartnerUserListQuery | undefined, AffiliatePartnerUserListQueryVariables>;
export function useAffiliatePartnerUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>(AffiliatePartnerUserListDocument, options);
        }
export type AffiliatePartnerUserListQueryHookResult = ReturnType<typeof useAffiliatePartnerUserListQuery>;
export type AffiliatePartnerUserListLazyQueryHookResult = ReturnType<typeof useAffiliatePartnerUserListLazyQuery>;
export type AffiliatePartnerUserListSuspenseQueryHookResult = ReturnType<typeof useAffiliatePartnerUserListSuspenseQuery>;
export type AffiliatePartnerUserListQueryResult = Apollo.QueryResult<AffiliatePartnerUserListQuery, AffiliatePartnerUserListQueryVariables>;
export const CustomerGetDocument = gql`
    query CustomerGet($id: String!) {
  customerGet(id: $id) {
    _id
    uf
    name
    phone
    email
    status
    document
    createdAt
    personType
    digitalAccount {
      id
      name
      status
    }
    address {
      city
      state
      number
      street
      zipcode
      complement
      neighborhood
    }
    legalRepresentatives {
      name
      email
      phone
      document
      identificationNumber
      bank {
        code
        type
        account
        agency
      }
      address {
        city
        state
        number
        street
        zipcode
        complement
        neighborhood
      }
      files {
        sendAt
        status
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
      }
    }
    files {
      sendAt
      status
      type
      file {
        fileName
        fileUrl
        key
        storageService
      }
    }
    bank {
      code
      type
      account
      agency
    }
  }
}
    `;

/**
 * __useCustomerGetQuery__
 *
 * To run a query within a React component, call `useCustomerGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerGetQuery(baseOptions: Apollo.QueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables> & ({ variables: CustomerGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerGetQuery, CustomerGetQueryVariables>(CustomerGetDocument, options);
      }
export function useCustomerGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerGetQuery, CustomerGetQueryVariables>(CustomerGetDocument, options);
        }
// @ts-ignore
export function useCustomerGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerGetQuery, CustomerGetQueryVariables>;
export function useCustomerGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables>): Apollo.UseSuspenseQueryResult<CustomerGetQuery | undefined, CustomerGetQueryVariables>;
export function useCustomerGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerGetQuery, CustomerGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerGetQuery, CustomerGetQueryVariables>(CustomerGetDocument, options);
        }
export type CustomerGetQueryHookResult = ReturnType<typeof useCustomerGetQuery>;
export type CustomerGetLazyQueryHookResult = ReturnType<typeof useCustomerGetLazyQuery>;
export type CustomerGetSuspenseQueryHookResult = ReturnType<typeof useCustomerGetSuspenseQuery>;
export type CustomerGetQueryResult = Apollo.QueryResult<CustomerGetQuery, CustomerGetQueryVariables>;
export const DealershipGetDocument = gql`
    query DealershipGet($id: String!) {
  dealershipGet(id: $id) {
    _id
    needLoginDealership
    name
    distributorId
    locationUf
    maxDiscountPercentagePf
    maxDiscountPercentagePj
    available
    resolutionAneel {
      linkUrl
      modality
      resolutionHomologed
      validity
    }
    resolutionClasses {
      class
      cofinsPercentage
      fcp
      icmsPercentage
      pisPercentage
      teValueCents
      tusdValueCents
      wireBCalculationBaseValueCents
    }
    minimumExceptionValue {
      value
      allowException
    }
    partnerBenefitToCustomer {
      customerPFDiscountMax
      customerPFDiscountMin
      customerPJDiscountMax
      customerPJDiscountMin
      customerPFDiscountSuggested
      customerPJDiscountSuggested
    }
  }
}
    `;

/**
 * __useDealershipGetQuery__
 *
 * To run a query within a React component, call `useDealershipGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealershipGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealershipGetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDealershipGetQuery(baseOptions: Apollo.QueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables> & ({ variables: DealershipGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealershipGetQuery, DealershipGetQueryVariables>(DealershipGetDocument, options);
      }
export function useDealershipGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealershipGetQuery, DealershipGetQueryVariables>(DealershipGetDocument, options);
        }
// @ts-ignore
export function useDealershipGetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables>): Apollo.UseSuspenseQueryResult<DealershipGetQuery, DealershipGetQueryVariables>;
export function useDealershipGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables>): Apollo.UseSuspenseQueryResult<DealershipGetQuery | undefined, DealershipGetQueryVariables>;
export function useDealershipGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealershipGetQuery, DealershipGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DealershipGetQuery, DealershipGetQueryVariables>(DealershipGetDocument, options);
        }
export type DealershipGetQueryHookResult = ReturnType<typeof useDealershipGetQuery>;
export type DealershipGetLazyQueryHookResult = ReturnType<typeof useDealershipGetLazyQuery>;
export type DealershipGetSuspenseQueryHookResult = ReturnType<typeof useDealershipGetSuspenseQuery>;
export type DealershipGetQueryResult = Apollo.QueryResult<DealershipGetQuery, DealershipGetQueryVariables>;
export const DealershipListDocument = gql`
    query DealershipList($params: DealershipListDTO) {
  dealershipList(params: $params) {
    meta {
      currentPage
      documentCounts
      pageSize
    }
    data {
      _id
      name
      locationUf
      maxDiscountPercentagePf
      maxDiscountPercentagePj
      partnerBenefitToCustomer {
        customerPFDiscountMax
        customerPFDiscountMin
        customerPFDiscountSuggested
        customerPJDiscountMax
        customerPJDiscountMin
        customerPJDiscountSuggested
      }
      available
      minimumExceptionValue {
        value
        allowException
      }
    }
  }
}
    `;

/**
 * __useDealershipListQuery__
 *
 * To run a query within a React component, call `useDealershipListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDealershipListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDealershipListQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useDealershipListQuery(baseOptions?: Apollo.QueryHookOptions<DealershipListQuery, DealershipListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DealershipListQuery, DealershipListQueryVariables>(DealershipListDocument, options);
      }
export function useDealershipListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DealershipListQuery, DealershipListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DealershipListQuery, DealershipListQueryVariables>(DealershipListDocument, options);
        }
// @ts-ignore
export function useDealershipListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DealershipListQuery, DealershipListQueryVariables>): Apollo.UseSuspenseQueryResult<DealershipListQuery, DealershipListQueryVariables>;
export function useDealershipListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealershipListQuery, DealershipListQueryVariables>): Apollo.UseSuspenseQueryResult<DealershipListQuery | undefined, DealershipListQueryVariables>;
export function useDealershipListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DealershipListQuery, DealershipListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DealershipListQuery, DealershipListQueryVariables>(DealershipListDocument, options);
        }
export type DealershipListQueryHookResult = ReturnType<typeof useDealershipListQuery>;
export type DealershipListLazyQueryHookResult = ReturnType<typeof useDealershipListLazyQuery>;
export type DealershipListSuspenseQueryHookResult = ReturnType<typeof useDealershipListSuspenseQuery>;
export type DealershipListQueryResult = Apollo.QueryResult<DealershipListQuery, DealershipListQueryVariables>;
export const GetCommissionsWithMetricsDocument = gql`
    query GetCommissionsWithMetrics($params: CommissionPaginateArgs, $metricParams: CommissionMetricsArgs) {
  getCommissions(params: $params) {
    data {
      _id
      createdAt
      dueDate
      status
      valueCents
      indicationRef {
        salesman {
          id
          name
        }
      }
    }
    meta {
      currentPage
      documentCounts
      pageSize
    }
  }
  getCommissionMetrics(params: $metricParams) {
    expectedRevenueCents
    receivableRevenueCents
  }
}
    `;

/**
 * __useGetCommissionsWithMetricsQuery__
 *
 * To run a query within a React component, call `useGetCommissionsWithMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionsWithMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionsWithMetricsQuery({
 *   variables: {
 *      params: // value for 'params'
 *      metricParams: // value for 'metricParams'
 *   },
 * });
 */
export function useGetCommissionsWithMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>(GetCommissionsWithMetricsDocument, options);
      }
export function useGetCommissionsWithMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>(GetCommissionsWithMetricsDocument, options);
        }
// @ts-ignore
export function useGetCommissionsWithMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>;
export function useGetCommissionsWithMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionsWithMetricsQuery | undefined, GetCommissionsWithMetricsQueryVariables>;
export function useGetCommissionsWithMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>(GetCommissionsWithMetricsDocument, options);
        }
export type GetCommissionsWithMetricsQueryHookResult = ReturnType<typeof useGetCommissionsWithMetricsQuery>;
export type GetCommissionsWithMetricsLazyQueryHookResult = ReturnType<typeof useGetCommissionsWithMetricsLazyQuery>;
export type GetCommissionsWithMetricsSuspenseQueryHookResult = ReturnType<typeof useGetCommissionsWithMetricsSuspenseQuery>;
export type GetCommissionsWithMetricsQueryResult = Apollo.QueryResult<GetCommissionsWithMetricsQuery, GetCommissionsWithMetricsQueryVariables>;
export const GetCommissionsDocument = gql`
    query GetCommissions($params: CommissionPaginateArgs) {
  getCommissions(params: $params) {
    data {
      _id
      createdAt
      dueDate
      status
      valueCents
      indicationRef {
        salesman {
          id
          name
        }
      }
    }
    meta {
      currentPage
      documentCounts
      pageSize
    }
  }
}
    `;

/**
 * __useGetCommissionsQuery__
 *
 * To run a query within a React component, call `useGetCommissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCommissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionsQuery, GetCommissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionsQuery, GetCommissionsQueryVariables>(GetCommissionsDocument, options);
      }
export function useGetCommissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionsQuery, GetCommissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionsQuery, GetCommissionsQueryVariables>(GetCommissionsDocument, options);
        }
// @ts-ignore
export function useGetCommissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionsQuery, GetCommissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionsQuery, GetCommissionsQueryVariables>;
export function useGetCommissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionsQuery, GetCommissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionsQuery | undefined, GetCommissionsQueryVariables>;
export function useGetCommissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionsQuery, GetCommissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionsQuery, GetCommissionsQueryVariables>(GetCommissionsDocument, options);
        }
export type GetCommissionsQueryHookResult = ReturnType<typeof useGetCommissionsQuery>;
export type GetCommissionsLazyQueryHookResult = ReturnType<typeof useGetCommissionsLazyQuery>;
export type GetCommissionsSuspenseQueryHookResult = ReturnType<typeof useGetCommissionsSuspenseQuery>;
export type GetCommissionsQueryResult = Apollo.QueryResult<GetCommissionsQuery, GetCommissionsQueryVariables>;
export const GetCommissionMetricsDocument = gql`
    query GetCommissionMetrics($params: CommissionMetricsArgs) {
  getCommissionMetrics(params: $params) {
    expectedRevenueCents
    receivableRevenueCents
  }
}
    `;

/**
 * __useGetCommissionMetricsQuery__
 *
 * To run a query within a React component, call `useGetCommissionMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionMetricsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCommissionMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>(GetCommissionMetricsDocument, options);
      }
export function useGetCommissionMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>(GetCommissionMetricsDocument, options);
        }
// @ts-ignore
export function useGetCommissionMetricsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>;
export function useGetCommissionMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionMetricsQuery | undefined, GetCommissionMetricsQueryVariables>;
export function useGetCommissionMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>(GetCommissionMetricsDocument, options);
        }
export type GetCommissionMetricsQueryHookResult = ReturnType<typeof useGetCommissionMetricsQuery>;
export type GetCommissionMetricsLazyQueryHookResult = ReturnType<typeof useGetCommissionMetricsLazyQuery>;
export type GetCommissionMetricsSuspenseQueryHookResult = ReturnType<typeof useGetCommissionMetricsSuspenseQuery>;
export type GetCommissionMetricsQueryResult = Apollo.QueryResult<GetCommissionMetricsQuery, GetCommissionMetricsQueryVariables>;
export const GetIndicationProposalByIdDocument = gql`
    query GetIndicationProposalById($id: String!) {
  getIndicationRelatedEntitiesById(id: $id) {
    contract {
      _id
      isDocumentsAudited
      cancellationRequestedAt
      cancellationRequestedBy
      previousGenerationBalance
      billingType
      previousGenerationBalance
      consortiumId
      contractType
      contractedSharePercent
      createdAt
      customerId
      customerRef {
        document
        name
        personType
        email
        phone
        legalRepresentatives {
          document
          email
          name
          document
          phone
          files {
            acceptedAt
            analyzedBy
            file {
              fileName
              fileUrl
              key
              storageService
            }
            rejectedAt
            sentAt
            status
            type
          }
          pendencies {
            city {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            complement {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            document {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            email {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            name {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            neighborhood {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            number {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            phone {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            state {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            zipCode {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
          }
        }
        pendencies {
          city {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          email {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          name {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          neighborhood {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          number {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          phone {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          state {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          street {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          zipCode {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          uf {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
        }
      }
      fidelityMonths
      gracePeriodMonths
      reward {
        history {
          description
        }
        type
        percent
      }
      participationKwh
      powerPlantId
      powerGeneratorId
      proposalId
      signDate
      specialDiscount {
        discountPercent
        month
      }
      status
      termOfAdhesion {
        active
        canceledAt
        canceledBy
        createdAt
        createdBy
        file {
          fileName
          fileUrl
          key
          storageService
        }
        signatureLink
        signedAt
        signerEmail
        status
      }
      termOfManagement {
        active
        canceledAt
        canceledBy
        createdAt
        createdBy
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
        origin
        replaced
        signatureLink
        signedAt
        signerEmail
        status
        uuid
        refusedReason
      }
      contractType
      updatedAt
      validityMonths
      energyBillInfo {
        AmountCents
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        avarageConsumption
        avarageBillAmountCents
        name
        clientNumber
        consumerClassification
        dealershipId
        dealershipName
        distributionTaxes
        energyBillFile {
          fileName
          fileUrl
        }
        energyTaxes
        installationNumber
        invoiceDueDay
        tariffClassification
        tension
        tusdValue
      }
      dealershipLogin {
        extraPassword
        login
        password
      }
      activatedAt
      activatedBy
      canceledReason
      monthlyConsumption {
        january
        february
        march
        april
        may
        june
        july
        august
        september
        october
        november
        december
      }
      indicationRef {
        condition {
          anticipated {
            additionalCommissionPercentage
            baseCommissionPercentage
            commissionAmountPercentage
            commissionExceptionGroupId
            commissionedInvoices
          }
          customerDiscountMax
          customerDiscountMin
          customerDiscountOffered
          customerDiscountSuggested
          dealershipId
          dealershipName
          recurring {
            additionalCommissionPercentage
            baseCommissionPercentage
            commissionAmountPercentage
            alwaysCommissionedInvoices
            commissionedInvoices
          }
          uf
        }
        expired
        id
        partner {
          document
          email
          id
          name
          phone
        }
        salesman {
          id
          name
        }
        type
      }
      customerIndicationRef {
        customerId
        customerName
      }
      files {
        acceptedAt
        analyzedBy
        file {
          fileName
          fileUrl
          key
          storageService
        }
        rejectedAt
        sentAt
        status
        type
      }
    }
    proposal {
      _id
      status
      dealershipLogin {
        extraPassword
        login
        password
      }
      customerRef {
        personType
        address {
          city
          complement
          neighborhood
          number
          state
          street
          zipcode
        }
      }
      cashbackInfo {
        active
        cashbackPercentagePf
        cashbackPercentagePj
      }
      indicationRef {
        partner {
          name
        }
        salesman {
          name
        }
      }
      createdAt
      createBy {
        name
      }
      customerRef {
        name
        personType
        legalRepresentative {
          name
          document
          identificationNumber
          email
          phone
          pendencies {
            name {
              acceptedAt
              rejectedAt
              sendedAt
            }
            document {
              acceptedAt
              rejectedAt
              sendedAt
            }
            email {
              acceptedAt
              rejectedAt
              sendedAt
            }
            phone {
              acceptedAt
              rejectedAt
              sendedAt
            }
            zipcode {
              acceptedAt
              rejectedAt
              sendedAt
            }
            number {
              acceptedAt
              rejectedAt
              sendedAt
            }
            complement {
              acceptedAt
              rejectedAt
              sendedAt
            }
            neighborhood {
              acceptedAt
              rejectedAt
              sendedAt
            }
            city {
              acceptedAt
              rejectedAt
              sendedAt
            }
            state {
              acceptedAt
              rejectedAt
              sendedAt
            }
          }
          address {
            city
            complement
            neighborhood
            number
            state
            street
            zipcode
          }
          files {
            acceptedAt
            rejectedAt
            analysedBy
            sendAt
            status
            type
            file {
              fileName
              fileUrl
            }
          }
        }
        pendencies {
          dealershipName {
            acceptedAt
            rejectedAt
            sendedAt
          }
          averageEnergyBillValue {
            acceptedAt
            rejectedAt
            sendedAt
          }
          city {
            acceptedAt
            rejectedAt
            sendedAt
          }
          document {
            acceptedAt
            rejectedAt
            sendedAt
          }
          email {
            acceptedAt
            rejectedAt
            sendedAt
          }
          name {
            acceptedAt
            rejectedAt
            sendedAt
          }
          neighborhood {
            acceptedAt
            rejectedAt
            sendedAt
          }
          number {
            acceptedAt
            rejectedAt
            sendedAt
          }
          phone {
            acceptedAt
            rejectedAt
            sendedAt
          }
          state {
            acceptedAt
            rejectedAt
            sendedAt
          }
          street {
            acceptedAt
            rejectedAt
            sendedAt
          }
          uf {
            acceptedAt
            rejectedAt
            sendedAt
          }
          zipcode {
            acceptedAt
            rejectedAt
            sendedAt
          }
        }
        legalRepresentative {
          name
          document
          identificationNumber
          email
          phone
          address {
            city
            complement
            neighborhood
            number
            state
            street
            zipcode
          }
          files {
            acceptedAt
            analysedBy
            file {
              fileName
              fileUrl
            }
            rejectedAt
            sendAt
            status
            type
          }
        }
      }
      cashbackInfo {
        active
        cashbackPercentagePf
        cashbackPercentagePj
      }
      files {
        acceptedAt
        analysedBy
        file {
          fileName
          fileUrl
        }
        rejectedAt
        sendAt
        status
        type
      }
    }
  }
}
    `;

/**
 * __useGetIndicationProposalByIdQuery__
 *
 * To run a query within a React component, call `useGetIndicationProposalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicationProposalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicationProposalByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIndicationProposalByIdQuery(baseOptions: Apollo.QueryHookOptions<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables> & ({ variables: GetIndicationProposalByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>(GetIndicationProposalByIdDocument, options);
      }
export function useGetIndicationProposalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>(GetIndicationProposalByIdDocument, options);
        }
// @ts-ignore
export function useGetIndicationProposalByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>;
export function useGetIndicationProposalByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndicationProposalByIdQuery | undefined, GetIndicationProposalByIdQueryVariables>;
export function useGetIndicationProposalByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>(GetIndicationProposalByIdDocument, options);
        }
export type GetIndicationProposalByIdQueryHookResult = ReturnType<typeof useGetIndicationProposalByIdQuery>;
export type GetIndicationProposalByIdLazyQueryHookResult = ReturnType<typeof useGetIndicationProposalByIdLazyQuery>;
export type GetIndicationProposalByIdSuspenseQueryHookResult = ReturnType<typeof useGetIndicationProposalByIdSuspenseQuery>;
export type GetIndicationProposalByIdQueryResult = Apollo.QueryResult<GetIndicationProposalByIdQuery, GetIndicationProposalByIdQueryVariables>;
export const GetIndicationsDocument = gql`
    query GetIndications($params: IndicationPaginateArgs) {
  getIndications(params: $params) {
    data {
      _id
      status
      averageEnergyBillValueCents
      origin
      createdAt
      updatedAt
      metadata {
        preProposalFileKey
      }
      salesmanRef {
        name
      }
      customerRef {
        name
      }
      errorMessage
    }
    meta {
      currentPage
      documentCounts
      pageSize
    }
  }
}
    `;

/**
 * __useGetIndicationsQuery__
 *
 * To run a query within a React component, call `useGetIndicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicationsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetIndicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIndicationsQuery, GetIndicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndicationsQuery, GetIndicationsQueryVariables>(GetIndicationsDocument, options);
      }
export function useGetIndicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndicationsQuery, GetIndicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndicationsQuery, GetIndicationsQueryVariables>(GetIndicationsDocument, options);
        }
// @ts-ignore
export function useGetIndicationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndicationsQuery, GetIndicationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndicationsQuery, GetIndicationsQueryVariables>;
export function useGetIndicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndicationsQuery, GetIndicationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndicationsQuery | undefined, GetIndicationsQueryVariables>;
export function useGetIndicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndicationsQuery, GetIndicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndicationsQuery, GetIndicationsQueryVariables>(GetIndicationsDocument, options);
        }
export type GetIndicationsQueryHookResult = ReturnType<typeof useGetIndicationsQuery>;
export type GetIndicationsLazyQueryHookResult = ReturnType<typeof useGetIndicationsLazyQuery>;
export type GetIndicationsSuspenseQueryHookResult = ReturnType<typeof useGetIndicationsSuspenseQuery>;
export type GetIndicationsQueryResult = Apollo.QueryResult<GetIndicationsQuery, GetIndicationsQueryVariables>;
export const GetIndicationsCsvDocument = gql`
    query GetIndicationsCsv($params: IndicationPaginateArgs) {
  getIndications(params: $params) {
    data {
      status
      averageEnergyBillValueCents
      origin
      createdAt
      updatedAt
      errorMessage
      condition {
        uf
        dealershipName
        anticipated {
          additionalCommissionPercentage
          baseCommissionPercentage
          commissionAmountPercentage
          commissionExceptionGroupId
          commissionedInvoices
        }
        anticipated {
          additionalCommissionPercentage
          baseCommissionPercentage
          commissionAmountPercentage
          commissionExceptionGroupId
          commissionedInvoices
        }
      }
      salesmanRef {
        name
      }
      customerRef {
        name
      }
    }
    meta {
      currentPage
      documentCounts
      pageSize
    }
  }
}
    `;

/**
 * __useGetIndicationsCsvQuery__
 *
 * To run a query within a React component, call `useGetIndicationsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndicationsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndicationsCsvQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetIndicationsCsvQuery(baseOptions?: Apollo.QueryHookOptions<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>(GetIndicationsCsvDocument, options);
      }
export function useGetIndicationsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>(GetIndicationsCsvDocument, options);
        }
// @ts-ignore
export function useGetIndicationsCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>;
export function useGetIndicationsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetIndicationsCsvQuery | undefined, GetIndicationsCsvQueryVariables>;
export function useGetIndicationsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>(GetIndicationsCsvDocument, options);
        }
export type GetIndicationsCsvQueryHookResult = ReturnType<typeof useGetIndicationsCsvQuery>;
export type GetIndicationsCsvLazyQueryHookResult = ReturnType<typeof useGetIndicationsCsvLazyQuery>;
export type GetIndicationsCsvSuspenseQueryHookResult = ReturnType<typeof useGetIndicationsCsvSuspenseQuery>;
export type GetIndicationsCsvQueryResult = Apollo.QueryResult<GetIndicationsCsvQuery, GetIndicationsCsvQueryVariables>;
export const GetPartnerAreaDashboardDocument = gql`
    query GetPartnerAreaDashboard {
  getPartnerAreaDashboard {
    embedToken
    embedUrl
    reportId
  }
}
    `;

/**
 * __useGetPartnerAreaDashboardQuery__
 *
 * To run a query within a React component, call `useGetPartnerAreaDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerAreaDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerAreaDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPartnerAreaDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>(GetPartnerAreaDashboardDocument, options);
      }
export function useGetPartnerAreaDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>(GetPartnerAreaDashboardDocument, options);
        }
// @ts-ignore
export function useGetPartnerAreaDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>;
export function useGetPartnerAreaDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartnerAreaDashboardQuery | undefined, GetPartnerAreaDashboardQueryVariables>;
export function useGetPartnerAreaDashboardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>(GetPartnerAreaDashboardDocument, options);
        }
export type GetPartnerAreaDashboardQueryHookResult = ReturnType<typeof useGetPartnerAreaDashboardQuery>;
export type GetPartnerAreaDashboardLazyQueryHookResult = ReturnType<typeof useGetPartnerAreaDashboardLazyQuery>;
export type GetPartnerAreaDashboardSuspenseQueryHookResult = ReturnType<typeof useGetPartnerAreaDashboardSuspenseQuery>;
export type GetPartnerAreaDashboardQueryResult = Apollo.QueryResult<GetPartnerAreaDashboardQuery, GetPartnerAreaDashboardQueryVariables>;
export const GetProposalAndIndicationByIdDocument = gql`
    query GetProposalAndIndicationById($id: String!) {
  getIndicationById(id: $id) {
    _id
    status
    averageEnergyBillValueCents
    condition {
      uf
      dealershipId
      dealershipName
      customerDiscountOffered
      recurring {
        additionalCommissionPercentage
        alwaysCommissionedInvoices
        baseCommissionPercentage
        commissionAmountPercentage
        commissionedInvoices
      }
      anticipated {
        additionalCommissionPercentage
        baseCommissionPercentage
        commissionAmountPercentage
        commissionExceptionGroupId
        commissionedInvoices
      }
    }
    customerRef {
      name
      document
      email
      phone
      address {
        city
        complement
        neighborhood
        number
        state
        street
        zipcode
      }
    }
  }
  getIndicationRelatedEntitiesById(id: $id) {
    contract {
      _id
      isDocumentsAudited
      cancellationRequestedAt
      cancellationRequestedBy
      previousGenerationBalance
      billingType
      previousGenerationBalance
      consortiumId
      contractType
      contractedSharePercent
      createdAt
      customerId
      customerRef {
        document
        name
        personType
        email
        phone
        legalRepresentatives {
          document
          email
          name
          document
          phone
          files {
            acceptedAt
            analyzedBy
            file {
              fileName
              fileUrl
              key
              storageService
            }
            rejectedAt
            sentAt
            status
            type
          }
          pendencies {
            city {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            complement {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            document {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            email {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            name {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            neighborhood {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            number {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            phone {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            state {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
            zipCode {
              acceptedAt
              analyzedBy
              rejectedAt
              sentAt
            }
          }
        }
        pendencies {
          city {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          email {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          name {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          neighborhood {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          number {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          phone {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          state {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          street {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          zipCode {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
          uf {
            acceptedAt
            analyzedBy
            rejectedAt
            sentAt
          }
        }
      }
      fidelityMonths
      gracePeriodMonths
      reward {
        history {
          description
        }
        type
        percent
      }
      participationKwh
      powerPlantId
      powerGeneratorId
      proposalId
      signDate
      specialDiscount {
        discountPercent
        month
      }
      status
      termOfAdhesion {
        active
        canceledAt
        canceledBy
        createdAt
        createdBy
        file {
          fileName
          fileUrl
          key
          storageService
        }
        signatureLink
        signedAt
        signerEmail
        status
      }
      termOfManagement {
        active
        canceledAt
        canceledBy
        createdAt
        createdBy
        type
        file {
          fileName
          fileUrl
          key
          storageService
        }
        origin
        replaced
        signatureLink
        signedAt
        signerEmail
        status
        uuid
        refusedReason
      }
      contractType
      updatedAt
      validityMonths
      energyBillInfo {
        AmountCents
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
        avarageConsumption
        avarageBillAmountCents
        name
        clientNumber
        consumerClassification
        dealershipId
        dealershipName
        distributionTaxes
        energyBillFile {
          fileName
          fileUrl
        }
        energyTaxes
        installationNumber
        invoiceDueDay
        tariffClassification
        tension
        tusdValue
      }
      dealershipLogin {
        extraPassword
        login
        password
      }
      activatedAt
      activatedBy
      canceledReason
      monthlyConsumption {
        january
        february
        march
        april
        may
        june
        july
        august
        september
        october
        november
        december
      }
      indicationRef {
        condition {
          anticipated {
            additionalCommissionPercentage
            baseCommissionPercentage
            commissionAmountPercentage
            commissionExceptionGroupId
            commissionedInvoices
          }
          customerDiscountMax
          customerDiscountMin
          customerDiscountOffered
          customerDiscountSuggested
          dealershipId
          dealershipName
          recurring {
            additionalCommissionPercentage
            baseCommissionPercentage
            commissionAmountPercentage
            alwaysCommissionedInvoices
            commissionedInvoices
          }
          uf
        }
        expired
        id
        partner {
          document
          email
          id
          name
          phone
        }
        salesman {
          id
          name
        }
        type
      }
      customerIndicationRef {
        customerId
        customerName
      }
      files {
        acceptedAt
        analyzedBy
        file {
          fileName
          fileUrl
          key
          storageService
        }
        rejectedAt
        sentAt
        status
        type
      }
    }
    proposal {
      _id
      sellerRef {
        changeAt
        changeBy
        email
        history {
          changeAt
          changeBy
          email
          id
          name
          user {
            email
            id
            name
          }
        }
        id
        name
        user {
          email
          id
          name
        }
      }
      supportRef {
        changeAt
        changeBy
        email
        history {
          changeAt
          changeBy
          email
          id
          name
          user {
            email
            id
            name
          }
        }
        id
        name
        user {
          email
          id
          name
        }
      }
      consortiumId
      contractId
      lossReason
      fidelityMonths
      dealershipLogin {
        extraPassword
        login
        password
      }
      rejectedInfo {
        reason
        rejectedAt
        rejectedBy {
          id
          name
        }
      }
      salesFunnel {
        stage
        changedBy
        date
        history {
          changedBy
          date
          stage
          user
        }
        user
      }
      indicationRef {
        condition {
          anticipated {
            additionalCommissionPercentage
            baseCommissionPercentage
            commissionAmountPercentage
            commissionExceptionGroupId
            commissionedInvoices
          }
          customerDiscountMax
          customerDiscountMin
          customerDiscountOffered
          customerDiscountSuggested
          dealershipId
          dealershipName
          recurring {
            additionalCommissionPercentage
            baseCommissionPercentage
            commissionAmountPercentage
            alwaysCommissionedInvoices
            commissionedInvoices
          }
          uf
        }
        salesman {
          id
          name
        }
        partner {
          name
        }
      }
      cashbackInfo {
        active
        cashbackPercentagePf
        cashbackPercentagePj
      }
      hasAnalysis
      notes {
        analystId
        createdAt
        text
        analystName
      }
      preProposals {
        file {
          fileName
          fileUrl
          key
        }
        dealershipName
        dealershipId
      }
      termOfAdhesion {
        _id
        name
        signedAt
        signedDocumentUrl
        signerUrl
        refusedReason
        approveManual
        manualOrAutomatic
        status
        signers {
          email
          id
          name
          requestSignId
        }
      }
      businessProposals {
        acceptedAt
        businessProposalDespertaNumber
        businessProposalPartnerNumber
        contractOfAdhesion {
          fileName
          fileUrl
          key
        }
        createdAt
        file {
          fileName
          fileUrl
          key
        }
        invoiceValueWithPartner
        monthlyEconomyPercent
        observation
        powerPlantId
        powerGeneratorId
        rejectedAt
        rejectedBy
        updatedAt
        tariffGreenFlag
        tariffRedFlagP1
        tariffRedFlagP2
        tariffPurpleFlag
        tariffYellowFlag
        status
      }
      files {
        status
        file {
          fileName
          fileUrl
          key
        }
        type
        sendAt
        analysedBy
        rejectedAt
        acceptedAt
      }
      customerRef {
        hasPendencies
        pendencies {
          averageEnergyBillValue {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          city {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          dealershipName {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          document {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          email {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          name {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          neighborhood {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          number {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          phone {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          state {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          street {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          uf {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
          zipcode {
            rejectedAt
            solvedAt
            acceptedAt
            analysedBy
            sendedAt
          }
        }
        averageEnergyBillValue
        uf
        dealershipId
        dealershipName
        name
        document
        personType
        email
        phone
        legalRepresentative {
          pendencies {
            city {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            complement {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            zipcode {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            document {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            email {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            name {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            neighborhood {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            number {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            phone {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
            state {
              rejectedAt
              solvedAt
              acceptedAt
              analysedBy
              sendedAt
            }
          }
          address {
            city
            complement
            country
            neighborhood
            number
            state
            street
            zipcode
          }
          identificationNumber
          name
          document
          email
          phone
          files {
            acceptedAt
            analysedBy
            file {
              fileName
              fileUrl
              key
            }
            rejectedAt
            sendAt
            status
            type
          }
        }
        address {
          city
          complement
          country
          neighborhood
          number
          state
          street
          zipcode
        }
      }
      hash
      origin
      status
      createBy {
        id
        name
        email
        phone
        type
      }
      updatedAt
      createdAt
      energyBillInfo {
        AmountCents
        consumerClassification
        avarageConsumption
        clientNumber
        dealershipId
        dealershipName
        distributionTaxes
        energyBillFile {
          file {
            fileName
            fileUrl
            key
          }
          status
          type
        }
        energyTaxes
        installationNumber
        invoiceDueDay
        tariffClassification
        tension
        tusdValue
        address {
          city
          complement
          neighborhood
          number
          state
          street
          zipcode
        }
      }
      monthlyConsumption {
        january
        february
        march
        april
        may
        june
        july
        august
        september
        october
        november
        december
      }
      customerIndicationRef {
        customerId
        customerName
      }
    }
  }
}
    `;

/**
 * __useGetProposalAndIndicationByIdQuery__
 *
 * To run a query within a React component, call `useGetProposalAndIndicationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalAndIndicationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalAndIndicationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProposalAndIndicationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables> & ({ variables: GetProposalAndIndicationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>(GetProposalAndIndicationByIdDocument, options);
      }
export function useGetProposalAndIndicationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>(GetProposalAndIndicationByIdDocument, options);
        }
// @ts-ignore
export function useGetProposalAndIndicationByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>;
export function useGetProposalAndIndicationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetProposalAndIndicationByIdQuery | undefined, GetProposalAndIndicationByIdQueryVariables>;
export function useGetProposalAndIndicationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>(GetProposalAndIndicationByIdDocument, options);
        }
export type GetProposalAndIndicationByIdQueryHookResult = ReturnType<typeof useGetProposalAndIndicationByIdQuery>;
export type GetProposalAndIndicationByIdLazyQueryHookResult = ReturnType<typeof useGetProposalAndIndicationByIdLazyQuery>;
export type GetProposalAndIndicationByIdSuspenseQueryHookResult = ReturnType<typeof useGetProposalAndIndicationByIdSuspenseQuery>;
export type GetProposalAndIndicationByIdQueryResult = Apollo.QueryResult<GetProposalAndIndicationByIdQuery, GetProposalAndIndicationByIdQueryVariables>;
export const GetCommissionsCsvDocument = gql`
    query GetCommissionsCsv($params: CommissionPaginateArgs) {
  getCommissions(params: $params) {
    data {
      _id
      createdAt
      dueDate
      updatedAt
      status
      valueCents
      indicationRef {
        condition {
          uf
          dealershipName
          recurring {
            additionalCommissionPercentage
            alwaysCommissionedInvoices
            baseCommissionPercentage
            commissionAmountPercentage
            commissionedInvoices
          }
          anticipated {
            additionalCommissionPercentage
            baseCommissionPercentage
            commissionAmountPercentage
            commissionExceptionGroupId
            commissionedInvoices
          }
        }
        salesman {
          id
          name
        }
      }
    }
    meta {
      currentPage
      documentCounts
      pageSize
    }
  }
}
    `;

/**
 * __useGetCommissionsCsvQuery__
 *
 * To run a query within a React component, call `useGetCommissionsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionsCsvQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCommissionsCsvQuery(baseOptions?: Apollo.QueryHookOptions<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>(GetCommissionsCsvDocument, options);
      }
export function useGetCommissionsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>(GetCommissionsCsvDocument, options);
        }
// @ts-ignore
export function useGetCommissionsCsvSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>;
export function useGetCommissionsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionsCsvQuery | undefined, GetCommissionsCsvQueryVariables>;
export function useGetCommissionsCsvSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>(GetCommissionsCsvDocument, options);
        }
export type GetCommissionsCsvQueryHookResult = ReturnType<typeof useGetCommissionsCsvQuery>;
export type GetCommissionsCsvLazyQueryHookResult = ReturnType<typeof useGetCommissionsCsvLazyQuery>;
export type GetCommissionsCsvSuspenseQueryHookResult = ReturnType<typeof useGetCommissionsCsvSuspenseQuery>;
export type GetCommissionsCsvQueryResult = Apollo.QueryResult<GetCommissionsCsvQuery, GetCommissionsCsvQueryVariables>;
export const HomePerformancesDocument = gql`
    query HomePerformances($paramsIndications: IndicationPaginateArgs, $paramsComissions: CommissionMetricsArgs) {
  getIndicationMetrics(params: $paramsIndications) {
    indicationCount
    signedContract
  }
  getCommissionMetrics(params: $paramsComissions) {
    expectedRevenueCents
    receivableRevenueCents
  }
}
    `;

/**
 * __useHomePerformancesQuery__
 *
 * To run a query within a React component, call `useHomePerformancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePerformancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePerformancesQuery({
 *   variables: {
 *      paramsIndications: // value for 'paramsIndications'
 *      paramsComissions: // value for 'paramsComissions'
 *   },
 * });
 */
export function useHomePerformancesQuery(baseOptions?: Apollo.QueryHookOptions<HomePerformancesQuery, HomePerformancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePerformancesQuery, HomePerformancesQueryVariables>(HomePerformancesDocument, options);
      }
export function useHomePerformancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePerformancesQuery, HomePerformancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePerformancesQuery, HomePerformancesQueryVariables>(HomePerformancesDocument, options);
        }
// @ts-ignore
export function useHomePerformancesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HomePerformancesQuery, HomePerformancesQueryVariables>): Apollo.UseSuspenseQueryResult<HomePerformancesQuery, HomePerformancesQueryVariables>;
export function useHomePerformancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePerformancesQuery, HomePerformancesQueryVariables>): Apollo.UseSuspenseQueryResult<HomePerformancesQuery | undefined, HomePerformancesQueryVariables>;
export function useHomePerformancesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePerformancesQuery, HomePerformancesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePerformancesQuery, HomePerformancesQueryVariables>(HomePerformancesDocument, options);
        }
export type HomePerformancesQueryHookResult = ReturnType<typeof useHomePerformancesQuery>;
export type HomePerformancesLazyQueryHookResult = ReturnType<typeof useHomePerformancesLazyQuery>;
export type HomePerformancesSuspenseQueryHookResult = ReturnType<typeof useHomePerformancesSuspenseQuery>;
export type HomePerformancesQueryResult = Apollo.QueryResult<HomePerformancesQuery, HomePerformancesQueryVariables>;
export const PaginateDealershipConditionsDocument = gql`
    query PaginateDealershipConditions($params: PartnerDealershipConditionsListDTO) {
  paginateDealershipConditions(params: $params) {
    data {
      ceilingReferencePercentage
      customerPFDiscountMax
      customerPFDiscountMin
      customerPFDiscountOffered
      customerPFDiscountSuggested
      customerPJDiscountMax
      customerPJDiscountMin
      customerPJDiscountOffered
      customerPJDiscountSuggested
      dealershipId
      dealershipName
      uf
    }
    meta {
      currentPage
      documentCounts
      pageSize
    }
  }
}
    `;

/**
 * __usePaginateDealershipConditionsQuery__
 *
 * To run a query within a React component, call `usePaginateDealershipConditionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginateDealershipConditionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginateDealershipConditionsQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function usePaginateDealershipConditionsQuery(baseOptions?: Apollo.QueryHookOptions<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>(PaginateDealershipConditionsDocument, options);
      }
export function usePaginateDealershipConditionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>(PaginateDealershipConditionsDocument, options);
        }
// @ts-ignore
export function usePaginateDealershipConditionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>): Apollo.UseSuspenseQueryResult<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>;
export function usePaginateDealershipConditionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>): Apollo.UseSuspenseQueryResult<PaginateDealershipConditionsQuery | undefined, PaginateDealershipConditionsQueryVariables>;
export function usePaginateDealershipConditionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>(PaginateDealershipConditionsDocument, options);
        }
export type PaginateDealershipConditionsQueryHookResult = ReturnType<typeof usePaginateDealershipConditionsQuery>;
export type PaginateDealershipConditionsLazyQueryHookResult = ReturnType<typeof usePaginateDealershipConditionsLazyQuery>;
export type PaginateDealershipConditionsSuspenseQueryHookResult = ReturnType<typeof usePaginateDealershipConditionsSuspenseQuery>;
export type PaginateDealershipConditionsQueryResult = Apollo.QueryResult<PaginateDealershipConditionsQuery, PaginateDealershipConditionsQueryVariables>;